import * as t from "react";
import xe, { useState as E, useEffect as D, useRef as K, createContext as Jr, useCallback as le, useId as Gn, useLayoutEffect as Xr, useMemo as Bn, useContext as Un } from "react";
import { CalciteAction as Qr, CalciteFlow as Wn, CalciteFlowItem as Rr, CalciteSlider as gt, CalciteInputNumber as jt, CalciteButton as Yn, CalcitePopover as Kn, CalciteColorPicker as en, CalciteLabel as re, CalciteSelect as $t, CalciteOption as ue, CalciteSegmentedControl as tn, CalciteSegmentedControlItem as Ke, CalciteSwitch as rn, CalciteBlock as St, CalciteNotice as Tr, CalciteAccordion as qn, CalciteAccordionItem as Jn, CalciteLoader as Xn, CalciteCardGroup as Qn, CalciteCard as ea } from "@esri/calcite-components-react";
import { useSelector as Er, useDispatch as ta } from "react-redux";
import { createSlice as Ht, createAsyncThunk as Je, combineReducers as ra } from "@reduxjs/toolkit";
import * as Ir from "@arcgis/core/intl";
import { useTranslation as Ie } from "react-i18next";
import { CalciteNavigation as na, CalciteAction as kt, CalciteNavigationLogo as aa, CalciteDropdown as oa, CalciteNavigationUser as la, CalciteDropdownGroup as ir, CalciteDropdownItem as cr, CalciteTooltip as Vr, CalciteShellPanel as sa, CalciteActionBar as ia, CalciteFlow as ca, CalciteFlowItem as ua } from "@esri/calcite-components-react/dist";
import ma from "@arcgis/core/widgets/LayerList";
import * as nn from "@arcgis/core/core/reactiveUtils";
import { useMapViewContext as Ee, MapMode as Be, basemaps as da, useMapState as pa } from "@origo/map-context";
import { Checkbox as fa, Tree as ha, Tooltip as xt, ToolbarItem as yt, Button as an, Slider as on, NumberInput as ln, Select as Lr, ColorPicker as Tt, Switch as Nr, SegmentedControl as ga, IconButton as sn, Toolbar as ya, Notice as cn, Loader as ba, TextInput as va, ListCard as Sa, Dialog as xa, Alert as un } from "@origo/origo-ui";
import _a from "@arcgis/core/widgets/BasemapGallery";
import wa from "@arcgis/core/widgets/BasemapGallery/support/LocalBasemapsSource";
import Aa from "@arcgis/core/widgets/Print";
import Ca from "@arcgis/core/widgets/Legend";
import Ea from "@arcgis/core/widgets/Sketch";
import bt from "@arcgis/core/layers/GraphicsLayer";
import La from "@arcgis/core/layers/FeatureLayer";
import { renderPreviewHTML as mn } from "@arcgis/core/symbols/support/symbolUtils";
import dn from "@arcgis/core/symbols/CIMSymbol";
import * as Ma from "@arcgis/core/geometry/operators/areaOperator";
import * as Fr from "@arcgis/core/geometry/operators/lengthOperator";
import ur from "@arcgis/core/Graphic";
import Zt from "@arcgis/core/geometry/Point";
import ja from "@arcgis/core/geometry/Polyline";
import $r from "@arcgis/core/widgets/Sketch/SketchViewModel";
import * as ka from "@arcgis/core/geometry/operators/intersectsOperator";
import Za from "@arcgis/core/views/interactive/snapping/SnappingOptions";
import Ra from "@arcgis/core/views/interactive/snapping/FeatureSnappingLayerSource";
import pn from "@arcgis/core/portal/Portal";
import Ta from "@arcgis/core/layers/Layer";
import fn from "@arcgis/core/portal/PortalGroup";
import hn from "@arcgis/core/portal/PortalItem";
import Ia from "@arcgis/core/WebMap";
import { createPortal as gn } from "react-dom";
import _t from "@arcgis/core/geometry/Point.js";
import Va from "@arcgis/core/geometry/Extent.js";
import Na from "@arcgis/core/Graphic.js";
var _r = { exports: {} }, mt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hr;
function Fa() {
  if (Hr)
    return mt;
  Hr = 1;
  var n = xe, e = Symbol.for("react.element"), a = Symbol.for("react.fragment"), l = Object.prototype.hasOwnProperty, s = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(i, p, c) {
    var h, y = {}, f = null, g = null;
    c !== void 0 && (f = "" + c), p.key !== void 0 && (f = "" + p.key), p.ref !== void 0 && (g = p.ref);
    for (h in p)
      l.call(p, h) && !u.hasOwnProperty(h) && (y[h] = p[h]);
    if (i && i.defaultProps)
      for (h in p = i.defaultProps, p)
        y[h] === void 0 && (y[h] = p[h]);
    return { $$typeof: e, type: i, key: f, ref: g, props: y, _owner: s.current };
  }
  return mt.Fragment = a, mt.jsx = d, mt.jsxs = d, mt;
}
var dt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Or;
function $a() {
  return Or || (Or = 1, process.env.NODE_ENV !== "production" && function() {
    var n = xe, e = Symbol.for("react.element"), a = Symbol.for("react.portal"), l = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), i = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), w = Symbol.iterator, S = "@@iterator";
    function b(r) {
      if (r === null || typeof r != "object")
        return null;
      var m = w && r[w] || r[S];
      return typeof m == "function" ? m : null;
    }
    var x = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function A(r) {
      {
        for (var m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), C = 1; C < m; C++)
          v[C - 1] = arguments[C];
        _("error", r, v);
      }
    }
    function _(r, m, v) {
      {
        var C = x.ReactDebugCurrentFrame, Z = C.getStackAddendum();
        Z !== "" && (m += "%s", v = v.concat([Z]));
        var V = v.map(function(j) {
          return String(j);
        });
        V.unshift("Warning: " + m), Function.prototype.apply.call(console[r], console, V);
      }
    }
    var $ = !1, G = !1, R = !1, X = !1, N = !1, T;
    T = Symbol.for("react.module.reference");
    function H(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === l || r === u || N || r === s || r === c || r === h || X || r === g || $ || G || R || typeof r == "object" && r !== null && (r.$$typeof === f || r.$$typeof === y || r.$$typeof === d || r.$$typeof === i || r.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === T || r.getModuleId !== void 0));
    }
    function M(r, m, v) {
      var C = r.displayName;
      if (C)
        return C;
      var Z = m.displayName || m.name || "";
      return Z !== "" ? v + "(" + Z + ")" : v;
    }
    function F(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && A("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case l:
          return "Fragment";
        case a:
          return "Portal";
        case u:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case i:
            var m = r;
            return F(m) + ".Consumer";
          case d:
            var v = r;
            return F(v._context) + ".Provider";
          case p:
            return M(r, r.render, "ForwardRef");
          case y:
            var C = r.displayName || null;
            return C !== null ? C : O(r.type) || "Memo";
          case f: {
            var Z = r, V = Z._payload, j = Z._init;
            try {
              return O(j(V));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, U, I, ne, ge, ae, Le, Me;
    function $e() {
    }
    $e.__reactDisabledLog = !0;
    function Xe() {
      {
        if (ee === 0) {
          U = console.log, I = console.info, ne = console.warn, ge = console.error, ae = console.group, Le = console.groupCollapsed, Me = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: $e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Qe() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, r, {
              value: U
            }),
            info: B({}, r, {
              value: I
            }),
            warn: B({}, r, {
              value: ne
            }),
            error: B({}, r, {
              value: ge
            }),
            group: B({}, r, {
              value: ae
            }),
            groupCollapsed: B({}, r, {
              value: Le
            }),
            groupEnd: B({}, r, {
              value: Me
            })
          });
        }
        ee < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var je = x.ReactCurrentDispatcher, ke;
    function _e(r, m, v) {
      {
        if (ke === void 0)
          try {
            throw Error();
          } catch (Z) {
            var C = Z.stack.trim().match(/\n( *(at )?)/);
            ke = C && C[1] || "";
          }
        return `
` + ke + r;
      }
    }
    var Ze = !1, k;
    {
      var W = typeof WeakMap == "function" ? WeakMap : Map;
      k = new W();
    }
    function q(r, m) {
      if (!r || Ze)
        return "";
      {
        var v = k.get(r);
        if (v !== void 0)
          return v;
      }
      var C;
      Ze = !0;
      var Z = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var V;
      V = je.current, je.current = null, Xe();
      try {
        if (m) {
          var j = function() {
            throw Error();
          };
          if (Object.defineProperty(j.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(j, []);
            } catch (Q) {
              C = Q;
            }
            Reflect.construct(r, [], j);
          } else {
            try {
              j.call();
            } catch (Q) {
              C = Q;
            }
            r.call(j.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            C = Q;
          }
          r();
        }
      } catch (Q) {
        if (Q && C && typeof Q.stack == "string") {
          for (var L = Q.stack.split(`
`), J = C.stack.split(`
`), P = L.length - 1, z = J.length - 1; P >= 1 && z >= 0 && L[P] !== J[z]; )
            z--;
          for (; P >= 1 && z >= 0; P--, z--)
            if (L[P] !== J[z]) {
              if (P !== 1 || z !== 1)
                do
                  if (P--, z--, z < 0 || L[P] !== J[z]) {
                    var oe = `
` + L[P].replace(" at new ", " at ");
                    return r.displayName && oe.includes("<anonymous>") && (oe = oe.replace("<anonymous>", r.displayName)), typeof r == "function" && k.set(r, oe), oe;
                  }
                while (P >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ze = !1, je.current = V, Qe(), Error.prepareStackTrace = Z;
      }
      var ve = r ? r.displayName || r.name : "", he = ve ? _e(ve) : "";
      return typeof r == "function" && k.set(r, he), he;
    }
    function ce(r, m, v) {
      return q(r, !1);
    }
    function me(r) {
      var m = r.prototype;
      return !!(m && m.isReactComponent);
    }
    function fe(r, m, v) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return q(r, me(r));
      if (typeof r == "string")
        return _e(r);
      switch (r) {
        case c:
          return _e("Suspense");
        case h:
          return _e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case p:
            return ce(r.render);
          case y:
            return fe(r.type, m, v);
          case f: {
            var C = r, Z = C._payload, V = C._init;
            try {
              return fe(V(Z), m, v);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Re = {}, Y = x.ReactDebugCurrentFrame;
    function ie(r) {
      if (r) {
        var m = r._owner, v = fe(r.type, r._source, m ? m.type : null);
        Y.setExtraStackFrame(v);
      } else
        Y.setExtraStackFrame(null);
    }
    function te(r, m, v, C, Z) {
      {
        var V = Function.call.bind(de);
        for (var j in r)
          if (V(r, j)) {
            var L = void 0;
            try {
              if (typeof r[j] != "function") {
                var J = Error((C || "React class") + ": " + v + " type `" + j + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[j] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw J.name = "Invariant Violation", J;
              }
              L = r[j](m, j, C, v, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (P) {
              L = P;
            }
            L && !(L instanceof Error) && (ie(Z), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", C || "React class", v, j, typeof L), ie(null)), L instanceof Error && !(L.message in Re) && (Re[L.message] = !0, ie(Z), A("Failed %s type: %s", v, L.message), ie(null));
          }
      }
    }
    var Ve = Array.isArray;
    function Ae(r) {
      return Ve(r);
    }
    function Dt(r) {
      {
        var m = typeof Symbol == "function" && Symbol.toStringTag, v = m && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return v;
      }
    }
    function zt(r) {
      try {
        return et(r), !1;
      } catch {
        return !0;
      }
    }
    function et(r) {
      return "" + r;
    }
    function tt(r) {
      if (zt(r))
        return A("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Dt(r)), et(r);
    }
    var we = x.ReactCurrentOwner, Gt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, rt, nt, He;
    He = {};
    function Bt(r) {
      if (de.call(r, "ref")) {
        var m = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function Ut(r) {
      if (de.call(r, "key")) {
        var m = Object.getOwnPropertyDescriptor(r, "key").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function Wt(r, m) {
      if (typeof r.ref == "string" && we.current && m && we.current.stateNode !== m) {
        var v = O(we.current.type);
        He[v] || (A('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(we.current.type), r.ref), He[v] = !0);
      }
    }
    function Yt(r, m) {
      {
        var v = function() {
          rt || (rt = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        v.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: v,
          configurable: !0
        });
      }
    }
    function Kt(r, m) {
      {
        var v = function() {
          nt || (nt = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        v.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: v,
          configurable: !0
        });
      }
    }
    var qt = function(r, m, v, C, Z, V, j) {
      var L = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: r,
        key: m,
        ref: v,
        props: j,
        // Record the component responsible for creating this element.
        _owner: V
      };
      return L._store = {}, Object.defineProperty(L._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(L, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.defineProperty(L, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Z
      }), Object.freeze && (Object.freeze(L.props), Object.freeze(L)), L;
    };
    function Jt(r, m, v, C, Z) {
      {
        var V, j = {}, L = null, J = null;
        v !== void 0 && (tt(v), L = "" + v), Ut(m) && (tt(m.key), L = "" + m.key), Bt(m) && (J = m.ref, Wt(m, Z));
        for (V in m)
          de.call(m, V) && !Gt.hasOwnProperty(V) && (j[V] = m[V]);
        if (r && r.defaultProps) {
          var P = r.defaultProps;
          for (V in P)
            j[V] === void 0 && (j[V] = P[V]);
        }
        if (L || J) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          L && Yt(j, z), J && Kt(j, z);
        }
        return qt(r, L, J, Z, C, we.current, j);
      }
    }
    var Oe = x.ReactCurrentOwner, at = x.ReactDebugCurrentFrame;
    function be(r) {
      if (r) {
        var m = r._owner, v = fe(r.type, r._source, m ? m.type : null);
        at.setExtraStackFrame(v);
      } else
        at.setExtraStackFrame(null);
    }
    var Pe;
    Pe = !1;
    function De(r) {
      return typeof r == "object" && r !== null && r.$$typeof === e;
    }
    function ot() {
      {
        if (Oe.current) {
          var r = O(Oe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Xt(r) {
      {
        if (r !== void 0) {
          var m = r.fileName.replace(/^.*[\\\/]/, ""), v = r.lineNumber;
          return `

Check your code at ` + m + ":" + v + ".";
        }
        return "";
      }
    }
    var lt = {};
    function Qt(r) {
      {
        var m = ot();
        if (!m) {
          var v = typeof r == "string" ? r : r.displayName || r.name;
          v && (m = `

Check the top-level render call using <` + v + ">.");
        }
        return m;
      }
    }
    function st(r, m) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var v = Qt(m);
        if (lt[v])
          return;
        lt[v] = !0;
        var C = "";
        r && r._owner && r._owner !== Oe.current && (C = " It was passed a child from " + O(r._owner.type) + "."), be(r), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', v, C), be(null);
      }
    }
    function it(r, m) {
      {
        if (typeof r != "object")
          return;
        if (Ae(r))
          for (var v = 0; v < r.length; v++) {
            var C = r[v];
            De(C) && st(C, m);
          }
        else if (De(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var Z = b(r);
          if (typeof Z == "function" && Z !== r.entries)
            for (var V = Z.call(r), j; !(j = V.next()).done; )
              De(j.value) && st(j.value, m);
        }
      }
    }
    function er(r) {
      {
        var m = r.type;
        if (m == null || typeof m == "string")
          return;
        var v;
        if (typeof m == "function")
          v = m.propTypes;
        else if (typeof m == "object" && (m.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        m.$$typeof === y))
          v = m.propTypes;
        else
          return;
        if (v) {
          var C = O(m);
          te(v, r.props, "prop", C, r);
        } else if (m.PropTypes !== void 0 && !Pe) {
          Pe = !0;
          var Z = O(m);
          A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Z || "Unknown");
        }
        typeof m.getDefaultProps == "function" && !m.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function tr(r) {
      {
        for (var m = Object.keys(r.props), v = 0; v < m.length; v++) {
          var C = m[v];
          if (C !== "children" && C !== "key") {
            be(r), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", C), be(null);
            break;
          }
        }
        r.ref !== null && (be(r), A("Invalid attribute `ref` supplied to `React.Fragment`."), be(null));
      }
    }
    var ct = {};
    function ut(r, m, v, C, Z, V) {
      {
        var j = H(r);
        if (!j) {
          var L = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var J = Xt(Z);
          J ? L += J : L += ot();
          var P;
          r === null ? P = "null" : Ae(r) ? P = "array" : r !== void 0 && r.$$typeof === e ? (P = "<" + (O(r.type) || "Unknown") + " />", L = " Did you accidentally export a JSX literal instead of a component?") : P = typeof r, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", P, L);
        }
        var z = Jt(r, m, v, Z, V);
        if (z == null)
          return z;
        if (j) {
          var oe = m.children;
          if (oe !== void 0)
            if (C)
              if (Ae(oe)) {
                for (var ve = 0; ve < oe.length; ve++)
                  it(oe[ve], r);
                Object.freeze && Object.freeze(oe);
              } else
                A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              it(oe, r);
        }
        if (de.call(m, "key")) {
          var he = O(r), Q = Object.keys(m).filter(function(sr) {
            return sr !== "key";
          }), ze = Q.length > 0 ? "{key: someKey, " + Q.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ct[he + ze]) {
            var lr = Q.length > 0 ? "{" + Q.join(": ..., ") + ": ...}" : "{}";
            A(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ze, he, lr, he), ct[he + ze] = !0;
          }
        }
        return r === l ? tr(z) : er(z), z;
      }
    }
    function rr(r, m, v) {
      return ut(r, m, v, !0);
    }
    function nr(r, m, v) {
      return ut(r, m, v, !1);
    }
    var ar = nr, or = rr;
    dt.Fragment = l, dt.jsx = ar, dt.jsxs = or;
  }()), dt;
}
process.env.NODE_ENV === "production" ? _r.exports = Fa() : _r.exports = $a();
var o = _r.exports;
const Ha = ({
  panels: n,
  side: e,
  activePanel: a,
  onPanelChange: l
}) => /* @__PURE__ */ o.jsx(o.Fragment, { children: Object.entries(n).map(([s, u]) => /* @__PURE__ */ o.jsx(
  Qr,
  {
    icon: u.icon,
    text: u.label,
    onClick: () => l?.(a === s ? null : s),
    active: a === s
  },
  s
)) }), Oa = {
  left: null,
  right: null
  // panelene er lukket ved oppstart
}, yn = Ht({
  name: "panel",
  initialState: Oa,
  reducers: {
    setActiveLeftPanel(n, e) {
      n.left = e.payload;
    },
    setActiveRightPanel(n, e) {
      n.right = e.payload;
    }
  }
}), { setActiveLeftPanel: p1, setActiveRightPanel: f1 } = yn.actions, h1 = yn.reducer, g1 = () => Er((n) => n.panel.left), y1 = () => Er((n) => n.panel.right), b1 = () => ta();
function v1({
  title: n,
  description: e,
  logo: a = "geodata-logo.png",
  user: l,
  onSignOut: s,
  onShowInfo: u,
  onToggleMenu: d,
  showMenuButton: i = !1,
  showInfoButton: p = !1
}) {
  const { t: c, i18n: h } = Ie("uiComponents"), [y, f] = E(!1);
  return D(() => {
    Ir.setLocale(h.language);
  }, []), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(na, { slot: "header", children: [
      i && /* @__PURE__ */ o.jsx(
        kt,
        {
          slot: "navigation-action",
          icon: "hamburger",
          text: "Toggle menu",
          onClick: d
        }
      ),
      /* @__PURE__ */ o.jsx(
        aa,
        {
          slot: "logo",
          heading: n || c("header.title"),
          description: e || c("header.description"),
          thumbnail: a
        }
      ),
      p && /* @__PURE__ */ o.jsx(
        kt,
        {
          slot: "content-end",
          id: "header-information",
          icon: "question",
          text: c("header.showInfoLabel"),
          scale: "l",
          onClick: u
        }
      ),
      /* @__PURE__ */ o.jsxs(
        oa,
        {
          slot: "user",
          id: "header-user-dropdown",
          onCalciteDropdownOpen: () => f(!0),
          onCalciteDropdownClose: () => f(!1),
          open: y ? !0 : void 0,
          onCalciteDropdownSelect: () => f(!1),
          widthScale: "m",
          children: [
            /* @__PURE__ */ o.jsx(
              kt,
              {
                slot: "trigger",
                id: "header-settings",
                icon: "gear",
                text: c("header.showInfoLabel"),
                scale: "l"
              }
            ),
            l && /* @__PURE__ */ o.jsx(
              la,
              {
                slot: "trigger",
                active: y ? !0 : void 0,
                fullName: l.fullName,
                username: l.username,
                thumbnail: l.thumbnailUrl
              }
            ),
            /* @__PURE__ */ o.jsx(ir, { selectionMode: "none", children: /* @__PURE__ */ o.jsx(cr, { iconStart: "language-translate", onCalciteDropdownItemSelect: () => {
              const g = h.language == "nb" ? "en" : "nb";
              h.changeLanguage(g), Ir.setLocale(g);
            }, children: c("header.languageToggleLabel") }) }),
            /* @__PURE__ */ o.jsx(ir, { selectionMode: "none", children: l?.orgUrl && /* @__PURE__ */ o.jsx(cr, { iconStart: "arcgis-online", onCalciteDropdownItemSelect: () => {
              window.open(l.orgUrl, "_blank");
            }, children: c("header.arcgisOnlineLabel") }) }),
            s && /* @__PURE__ */ o.jsx(ir, { selectionMode: "none", children: /* @__PURE__ */ o.jsx(cr, { iconStart: "sign-out", onCalciteDropdownItemSelect: s, children: c("header.signoutLabel") }) })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ o.jsx(Vr, { placement: "bottom-end", closeOnClick: !0, referenceElement: "header-information", children: c("header.showInfoTooltip") }),
    /* @__PURE__ */ o.jsx(Vr, { placement: "bottom-end", closeOnClick: !0, referenceElement: "header-user-dropdown", open: void 0, children: c("header.userDropdownTooltip") })
  ] });
}
const S1 = ({ panels: n, activePanel: e }) => {
  if (!e || !n[e])
    return null;
  console.log("Rendering LeftPanel with activePanel:", e);
  const a = n[e].component;
  return /* @__PURE__ */ o.jsx("div", { className: "left-panel", children: /* @__PURE__ */ o.jsx(a, {}) });
}, x1 = ({ panels: n, activePanel: e }) => !e || !n[e] ? null : /* @__PURE__ */ o.jsx("div", { className: "right-panel", children: n[e].panel }), Pa = ({
  panels: n,
  activePanel: e,
  className: a,
  onHeadingChange: l,
  onDescriptionChange: s
}) => {
  if (!e || !n[e])
    return null;
  const d = n[e].component;
  return /* @__PURE__ */ o.jsx("div", { className: a, children: /* @__PURE__ */ o.jsx(
    d,
    {
      onHeadingChange: l,
      onDescriptionChange: s
    }
  ) });
}, bn = ({
  panels: n,
  activePanel: e,
  onPanelChange: a,
  onPanelClose: l,
  side: s,
  expanded: u,
  initialWidth: d,
  onPanelInfo: i
}) => {
  const [p, c] = E(""), [h, y] = E(void 0);
  if (D(() => {
    if (e && n[e]) {
      const S = n[e];
      c(S.heading || S.label), y(S.description);
    } else
      c(""), y(void 0);
  }, [e, n]), !n)
    return null;
  const f = s === "left", g = s === "left" ? "start" : "end", w = s === "left" ? "panel-start" : "panel-end";
  return /* @__PURE__ */ o.jsxs(
    sa,
    {
      position: g,
      slot: w,
      resizable: !0,
      collapsed: !e,
      style: {
        "--calcite-shell-panel-width": d || "400px",
        "--calcite-shell-panel-max-width": "70vw"
      },
      ...f && { layout: "vertical" },
      children: [
        /* @__PURE__ */ o.jsx(ia, { id: "main_toolbar", slot: "action-bar", expanded: u, children: /* @__PURE__ */ o.jsx(
          Ha,
          {
            panels: n,
            side: s,
            activePanel: e,
            onPanelChange: a
          }
        ) }),
        /* @__PURE__ */ o.jsx(ca, { children: /* @__PURE__ */ o.jsxs(
          ua,
          {
            heading: p,
            collapsible: !0,
            closable: !0,
            closed: !e,
            description: h,
            onCalciteFlowItemClose: l,
            children: [
              e && /* @__PURE__ */ o.jsx(
                kt,
                {
                  slot: "header-actions-end",
                  id: "panel-information",
                  icon: "question",
                  text: "Show panel info",
                  scale: "l",
                  onClick: () => i?.(e)
                }
              ),
              /* @__PURE__ */ o.jsx(
                Pa,
                {
                  panels: n,
                  activePanel: e,
                  className: f ? "left-panel" : "right-panel",
                  onHeadingChange: c,
                  onDescriptionChange: y
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}, _1 = (n) => /* @__PURE__ */ o.jsx(
  bn,
  {
    ...n,
    side: "left",
    expanded: !0
  }
), w1 = (n) => /* @__PURE__ */ o.jsx(
  bn,
  {
    ...n,
    side: "right"
  }
);
function A1() {
  const { t: n } = Ie("map"), e = K(null), a = K(), { mapView: l, sceneView: s, mapMode: u } = Ee();
  D(() => () => {
    a.current?.removeHandles("location-analytics");
  }, []), D(() => {
    if (!a.current) {
      const p = u === Be.ThreeD ? s : l;
      p && (a.current = d(p));
    }
  }, [u, l, s]), D(() => {
    if (!a.current)
      return;
    const p = u === Be.ThreeD ? s : l;
    p && a.current.view !== p && (console.log(`Switching LayerList to ${u === Be.ThreeD ? "3D" : "2D"} view`), a.current.view = p);
  }, [u, l, s]);
  const d = (p) => {
    console.log("Creating LayerList widget with view:", p.type);
    const c = new ma({
      view: p,
      // Bruk den passede view'et
      container: e.current,
      filterPlaceholder: n("layerlist.filterPlaceholder"),
      dragEnabled: !0,
      visibleElements: {
        filter: !0,
        statusIndicators: !0
      },
      listItemCreatedFunction: function(f) {
        const g = f.item;
        g.actionsSections = [
          [
            {
              title: "Delete",
              icon: "trash",
              id: "delete"
            },
            {
              title: "Layer information",
              icon: "information",
              id: "information"
            }
          ]
        ];
      }
    }), h = c.on("trigger-action", (f) => {
      console.log(f), f.action.id === "delete" && a.current?.view?.map && a.current.view.map.remove(f.item.layer);
    }), y = nn.watch(() => a.current?.viewModel.state, (f) => {
      console.log("LayerList state", f);
    });
    return c.addHandles([h, y], "location-analytics"), c;
  }, i = {
    display: "unset"
  };
  return /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx("div", { id: "esri-layer-list", style: i, className: "widget-container", ref: e }) });
}
const Da = "LayerListCustom-module__item___qrsm5", za = "LayerListCustom-module__row___07KOG", Ga = "LayerListCustom-module__dragHandle___-70p3", Ba = "LayerListCustom-module__dragging___JoSbZ", Ua = "LayerListCustom-module__dropAbove___4kUlw", Wa = "LayerListCustom-module__dropBelow___JIlJ9", Ya = "LayerListCustom-module__expandBtn___WsMcW", Ka = "LayerListCustom-module__spacer___mSQAU", qa = "LayerListCustom-module__children___cKm0l", Ja = "LayerListCustom-module__container___6-8QZ", Xa = "LayerListCustom-module__search___iGLi7", Qa = "LayerListCustom-module__searchInput___dCQFL", Se = {
  item: Da,
  row: za,
  dragHandle: Ga,
  dragging: Ba,
  dropAbove: Ua,
  dropBelow: Wa,
  expandBtn: Ya,
  spacer: Ka,
  children: qa,
  container: Ja,
  search: Xa,
  searchInput: Qa
}, eo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M236,184a12,12,0,0,1-24,0A84,84,0,0,0,68.6,124.6L53.11,140H88a12,12,0,0,1,0,24H24a12,12,0,0,1-12-12V88a12,12,0,0,1,24,0v35.16l15.66-15.55A108,108,0,0,1,236,184Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M88,152H24V88Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M201.54,110.46a104,104,0,0,0-145.4-1.63L29.66,82.34A8,8,0,0,0,16,88v64a8,8,0,0,0,8,8H88a8,8,0,0,0,5.66-13.66L67.47,120.16A88,88,0,0,1,216,184a8,8,0,0,0,16,0A103.33,103.33,0,0,0,201.54,110.46ZM32,144V107.31L68.69,144Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,67.47,120.16l26.19,26.18A8,8,0,0,1,88,160H24a8,8,0,0,1-8-8V88a8,8,0,0,1,13.66-5.66l26.48,26.48A104,104,0,0,1,232,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M230,184a6,6,0,0,1-12,0A90,90,0,0,0,64.36,120.36L38.55,146H88a6,6,0,0,1,0,12H24a6,6,0,0,1-6-6V88a6,6,0,0,1,12,0v49.58l25.89-25.72A102,102,0,0,1,230,184Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,65.78,121.78L43.4,144H88a8,8,0,0,1,0,16H24a8,8,0,0,1-8-8V88a8,8,0,0,1,16,0v44.77l22.48-22.33A104,104,0,0,1,232,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M228,184a4,4,0,0,1-8,0A92,92,0,0,0,63,119L33.7,148H88a4,4,0,0,1,0,8H24a4,4,0,0,1-4-4V88a4,4,0,0,1,8,0v54.39l29.3-29.11A100,100,0,0,1,228,184Z" }))
  ]
]), to = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M244,88v64a12,12,0,0,1-12,12H168a12,12,0,0,1,0-24h34.9l-15.48-15.37A84,84,0,0,0,44,184a12,12,0,0,1-24,0,108,108,0,0,1,184.37-76.37L220,123.16V88a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,88v64H168Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M235.06,80.61a8,8,0,0,0-8.72,1.73l-26.48,26.49A104,104,0,0,0,24,184a8,8,0,0,0,16,0,88,88,0,0,1,148.53-63.84l-26.19,26.18A8,8,0,0,0,168,160h64a8,8,0,0,0,8-8V88A8,8,0,0,0,235.06,80.61ZM224,144H187.31L224,107.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M240,88v64a8,8,0,0,1-8,8H168a8,8,0,0,1-5.66-13.66l26.19-26.18A88,88,0,0,0,40,184a8,8,0,0,1-16,0,104,104,0,0,1,175.86-75.18l26.48-26.48A8,8,0,0,1,240,88Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M238,88v64a6,6,0,0,1-6,6H168a6,6,0,0,1,0-12h49.45l-25.8-25.63A90,90,0,0,0,38,184a6,6,0,0,1-12,0,102,102,0,0,1,174.12-72.12L226,137.58V88a6,6,0,0,1,12,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M240,88v64a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h44.6l-22.36-22.21A88,88,0,0,0,40,184a8,8,0,0,1-16,0,104,104,0,0,1,177.54-73.54L224,132.77V88a8,8,0,0,1,16,0Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M236,88v64a4,4,0,0,1-4,4H168a4,4,0,0,1,0-8h54.3l-29.24-29A92,92,0,0,0,36,184a4,4,0,0,1-8,0,100,100,0,0,1,170.71-70.71L228,142.39V88a4,4,0,0,1,8,0Z" }))
  ]
]), ro = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M208,96l-80,80L48,96Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), no = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M176,128,96,208V48Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }))
  ]
]), ao = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), oo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,128A104,104,0,1,1,128,24,104.13,104.13,0,0,1,232,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Z" }))
  ]
]), lo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224.15,179.17l-46.83-46.82,37.93-13.51.76-.3a20,20,0,0,0-1.76-37.27L54.16,29A20,20,0,0,0,29,54.16L81.27,214.24A20,20,0,0,0,118.54,216c.11-.25.21-.5.3-.76l13.51-37.92,46.83,46.82a20,20,0,0,0,28.28,0l16.69-16.68A20,20,0,0,0,224.15,179.17Zm-30.83,25.17-48.48-48.48A20,20,0,0,0,130.7,150a20.66,20.66,0,0,0-3.74.35A20,20,0,0,0,112.35,162c-.11.25-.21.5-.3.76L100.4,195.5,54.29,54.29l141.21,46.1-32.71,11.66c-.26.09-.51.19-.76.3a20,20,0,0,0-6.17,32.48h0l48.49,48.48Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M213.66,201,201,213.66a8,8,0,0,1-11.31,0l-51.31-51.31a8,8,0,0,0-13,2.46l-17.82,46.41a8,8,0,0,1-14.85-.71L40.41,50.44a8,8,0,0,1,10-10L210.51,92.68a8,8,0,0,1,.71,14.85l-46.41,17.82a8,8,0,0,0-2.46,13l51.31,51.31A8,8,0,0,1,213.66,201Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M168,132.69,214.08,115l.33-.13A16,16,0,0,0,213,85.07L52.92,32.8A15.95,15.95,0,0,0,32.8,52.92L85.07,213a15.82,15.82,0,0,0,14.41,11l.78,0a15.84,15.84,0,0,0,14.61-9.59l.13-.33L132.69,168,184,219.31a16,16,0,0,0,22.63,0l12.68-12.68a16,16,0,0,0,0-22.63ZM195.31,208,144,156.69a16,16,0,0,0-26,4.93c0,.11-.09.22-.13.32l-17.65,46L48,48l159.85,52.2-45.95,17.64-.32.13a16,16,0,0,0-4.93,26h0L208,195.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M220.49,207.8,207.8,220.49a12,12,0,0,1-17,0l-56.57-56.57L115,214.08l-.13.33A15.84,15.84,0,0,1,100.26,224l-.78,0a15.82,15.82,0,0,1-14.41-11L32.8,52.92A15.95,15.95,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.33.13-50.16,19.27,56.57,56.56A12,12,0,0,1,220.49,207.8Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M166.59,134.1a1.91,1.91,0,0,1-.55-1.79,2,2,0,0,1,1.08-1.42l46.25-17.76.24-.1A14,14,0,0,0,212.38,87L52.29,34.7A13.95,13.95,0,0,0,34.7,52.29L87,212.38a13.82,13.82,0,0,0,12.6,9.6c.23,0,.46,0,.69,0A13.84,13.84,0,0,0,113,213.61a2.44,2.44,0,0,0,.1-.24l17.76-46.25a2,2,0,0,1,3.21-.53l51.31,51.31a14,14,0,0,0,19.8,0l12.69-12.69a14,14,0,0,0,0-19.8Zm42.82,62.63-12.68,12.68a2,2,0,0,1-2.83,0L142.59,158.1a14,14,0,0,0-22.74,4.32,2.44,2.44,0,0,0-.1.24L102,208.91a2,2,0,0,1-3.61-.26L46.11,48.57a1.87,1.87,0,0,1,.47-2A1.92,1.92,0,0,1,47.93,46a2.22,2.22,0,0,1,.64.1L208.65,98.38a2,2,0,0,1,.26,3.61l-46.25,17.76-.24.1a14,14,0,0,0-4.32,22.74h0l51.31,51.31A2,2,0,0,1,209.41,196.73Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M168,132.69,214.08,115l.33-.13A16,16,0,0,0,213,85.07L52.92,32.8A15.95,15.95,0,0,0,32.8,52.92L85.07,213a15.82,15.82,0,0,0,14.41,11l.78,0a15.84,15.84,0,0,0,14.61-9.59l.13-.33L132.69,168,184,219.31a16,16,0,0,0,22.63,0l12.68-12.68a16,16,0,0,0,0-22.63ZM195.31,208,144,156.69a16,16,0,0,0-26,4.93c0,.11-.09.22-.13.32l-17.65,46L48,48l159.85,52.2-45.95,17.64-.32.13a16,16,0,0,0-4.93,26h0L208,195.31Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M165.17,135.51a4,4,0,0,1,1.17-6.46l46.31-17.79.16-.06a12,12,0,0,0-1.05-22.33L51.67,36.6A12,12,0,0,0,36.6,51.67L88.87,211.76A11.86,11.86,0,0,0,99.67,220h.58a11.86,11.86,0,0,0,11-7.19l.06-.16,17.79-46.31a4,4,0,0,1,6.47-1.17l51.31,51.32a12,12,0,0,0,17,0l12.69-12.69a12,12,0,0,0,0-17Zm45.66,62.63-12.69,12.69a4,4,0,0,1-5.66,0l-51.31-51.31a12,12,0,0,0-8.48-3.52,12.13,12.13,0,0,0-2.24.21,12,12,0,0,0-8.77,7l-.06.16-17.79,46.31a4,4,0,0,1-7.36-.42L44.2,49.19a4,4,0,0,1,5-5L209.27,96.47a4,4,0,0,1,.42,7.36l-46.31,17.78-.16.07a12,12,0,0,0-3.71,19.49l51.32,51.31A4,4,0,0,1,210.83,198.14Z" }))
  ]
]), so = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M108,60A16,16,0,1,1,92,44,16,16,0,0,1,108,60Zm56,16a16,16,0,1,0-16-16A16,16,0,0,0,164,76ZM92,112a16,16,0,1,0,16,16A16,16,0,0,0,92,112Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,112ZM92,180a16,16,0,1,0,16,16A16,16,0,0,0,92,180Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,180Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M208,32V224a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V32A16,16,0,0,1,64,16H192A16,16,0,0,1,208,32Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M192,16H64A16,16,0,0,0,48,32V224a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V32A16,16,0,0,0,192,16ZM100,200a12,12,0,1,1,12-12A12,12,0,0,1,100,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,80Zm56,120a12,12,0,1,1,12-12A12,12,0,0,1,156,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M102,60A10,10,0,1,1,92,50,10,10,0,0,1,102,60Zm62,10a10,10,0,1,0-10-10A10,10,0,0,0,164,70ZM92,118a10,10,0,1,0,10,10A10,10,0,0,0,92,118Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,118ZM92,186a10,10,0,1,0,10,10A10,10,0,0,0,92,186Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,186Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M100,60a8,8,0,1,1-8-8A8,8,0,0,1,100,60Zm64,8a8,8,0,1,0-8-8A8,8,0,0,0,164,68ZM92,120a8,8,0,1,0,8,8A8,8,0,0,0,92,120Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,120ZM92,188a8,8,0,1,0,8,8A8,8,0,0,0,92,188Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,188Z" }))
  ]
]), io = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M144,176a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm88-48A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128ZM124,96a12,12,0,1,0-12-12A12,12,0,0,0,124,96Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M140,176a4,4,0,0,1-4,4,12,12,0,0,1-12-12V128a4,4,0,0,0-4-4,4,4,0,0,1,0-8,12,12,0,0,1,12,12v40a4,4,0,0,0,4,4A4,4,0,0,1,140,176ZM124,92a8,8,0,1,0-8-8A8,8,0,0,0,124,92Zm104,36A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), co = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M207.83,56.53C186.32,43.29,158,36,128,36S69.68,43.29,48.17,56.53C24.85,70.89,12,90.6,12,112s12.85,41.14,36.17,55.5c18.48,11.37,42,18.34,67.29,20.08-2,11.07-9.09,17.75-15.22,21.54-13.48,8.31-32.75,9.18-46.86,2.1A12,12,0,1,0,42.62,232.7a71.76,71.76,0,0,0,32,7.3,73.2,73.2,0,0,0,38.18-10.43c15.45-9.54,25-24.58,26.83-41.9,25.6-1.64,49.47-8.65,68.16-20.15C231.15,153.16,244,133.45,244,112S231.15,70.89,207.83,56.53Zm-134.44,97a21,21,0,0,1,20.16-9.35c10.36,1.39,16.54,9.43,19.72,19.13A135.3,135.3,0,0,1,73.39,153.56Zm64.87,10.14a61.84,61.84,0,0,0-10.76-24.82,46.08,46.08,0,0,0-30.75-18.46c-18-2.41-34.52,5.89-44.1,21C42.2,133,36,122.84,36,112c0-28.19,42.13-52,92-52s92,23.82,92,52C220,138.26,183.51,160.71,138.26,163.7Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M232,112c0,35.35-46.56,64-104,64S24,147.35,24,112,70.56,48,128,48,232,76.65,232,112Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M205.73,59.93C184.85,47.08,157.24,40,128,40S71.15,47.08,50.27,59.93C28.17,73.52,16,92,16,112S28.17,150.44,50.27,164c19,11.67,43.49,18.56,69.73,19.73v0a37.35,37.35,0,0,1-18.58,33c-14.64,8.86-34.62,9.52-49.72,1.64a8,8,0,1,0-7.4,14.18A66.4,66.4,0,0,0,75,240a67.31,67.31,0,0,0,34.74-9.5c17-10.27,26.29-26.86,26.29-46.7v0c26.24-1.17,50.76-8.06,69.73-19.73C227.83,150.44,240,132,240,112S227.83,73.52,205.73,59.93ZM67.41,155.18c5.24-9.55,15.45-12,23.53-11,10.9,1.42,21.86,9.13,26.61,23.42C99.11,166.45,81.85,162.16,67.41,155.18Zm129.94-4.77c-16.95,10.43-39.17,16.53-63.13,17.43a54.37,54.37,0,0,0-11.39-23.07A47.17,47.17,0,0,0,93,128.35c-17-2.2-31.72,5.11-39.38,18.7C39.64,137,32,124.73,32,112c0-14.21,9.47-27.86,26.65-38.43C77.05,62.23,101.68,56,128,56S179,62.23,197.35,73.55C214.53,84.12,224,97.77,224,112S214.53,139.84,197.35,150.41Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M93.43,136.11a17.14,17.14,0,0,0-15.35,6.1c9.31,6.56,22.51,11.33,37.43,13.07C110.41,143.33,101.72,137,93.43,136.11Z" }), /* @__PURE__ */ t.createElement("path", { d: "M224,48V208a16,16,0,0,1-16,16H127.65a4,4,0,0,1-3.23-6.34c7.5-10.23,11.58-23.24,11.58-37.84,0-2.79-.13-5.46-.35-8.05C176.79,169.33,208,147.47,208,120c0-29.15-35.14-52-80-52S48,90.84,48,120c0,27.31,30.82,49.07,71.58,51.73a77,77,0,0,1,.42,8.09c0,17.62-7.65,31.95-21,39.32A38.77,38.77,0,0,1,79.27,224H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Zm-32,72c0-19.51-29.31-36-64-36s-64,16.48-64,36a21.29,21.29,0,0,0,3,10.63A33.65,33.65,0,0,1,95.16,120.2c15,1.63,30.84,13.4,37.54,35.68C165.3,154.47,192,138.62,192,120Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M204.68,61.63C184.11,49,156.88,42,128,42S71.89,49,51.32,61.63C29.83,74.85,18,92.73,18,112s11.83,37.13,33.32,50.35C70.45,174.1,95.35,181,122,181.85c0,.64,0,1.28,0,1.94,0,14.76-6.94,27.1-19.54,34.73-15.22,9.22-36,9.9-51.68,1.71a6,6,0,1,0-5.56,10.63A64.45,64.45,0,0,0,75,238a65.24,65.24,0,0,0,33.7-9.22c16.34-9.89,25.33-25.87,25.33-45,0-.65,0-1.29,0-1.94,26.65-.89,51.57-7.74,70.72-19.52C226.17,149.11,238,131.23,238,112S226.17,74.85,204.68,61.63Zm-140,94.46c5.32-12,17.2-15.07,26.48-13.87,12.28,1.6,24.64,10.67,29.08,27.55C99.73,168.81,80.48,164.08,64.72,156.09Zm133.67-4c-17.62,10.85-40.83,17.1-65.77,17.79a52.77,52.77,0,0,0-11.31-23.84,45.24,45.24,0,0,0-28.56-15.73c-16.89-2.2-31.49,5.54-38.41,19.68C38.61,139.37,30,126,30,112c0-14.93,9.8-29.18,27.61-40.13C76.32,60.34,101.32,54,128,54s51.68,6.34,70.39,17.85C216.2,82.8,226,97.05,226,112S216.2,141.16,198.39,152.11Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M205.73,59.93C184.85,47.08,157.24,40,128,40S71.15,47.08,50.27,59.93C28.17,73.52,16,92,16,112S28.17,150.44,50.27,164c19,11.67,43.49,18.56,69.73,19.73v0a37.35,37.35,0,0,1-18.58,33c-14.64,8.86-34.62,9.52-49.72,1.64a8,8,0,1,0-7.4,14.18A66.4,66.4,0,0,0,75,240a67.31,67.31,0,0,0,34.74-9.5c17-10.27,26.29-26.86,26.29-46.7v0c26.24-1.17,50.76-8.06,69.73-19.73C227.83,150.44,240,132,240,112S227.83,73.52,205.73,59.93ZM67.41,155.18c5.24-9.55,15.44-12,23.53-11,10.9,1.42,21.86,9.13,26.61,23.42C99.11,166.45,81.85,162.16,67.41,155.18Zm129.94-4.77c-16.95,10.43-39.17,16.53-63.13,17.43a54.37,54.37,0,0,0-11.39-23.07A47.17,47.17,0,0,0,93,128.35c-17-2.2-31.72,5.11-39.38,18.7C39.64,137,32,124.73,32,112c0-14.21,9.47-27.86,26.65-38.43C77.05,62.23,101.68,56,128,56S179,62.23,197.35,73.55C214.53,84.12,224,97.77,224,112S214.53,139.84,197.35,150.41Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M203.64,63.34C183.37,50.87,156.51,44,128,44S72.63,50.87,52.36,63.34C31.49,76.19,20,93.48,20,112s11.49,35.83,32.36,48.68c19.29,11.87,44.55,18.65,71.51,19.28.08,1.27.13,2.56.13,3.9,0,15.49-7.28,28.44-20.51,36.46-15.79,9.57-37.34,10.28-53.64,1.77a4,4,0,1,0-3.7,7.09A62.32,62.32,0,0,0,74.91,236a63.56,63.56,0,0,0,32.73-8.82c15.71-9.52,24.36-24.9,24.36-43.3,0-1.32-.05-2.61-.12-3.9,27.06-.59,52.41-7.38,71.76-19.28C224.51,147.85,236,130.56,236,112S224.51,76.19,203.64,63.34ZM62.16,157.15c5.3-14.49,18.83-18.22,29.3-16.85,13.64,1.78,27.38,12.19,31.38,31.66C99.66,171.25,78.55,165.78,62.16,157.15ZM131,172a51.35,51.35,0,0,0-11.18-24.59,43.28,43.28,0,0,0-27.3-15.06c-16.82-2.19-31.24,6-37.33,20.74C38.33,142.35,28,127.9,28,112c0-33.09,44.86-60,100-60s100,26.93,100,60C228,144.52,184.74,171.06,131,172Z" }))
  ]
]), uo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M217.47,38.53a36,36,0,0,0-57.95,41l-80,80a36.07,36.07,0,0,0-41,7h0a36,36,0,1,0,58,9.95l80-80a36,36,0,0,0,41-57.95Zm-145,162a12,12,0,1,1,0-17A12,12,0,0,1,72.48,200.5Zm128-128a12,12,0,0,1-17,0h0a12,12,0,1,1,17,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M81,175A24,24,0,1,1,47,175,24,24,0,0,1,81,175ZM209,47A24,24,0,1,0,209,81,24,24,0,0,0,209,47Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M214.64,41.36a32,32,0,0,0-50.2,38.89L80.25,164.44a32.06,32.06,0,0,0-38.89,4.94h0a32,32,0,1,0,50.2,6.37l84.19-84.19a32,32,0,0,0,38.89-50.2Zm-139.33,162a16,16,0,0,1-22.64-22.64h0a16,16,0,0,1,22.63,0h0A16,16,0,0,1,75.31,203.33Zm128-128a16,16,0,1,1,0-22.63A16,16,0,0,1,203.33,75.3Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M211.81,83.79a28,28,0,0,1-33.12,4.83L88.62,178.69a28,28,0,1,1-44.43-6.48h0a28,28,0,0,1,33.12-4.83l90.07-90.07a28,28,0,1,1,44.43,6.48Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M213.23,42.77A30,30,0,0,0,167,80.54L80.54,167a30.07,30.07,0,0,0-37.77,3.81h0A30,30,0,1,0,89,175.46L175.46,89a30,30,0,0,0,37.77-46.25Zm-136.51,162a18,18,0,1,1,0-25.46A18,18,0,0,1,76.72,204.74Zm128-128a18,18,0,0,1-25.46,0h0a18,18,0,1,1,25.46,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M214.64,41.36a32,32,0,0,0-50.2,38.89L80.25,164.44a32.06,32.06,0,0,0-38.89,4.94h0a32,32,0,1,0,50.2,6.37l84.19-84.19a32,32,0,0,0,38.89-50.2Zm-139.33,162a16,16,0,0,1-22.64-22.64h0a16,16,0,0,1,22.63,0h0A16,16,0,0,1,75.31,203.33Zm128-128a16,16,0,1,1,0-22.63A16,16,0,0,1,203.33,75.3Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M211.81,44.19a28,28,0,0,0-42.23,36.57L80.76,169.58a28,28,0,0,0-36.57,2.63h0a28,28,0,1,0,42.23,3l88.82-88.82a28,28,0,0,0,36.57-42.23Zm-133.67,162a20,20,0,1,1,0-28.28A20,20,0,0,1,78.14,206.15Zm128-128a20,20,0,0,1-28.28,0h0a20,20,0,1,1,28.28,0Z" }))
  ]
]), mo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,36H160a20,20,0,0,0-20,20v88a12,12,0,0,1-24,0V56A20,20,0,0,0,96,36H56A20,20,0,0,0,36,56v88a92,92,0,0,0,92,92h.71c50.34-.38,91.3-42.1,91.3-93V56A20,20,0,0,0,200,36Zm-4,24V84H164V60ZM92,60V84H60V60Zm36.52,152H128a68,68,0,0,1-68-68V108H92v36a36,36,0,0,0,72,0V108h32v35C196,180.77,165.73,211.72,128.52,212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M104,56V96H48V56a8,8,0,0,1,8-8H96A8,8,0,0,1,104,56Zm96-8H160a8,8,0,0,0-8,8V96h56V56A8,8,0,0,0,200,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a88,88,0,0,0,88,88h.67c48.15-.36,87.33-40.29,87.33-89V56A16,16,0,0,0,200,40Zm0,16V88H160V56ZM96,56V88H56V56Zm32.55,160A72,72,0,0,1,56,144V104H96v40a32,32,0,0,0,64,0V104h40v39C200,183,168,215.71,128.55,216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a88,88,0,0,0,88,88h.67c48.15-.36,87.33-40.29,87.33-89V56A16,16,0,0,0,200,40Zm0,16V96H160V56ZM96,56V96H56V56Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,42H160a14,14,0,0,0-14,14v88a18,18,0,0,1-36,0V56A14,14,0,0,0,96,42H56A14,14,0,0,0,42,56v88a86,86,0,0,0,86,86h.65c47.06-.35,85.35-39.38,85.35-87V56A14,14,0,0,0,200,42ZM160,54h40a2,2,0,0,1,2,2V90H158V56A2,2,0,0,1,160,54ZM56,54H96a2,2,0,0,1,2,2V90H54V56A2,2,0,0,1,56,54Zm72.56,164H128a74,74,0,0,1-74-74V102H98v42a30,30,0,0,0,60,0V102h44v41C202,184.05,169.06,217.7,128.56,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a88,88,0,0,0,88,88h.67c48.15-.36,87.33-40.29,87.33-89V56A16,16,0,0,0,200,40Zm0,16V88H160V56ZM96,56V88H56V56Zm32.55,160A72,72,0,0,1,56,144V104H96v40a32,32,0,0,0,64,0V104h40v39C200,183,168,215.71,128.55,216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,44H160a12,12,0,0,0-12,12v88a20,20,0,0,1-40,0V56A12,12,0,0,0,96,44H56A12,12,0,0,0,44,56v88a84,84,0,0,0,84,84h.64c46-.34,83.36-38.47,83.36-85V56A12,12,0,0,0,200,44Zm-40,8h40a4,4,0,0,1,4,4V92H156V56A4,4,0,0,1,160,52ZM56,52H96a4,4,0,0,1,4,4V92H52V56A4,4,0,0,1,56,52Zm72.58,168H128a76,76,0,0,1-76-76V100h48v44a28,28,0,0,0,56,0V100h48v43C204,185.15,170.17,219.69,128.58,220Z" }))
  ]
]), po = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z" }))
  ]
]), fo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,60a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,60Zm0,64a20,20,0,1,1,20-20A20,20,0,0,1,128,124Zm0-112a92.1,92.1,0,0,0-92,92c0,77.36,81.64,135.4,85.12,137.83a12,12,0,0,0,13.76,0,259,259,0,0,0,42.18-39C205.15,170.57,220,136.37,220,104A92.1,92.1,0,0,0,128,12Zm31.3,174.71A249.35,249.35,0,0,1,128,216.89a249.35,249.35,0,0,1-31.3-30.18C80,167.37,60,137.31,60,104a68,68,0,0,1,136,0C196,137.31,176,167.37,159.3,186.71Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M128,24a80,80,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80,80,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,16a88.1,88.1,0,0,0-88,88c0,75.3,80,132.17,83.41,134.55a8,8,0,0,0,9.18,0C136,236.17,216,179.3,216,104A88.1,88.1,0,0,0,128,16Zm0,56a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,66a38,38,0,1,0,38,38A38,38,0,0,0,128,66Zm0,64a26,26,0,1,1,26-26A26,26,0,0,1,128,130Zm0-112a86.1,86.1,0,0,0-86,86c0,30.91,14.34,63.74,41.47,94.94a252.32,252.32,0,0,0,41.09,38,6,6,0,0,0,6.88,0,252.32,252.32,0,0,0,41.09-38c27.13-31.2,41.47-64,41.47-94.94A86.1,86.1,0,0,0,128,18Zm0,206.51C113,212.93,54,163.62,54,104a74,74,0,0,1,148,0C202,163.62,143,212.93,128,224.51Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,68a36,36,0,1,0,36,36A36,36,0,0,0,128,68Zm0,64a28,28,0,1,1,28-28A28,28,0,0,1,128,132Zm0-112a84.09,84.09,0,0,0-84,84c0,30.42,14.17,62.79,41,93.62a250,250,0,0,0,40.73,37.66,4,4,0,0,0,4.58,0A250,250,0,0,0,171,197.62c26.81-30.83,41-63.2,41-93.62A84.09,84.09,0,0,0,128,20Zm37.1,172.23A254.62,254.62,0,0,1,128,227a254.62,254.62,0,0,1-37.1-34.81C73.15,171.8,52,139.9,52,104a76,76,0,0,1,152,0C204,139.9,182.85,171.8,165.1,192.23Z" }))
  ]
]), ho = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M233.47,97.45a36,36,0,0,0-50.92-50.92h0a36.18,36.18,0,0,0-4.12,4.95l-22.55-6.15a36,36,0,0,0-61.34-22.8h0a36.05,36.05,0,0,0-7.8,39.24L57.19,88.37a36.08,36.08,0,0,0-42.66,6.17h0a36,36,0,0,0,45.73,55.21l65.28,47.87A36,36,0,1,0,182.62,180L208,108A35.91,35.91,0,0,0,233.47,97.45Zm-93.74,80.81L74.45,130.39a36.19,36.19,0,0,0-1.21-24.17L102.8,79.61a36,36,0,0,0,42.66-6.16,35.47,35.47,0,0,0,4.12-5l22.55,6.15a35.86,35.86,0,0,0,10.42,22.8A38.06,38.06,0,0,0,185.4,100L160,172A36,36,0,0,0,139.73,178.26ZM216.5,63.5a12,12,0,1,1-17,0A12,12,0,0,1,216.5,63.5Zm-105-24a12,12,0,1,1,0,17A12,12,0,0,1,111.51,39.5Zm-80,89a12,12,0,1,1,17,0A12,12,0,0,1,31.5,128.49Zm137,88a12,12,0,1,1,0-17A12,12,0,0,1,168.49,216.5Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M137,65A24,24,0,1,1,137,31,24,24,0,0,1,137,65ZM23,103A24,24,0,1,0,57,103,24,24,0,0,0,23,103Zm120,88A24,24,0,1,0,177,191,24,24,0,0,0,143,191ZM225,55A24,24,0,1,0,225,89,24,24,0,0,0,225,55Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M230.64,49.36a32,32,0,0,0-45.26,0h0a31.9,31.9,0,0,0-5.16,6.76L152,48.42A32,32,0,0,0,97.37,25.36h0a32.06,32.06,0,0,0-5.76,37.41L57.67,93.32a32.05,32.05,0,0,0-40.31,4.05h0a32,32,0,0,0,42.89,47.41l70,51.36a32,32,0,1,0,47.57-14.69l27.39-77.59q1.38.12,2.76.12a32,32,0,0,0,22.63-54.62Zm-122-12.69h0a16,16,0,1,1,0,22.64A16,16,0,0,1,108.68,36.67Zm-80,94.65a16,16,0,0,1,0-22.64h0a16,16,0,1,1,0,22.64Zm142.65,88a16,16,0,0,1-22.63-22.63h0a16,16,0,1,1,22.63,22.63Zm-8.55-43.18a32,32,0,0,0-23,7.08l-70-51.36a32.17,32.17,0,0,0-1.34-26.65l33.95-30.55a32,32,0,0,0,45.47-10.81L176,71.56a32,32,0,0,0,14.12,27Zm56.56-92.84A16,16,0,1,1,196.7,60.68h0a16,16,0,0,1,22.63,22.63Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M227.81,52.19a28,28,0,0,0-39.6,0h0a28.14,28.14,0,0,0-4,5L148,47.33A28,28,0,0,0,100.2,28.19h0A28,28,0,0,0,94.7,60L54.58,96.1a28,28,0,0,0-34.39,4.1h0a28,28,0,0,0,36.7,42.12l76.75,56.28a28,28,0,1,0,46.17-10.39,27.66,27.66,0,0,0-3.33-2.84L206.63,100q.69,0,1.38,0a28,28,0,0,0,19.8-47.79ZM161.39,180.05a28,28,0,0,0-18.29,5.64L66.36,129.41A28.15,28.15,0,0,0,65.29,108l40.12-36.11a28,28,0,0,0,38.37-9.12L180,72.66a27.88,27.88,0,0,0,8.17,19.13,28.61,28.61,0,0,0,3.32,2.85Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M229.23,50.78a30,30,0,0,0-42.44,0h0a29.82,29.82,0,0,0-5.56,7.69l-31.31-8.54A30,30,0,0,0,98.78,26.77h0A30.09,30.09,0,0,0,94.13,63.2L57.83,95.87a30.07,30.07,0,0,0-39.06,2.91h0a30,30,0,0,0,41.38,43.44l72.6,53.25a30,30,0,1,0,48.47-8.68,29.65,29.65,0,0,0-5.77-4.5l28.44-80.59A31.57,31.57,0,0,0,208,102a30,30,0,0,0,21.22-51.2Zm-122-15.52a18,18,0,1,1,0,25.46A18,18,0,0,1,107.27,35.26Zm-80,97.47a18,18,0,1,1,25.46,0A18,18,0,0,1,27.26,132.73Zm145.47,88a18,18,0,1,1,0-25.46A18,18,0,0,1,172.73,220.74Zm-8.61-42.43a30,30,0,0,0-24.27,7.48L67.24,132.54a30.14,30.14,0,0,0-1.38-27.75l36.3-32.67a30,30,0,0,0,44.62-10.61l31.31,8.54a30,30,0,0,0,8.7,23.16,30.47,30.47,0,0,0,5.78,4.51Zm56.62-93.59a18,18,0,1,1,0-25.46A18,18,0,0,1,220.74,84.72Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M230.64,49.36a32,32,0,0,0-45.26,0h0a31.9,31.9,0,0,0-5.16,6.76L152,48.42A32,32,0,0,0,97.37,25.36h0a32.06,32.06,0,0,0-5.76,37.41L57.67,93.32a32.05,32.05,0,0,0-40.31,4.05h0a32,32,0,0,0,42.89,47.41l70,51.36a32,32,0,1,0,47.57-14.69l27.39-77.59q1.38.12,2.76.12a32,32,0,0,0,22.63-54.62Zm-122-12.69h0a16,16,0,1,1,0,22.64A16,16,0,0,1,108.68,36.67Zm-80,94.65a16,16,0,0,1,0-22.64h0a16,16,0,1,1,0,22.64Zm142.65,88a16,16,0,0,1-22.63-22.63h0a16,16,0,1,1,22.63,22.63Zm-8.55-43.18a32,32,0,0,0-23,7.08l-70-51.36a32.17,32.17,0,0,0-1.34-26.65l33.95-30.55a32,32,0,0,0,45.47-10.81L176,71.56a32,32,0,0,0,14.12,27Zm56.56-92.84A16,16,0,1,1,196.7,60.68h0a16,16,0,0,1,22.63,22.63Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M227.81,52.19a28,28,0,0,0-39.6,0h0a27.84,27.84,0,0,0-5.88,8.65l-34.56-9.42A28,28,0,0,0,100.2,28.19h0a28.05,28.05,0,0,0-3.48,35.37L57.91,98.49a28,28,0,0,0-37.72,1.71h0a28,28,0,0,0,39.6,39.6l.18-.19,75.32,55.24A28,28,0,1,0,173,183.2l29.56-83.75A28.52,28.52,0,0,0,208,100a28,28,0,0,0,19.8-47.79ZM105.86,33.85a20,20,0,1,1,0,28.29A20,20,0,0,1,105.86,33.85Zm-80,100.29a20,20,0,1,1,28.28,0A20,20,0,0,1,25.85,134.14Zm148.3,88a20,20,0,1,1,0-28.28A20,20,0,0,1,174.15,222.15Zm-8.7-41.6a28,28,0,0,0-25.25,7.66h0l-.18.19L64.71,133.16a28.13,28.13,0,0,0-1.44-28.73L102.08,69.5a28,28,0,0,0,43.6-10.36l34.56,9.43a28,28,0,0,0,8,23.22,27.64,27.64,0,0,0,6.8,5Zm56.7-94.41a20,20,0,1,1,0-28.29A20,20,0,0,1,222.15,86.14Z" }))
  ]
]), go = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,36H40A20,20,0,0,0,20,56V200a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A20,20,0,0,0,216,36Zm-4,160H44V60H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M224,56V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216A8,8,0,0,1,224,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,42H40A14,14,0,0,0,26,56V200a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A14,14,0,0,0,216,42Zm2,158a2,2,0,0,1-2,2H40a2,2,0,0,1-2-2V56a2,2,0,0,1,2-2H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,44H40A12,12,0,0,0,28,56V200a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A12,12,0,0,0,216,44Zm4,156a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V56a4,4,0,0,1,4-4H216a4,4,0,0,1,4,4Z" }))
  ]
]), yo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M100,40a12,12,0,0,1,12-12h32a12,12,0,0,1,0,24H112A12,12,0,0,1,100,40Zm44,164H112a12,12,0,0,0,0,24h32a12,12,0,0,0,0-24ZM208,28H184a12,12,0,0,0,0,24h20V72a12,12,0,0,0,24,0V48A20,20,0,0,0,208,28Zm8,72a12,12,0,0,0-12,12v32a12,12,0,0,0,24,0V112A12,12,0,0,0,216,100Zm0,72a12,12,0,0,0-12,12v20H184a12,12,0,0,0,0,24h24a20,20,0,0,0,20-20V184A12,12,0,0,0,216,172ZM40,156a12,12,0,0,0,12-12V112a12,12,0,0,0-24,0v32A12,12,0,0,0,40,156Zm32,48H52V184a12,12,0,0,0-24,0v24a20,20,0,0,0,20,20H72a12,12,0,0,0,0-24ZM40,84A12,12,0,0,0,52,72V52H72a12,12,0,0,0,0-24H48A20,20,0,0,0,28,48V72A12,12,0,0,0,40,84ZM80,68h96a12,12,0,0,1,12,12v96a12,12,0,0,1-12,12H80a12,12,0,0,1-12-12V80A12,12,0,0,1,80,68Zm12,96h72V92H92Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M176,80v96H80V80Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Zm-8-96H88v80h80Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80Zm144,96V80a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8v96a8,8,0,0,0,8,8h96A8,8,0,0,0,184,176Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M106,40a6,6,0,0,1,6-6h32a6,6,0,0,1,0,12H112A6,6,0,0,1,106,40Zm38,170H112a6,6,0,0,0,0,12h32a6,6,0,0,0,0-12ZM208,34H184a6,6,0,0,0,0,12h24a2,2,0,0,1,2,2V72a6,6,0,0,0,12,0V48A14,14,0,0,0,208,34Zm8,72a6,6,0,0,0-6,6v32a6,6,0,0,0,12,0V112A6,6,0,0,0,216,106Zm0,72a6,6,0,0,0-6,6v24a2,2,0,0,1-2,2H184a6,6,0,0,0,0,12h24a14,14,0,0,0,14-14V184A6,6,0,0,0,216,178ZM40,150a6,6,0,0,0,6-6V112a6,6,0,0,0-12,0v32A6,6,0,0,0,40,150Zm32,60H48a2,2,0,0,1-2-2V184a6,6,0,0,0-12,0v24a14,14,0,0,0,14,14H72a6,6,0,0,0,0-12ZM40,78a6,6,0,0,0,6-6V48a2,2,0,0,1,2-2H72a6,6,0,0,0,0-12H48A14,14,0,0,0,34,48V72A6,6,0,0,0,40,78ZM176,182H80a6,6,0,0,1-6-6V80a6,6,0,0,1,6-6h96a6,6,0,0,1,6,6v96A6,6,0,0,1,176,182Zm-6-96H86v84h84Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Zm-8-96H88v80h80Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M108,40a4,4,0,0,1,4-4h32a4,4,0,0,1,0,8H112A4,4,0,0,1,108,40Zm36,172H112a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM208,36H184a4,4,0,0,0,0,8h24a4,4,0,0,1,4,4V72a4,4,0,0,0,8,0V48A12,12,0,0,0,208,36Zm8,72a4,4,0,0,0-4,4v32a4,4,0,0,0,8,0V112A4,4,0,0,0,216,108Zm0,72a4,4,0,0,0-4,4v24a4,4,0,0,1-4,4H184a4,4,0,0,0,0,8h24a12,12,0,0,0,12-12V184A4,4,0,0,0,216,180ZM40,148a4,4,0,0,0,4-4V112a4,4,0,0,0-8,0v32A4,4,0,0,0,40,148Zm32,64H48a4,4,0,0,1-4-4V184a4,4,0,0,0-8,0v24a12,12,0,0,0,12,12H72a4,4,0,0,0,0-8ZM40,76a4,4,0,0,0,4-4V48a4,4,0,0,1,4-4H72a4,4,0,0,0,0-8H48A12,12,0,0,0,36,48V72A4,4,0,0,0,40,76ZM180,176a4,4,0,0,1-4,4H80a4,4,0,0,1-4-4V80a4,4,0,0,1,4-4h96a4,4,0,0,1,4,4Zm-8-92H84v88h88Z" }))
  ]
]), bo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,48H180V36A28,28,0,0,0,152,8H104A28,28,0,0,0,76,36V48H40a12,12,0,0,0,0,24h4V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V72h4a12,12,0,0,0,0-24ZM100,36a4,4,0,0,1,4-4h48a4,4,0,0,1,4,4V48H100Zm88,168H68V72H188ZM116,104v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Zm48,0v64a12,12,0,0,1-24,0V104a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM112,168a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm0-120H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,50H174V40a22,22,0,0,0-22-22H104A22,22,0,0,0,82,40V50H40a6,6,0,0,0,0,12H50V208a14,14,0,0,0,14,14H192a14,14,0,0,0,14-14V62h10a6,6,0,0,0,0-12ZM94,40a10,10,0,0,1,10-10h48a10,10,0,0,1,10,10V50H94ZM194,208a2,2,0,0,1-2,2H64a2,2,0,0,1-2-2V62H194ZM110,104v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Zm48,0v64a6,6,0,0,1-12,0V104a6,6,0,0,1,12,0Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M216,52H172V40a20,20,0,0,0-20-20H104A20,20,0,0,0,84,40V52H40a4,4,0,0,0,0,8H52V208a12,12,0,0,0,12,12H192a12,12,0,0,0,12-12V60h12a4,4,0,0,0,0-8ZM92,40a12,12,0,0,1,12-12h48a12,12,0,0,1,12,12V52H92ZM196,208a4,4,0,0,1-4,4H64a4,4,0,0,1-4-4V60H196ZM108,104v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Zm48,0v64a4,4,0,0,1-8,0V104a4,4,0,0,1,8,0Z" }))
  ]
]), vo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22c6.3-11,22.52-11,28.82,0l87.46,151.87C236,202.79,228.08,216,215.46,216Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M235.07,189.09,147.61,37.22h0a22.75,22.75,0,0,0-39.22,0L20.93,189.09a21.53,21.53,0,0,0,0,21.72A22.35,22.35,0,0,0,40.55,222h174.9a22.35,22.35,0,0,0,19.6-11.19A21.53,21.53,0,0,0,235.07,189.09ZM224.66,204.8a10.46,10.46,0,0,1-9.21,5.2H40.55a10.46,10.46,0,0,1-9.21-5.2,9.51,9.51,0,0,1,0-9.72L118.79,43.21a10.75,10.75,0,0,1,18.42,0l87.46,151.87A9.51,9.51,0,0,1,224.66,204.8ZM122,144V104a6,6,0,0,1,12,0v40a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,180Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M233.34,190.09,145.88,38.22h0a20.75,20.75,0,0,0-35.76,0L22.66,190.09a19.52,19.52,0,0,0,0,19.71A20.36,20.36,0,0,0,40.54,220H215.46a20.36,20.36,0,0,0,17.86-10.2A19.52,19.52,0,0,0,233.34,190.09ZM226.4,205.8a12.47,12.47,0,0,1-10.94,6.2H40.54a12.47,12.47,0,0,1-10.94-6.2,11.45,11.45,0,0,1,0-11.72L117.05,42.21a12.76,12.76,0,0,1,21.9,0L226.4,194.08A11.45,11.45,0,0,1,226.4,205.8ZM124,144V104a4,4,0,0,1,8,0v40a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,180Z" }))
  ]
]), So = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,20A108,108,0,1,0,236,128,108.12,108.12,0,0,0,128,20Zm0,192a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,212Zm-12-80V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,172Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,26A102,102,0,1,0,230,128,102.12,102.12,0,0,0,128,26Zm0,192a90,90,0,1,1,90-90A90.1,90.1,0,0,1,128,218Zm-6-82V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,172Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M128,28A100,100,0,1,0,228,128,100.11,100.11,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.1,92.1,0,0,1,128,220Zm-4-84V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,172Z" }))
  ]
]), xo = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ t.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))
  ]
]), wr = Jr({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), se = t.forwardRef(
  (n, e) => {
    const {
      alt: a,
      color: l,
      size: s,
      weight: u,
      mirrored: d,
      children: i,
      weights: p,
      ...c
    } = n, {
      color: h = "currentColor",
      size: y,
      weight: f = "regular",
      mirrored: g = !1,
      ...w
    } = t.useContext(wr);
    return /* @__PURE__ */ t.createElement(
      "svg",
      {
        ref: e,
        xmlns: "http://www.w3.org/2000/svg",
        width: s ?? y,
        height: s ?? y,
        fill: l ?? h,
        viewBox: "0 0 256 256",
        transform: d || g ? "scale(-1, 1)" : void 0,
        ...w,
        ...c
      },
      !!a && /* @__PURE__ */ t.createElement("title", null, a),
      i,
      p.get(u ?? f)
    );
  }
);
se.displayName = "IconBase";
const vn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: eo }));
vn.displayName = "ArrowArcLeftIcon";
const Sn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: to }));
Sn.displayName = "ArrowArcRightIcon";
const Mr = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: ro }));
Mr.displayName = "CaretDownIcon";
const jr = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: no }));
jr.displayName = "CaretRightIcon";
const xn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: ao }));
xn.displayName = "CheckCircleIcon";
const _n = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: oo }));
_n.displayName = "CircleIcon";
const wn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: lo }));
wn.displayName = "CursorIcon";
const An = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: so }));
An.displayName = "DotsSixVerticalIcon";
const Ot = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: io }));
Ot.displayName = "InfoIcon";
const Cn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: co }));
Cn.displayName = "LassoIcon";
const En = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: uo }));
En.displayName = "LineSegmentIcon";
const Ln = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: mo }));
Ln.displayName = "MagnetStraightIcon";
const Mn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: po }));
Mn.displayName = "MagnifyingGlassIcon";
const jn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: fo }));
jn.displayName = "MapPinIcon";
const kn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: ho }));
kn.displayName = "PolygonIcon";
const Zn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: go }));
Zn.displayName = "RectangleIcon";
const Rn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: yo }));
Rn.displayName = "SelectionAllIcon";
const kr = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: bo }));
kr.displayName = "TrashIcon";
const Tn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: vo }));
Tn.displayName = "WarningIcon";
const In = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: So }));
In.displayName = "WarningCircleIcon";
const Vn = t.forwardRef((n, e) => /* @__PURE__ */ t.createElement(se, { ref: e, ...n, weights: xo }));
Vn.displayName = "XIcon";
function _o(n, e) {
  n.visible = e;
}
function Nn({
  layer: n,
  depth: e = 0,
  search: a = "",
  dragIndex: l,
  dragFrom: s,
  dragOver: u,
  onDragStart: d,
  onDragEnter: i,
  onDrop: p,
  onDragEnd: c
}) {
  const [h, y] = E(!1), [f, g] = E(n.visible), w = K(null), S = n.type === "group", b = S ? [...n.layers].reverse() : [], x = a.trim() ? b.filter((I) => It(I, a)) : b, [A, _] = E(null), [$, G] = E(null), R = a.trim() && b.some(
    (I) => It(I, a)
  );
  D(() => {
    R && y(!0);
  }, [R]), D(() => {
    const I = nn.watch(
      () => n.visible,
      (ne) => g(ne)
    );
    return () => I.remove();
  }, [n]);
  const X = le(
    (I) => {
      _o(n, I.target.checked);
    },
    [n]
  ), N = le(
    (I, ne) => {
      if (!S || I === ne)
        return;
      const ge = n, ae = [...ge.layers].reverse(), Le = ae[I], Me = ae[ne];
      ge.layers.reorder(Le, ge.layers.indexOf(Me));
    },
    [S, n]
  ), T = le(
    (I) => {
      A !== null && I !== A && N(A, I), _(null), G(null);
    },
    [A, N]
  ), H = le(() => {
    _(null), G(null);
  }, []), M = l !== void 0 && d !== void 0, F = M && s === l, O = M && u === l && s !== null && s !== l, B = O && (s ?? 0) > l, ee = O && (s ?? 0) < l, U = [
    Se.row,
    F ? Se.dragging : "",
    B ? Se.dropAbove : "",
    ee ? Se.dropBelow : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      role: "treeitem",
      "aria-expanded": S ? h : void 0,
      className: Se.item,
      children: [
        /* @__PURE__ */ o.jsxs(
          "div",
          {
            ref: w,
            className: U,
            style: { "--depth": e },
            onDragOver: M ? (I) => {
              I.preventDefault(), I.dataTransfer.dropEffect = "move", i?.(l);
            } : void 0,
            onDrop: M ? (I) => {
              I.preventDefault(), p?.(l);
            } : void 0,
            onDragEnd: M ? () => c?.() : void 0,
            children: [
              M && /* @__PURE__ */ o.jsx(
                "span",
                {
                  className: Se.dragHandle,
                  draggable: !0,
                  "aria-hidden": "true",
                  onDragStart: (I) => {
                    I.dataTransfer.effectAllowed = "move", w.current && I.dataTransfer.setDragImage(w.current, 10, 10), d?.(l);
                  },
                  children: /* @__PURE__ */ o.jsx(An, { size: 16, weight: "bold" })
                }
              ),
              S ? /* @__PURE__ */ o.jsx(
                "button",
                {
                  type: "button",
                  className: Se.expandBtn,
                  onClick: () => y((I) => !I),
                  "aria-label": h ? "Lukk" : "Utvid",
                  children: h ? /* @__PURE__ */ o.jsx(Mr, { size: 16, weight: "light" }) : /* @__PURE__ */ o.jsx(jr, { size: 16, weight: "light" })
                }
              ) : /* @__PURE__ */ o.jsx("span", { className: Se.spacer, "aria-hidden": !0 }),
              /* @__PURE__ */ o.jsx(
                fa,
                {
                  label: n.title || n.id,
                  checked: f,
                  onChange: X
                }
              )
            ]
          }
        ),
        S && h && /* @__PURE__ */ o.jsx("div", { role: "group", className: Se.children, children: x.map((I, ne) => /* @__PURE__ */ o.jsx(
          Nn,
          {
            layer: I,
            depth: e + 1,
            search: a,
            dragIndex: a.trim() ? void 0 : ne,
            dragFrom: a.trim() ? null : A,
            dragOver: a.trim() ? null : $,
            onDragStart: a.trim() ? void 0 : _,
            onDragEnter: a.trim() ? void 0 : G,
            onDrop: a.trim() ? void 0 : T,
            onDragEnd: a.trim() ? void 0 : H
          },
          I.id
        )) })
      ]
    }
  );
}
function It(n, e) {
  const a = e.toLowerCase();
  return (n.title || n.id).toLowerCase().includes(a) ? !0 : n.type === "group" ? n.layers.some(
    (l) => It(l, a)
  ) : !1;
}
function C1() {
  const { mapView: n } = Ee(), [e, a] = E([]), [l, s] = E(""), [u, d] = E(null), [i, p] = E(null), c = K(null);
  D(() => {
    c.current = n?.map ?? null;
  }, [n]), D(() => {
    if (!n?.map)
      return;
    const S = n.map, b = () => a([...S.layers].reverse().filter((A) => A.listMode !== "hide"));
    b();
    const x = S.layers.on("change", b);
    return () => x.remove();
  }, [n]);
  const h = le((S, b) => {
    const x = c.current;
    if (!x || S === b)
      return;
    const A = [...x.layers].reverse().filter((G) => G.listMode !== "hide"), _ = A[S], $ = A[b];
    x.layers.reorder(_, x.layers.indexOf($));
  }, []), y = le(
    (S) => {
      u !== null && S !== u && h(u, S), d(null), p(null);
    },
    [u, h]
  ), f = le(() => {
    d(null), p(null);
  }, []), g = l.trim() === "", w = l.trim() ? e.filter((S) => It(S, l)) : e;
  return /* @__PURE__ */ o.jsxs("div", { id: "layer-list-custom", className: Se.container, children: [
    /* @__PURE__ */ o.jsx("div", { className: Se.search, children: /* @__PURE__ */ o.jsx(
      "input",
      {
        type: "search",
        className: Se.searchInput,
        placeholder: "Søk etter kartlag",
        value: l,
        onChange: (S) => s(S.target.value),
        "aria-label": "Søk etter kartlag"
      }
    ) }),
    /* @__PURE__ */ o.jsx(ha, { children: w.map((S, b) => /* @__PURE__ */ o.jsx(
      Nn,
      {
        layer: S,
        search: l,
        dragIndex: g ? b : void 0,
        dragFrom: g ? u : null,
        dragOver: g ? i : null,
        onDragStart: g ? d : void 0,
        onDragEnter: g ? p : void 0,
        onDrop: g ? y : void 0,
        onDragEnd: g ? f : void 0
      },
      S.id
    )) })
  ] });
}
const wo = "https://labs.geodataonline.no/bakgrunnskart/";
function E1() {
  const n = K(null), e = K(), { mapView: a, sceneView: l, mapMode: s } = Ee(), { t: u, i18n: d } = Ie("map"), i = () => {
    const p = da.basemaps.map((c) => {
      const h = c.clone();
      if (h.title = u(c.title), c.thumbnailUrl && !c.thumbnailUrl.startsWith("http") && !c.thumbnailUrl.startsWith("data:")) {
        const y = new URL(c.thumbnailUrl, wo);
        h.thumbnailUrl = y.href;
      }
      return h;
    });
    return new wa({
      basemaps: p
    });
  };
  return D(() => {
    n.current && a && !e.current && (e.current = new _a({
      view: a,
      source: i(),
      container: n.current
    }));
  }, [a]), D(() => {
    const p = () => {
      e.current && (e.current.source = i());
    };
    return d.on("languageChanged", p), () => {
      d.off("languageChanged", p);
    };
  }, [d]), D(() => {
    e.current && (s == Be.TwoD && a ? e.current.view = a : s == Be.ThreeD && l && (e.current.view = l));
  }, [s, a, l]), /* @__PURE__ */ o.jsx("div", { id: "esri-basemap-gallery", className: "widget-container", ref: n });
}
function L1() {
  const n = K(null), e = K(), { mapView: a } = Ee();
  return D(() => (n?.current && a && (e.current = new Aa({
    view: a,
    container: n.current,
    // specify your own print service
    printServiceUrl: "https://services.geodataonline.no/arcgis/rest/services/Georapport/Kartutskrift/GPServer/Standard"
  })), () => {
  }), []), /* @__PURE__ */ o.jsx("div", { id: "print-details", className: "widget-container", ref: n });
}
function M1() {
  const n = K(null), e = K(), { mapView: a, sceneView: l, mapMode: s } = Ee();
  return D(() => (n?.current && a && (e.current = new Ca({
    view: a,
    container: n.current
  })), () => {
  }), []), D(() => {
    e.current && (s == Be.TwoD && a ? e.current.view = a : s == Be.ThreeD && l && (e.current.view = l));
  }, [s, a, l]), /* @__PURE__ */ o.jsx("div", { className: "widget-container", ref: n });
}
const j1 = ({ children: n }) => {
  const [e, a] = E([]), l = (u, d, i) => {
    const p = i || `flow-item-${Date.now()}`;
    a((c) => [...c, { content: u, heading: d, id: p }]);
  }, s = (u) => new Promise((d) => {
    a((i) => i.slice(0, u)), setTimeout(() => d(), 50);
  });
  return /* @__PURE__ */ o.jsxs(Wn, { children: [
    /* @__PURE__ */ o.jsx(Rr, { heading: "", children: n(l) }),
    e.map((u, d) => /* @__PURE__ */ o.jsx(
      Rr,
      {
        heading: u.heading,
        beforeBack: () => s(d),
        children: u.content
      },
      u.id
    ))
  ] });
}, Ao = "NumberInput-module__controlGroup___9vmMM", Co = "NumberInput-module__slider___KzgW5", Eo = "NumberInput-module__numberInput___0mrur", mr = {
  controlGroup: Ao,
  slider: Co,
  numberInput: Eo
}, Fe = ({ value: n, onChange: e, min: a, max: l, step: s = 1, suffix: u }) => /* @__PURE__ */ o.jsxs("div", { className: mr.controlGroup, children: [
  /* @__PURE__ */ o.jsx(
    gt,
    {
      min: a ?? 0,
      max: l ?? 100,
      value: n,
      step: s,
      className: mr.slider,
      onCalciteSliderChange: (d) => {
        e(d.target.value);
      }
    }
  ),
  /* @__PURE__ */ o.jsx(
    jt,
    {
      value: n.toString(),
      scale: "s",
      numberButtonType: "vertical",
      className: mr.numberInput,
      suffixText: u,
      min: a,
      max: l,
      step: s,
      onCalciteInputNumberChange: (d) => {
        const i = Number(d.target.value);
        if (!isNaN(i)) {
          const p = Math.min(l ?? 1 / 0, Math.max(a ?? -1 / 0, i));
          e(p);
        }
      }
    }
  )
] }), Lo = "ColorControl-module__colorControl___rEpEZ", Mo = "ColorControl-module__colorSwatchContainer___s8Q-J", jo = "ColorControl-module__colorSwatch___98gCl", ko = "ColorControl-module__colorPickerPopover___-tUEA", wt = {
  colorControl: Lo,
  colorSwatchContainer: Mo,
  colorSwatch: jo,
  colorPickerPopover: ko
}, vt = ({ color: n, opacity: e = 100, onChange: a, buttonId: l }) => {
  const { t: s } = Ie(["drawing", "common"]);
  return /* @__PURE__ */ o.jsxs("div", { className: wt.colorControl, children: [
    /* @__PURE__ */ o.jsxs("div", { className: wt.colorSwatchContainer, children: [
      /* @__PURE__ */ o.jsx(
        "div",
        {
          className: wt.colorSwatch,
          style: { "--swatch-color": n, "--swatch-opacity": e / 100 }
        }
      ),
      /* @__PURE__ */ o.jsx(
        Yn,
        {
          id: l,
          appearance: "transparent",
          iconStart: "pencil",
          title: s("drawing:colorControl.clickToSelectColor"),
          "aria-label": s("drawing:colorControl.openColorPicker"),
          scale: "s"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsx(
      Kn,
      {
        placement: "bottom-start",
        referenceElement: l,
        overlayPositioning: "fixed",
        autoClose: !0,
        className: wt.colorPickerPopover,
        children: /* @__PURE__ */ o.jsx(
          en,
          {
            value: n,
            onCalciteColorPickerChange: (u) => a(u.target.value)
          }
        )
      }
    )
  ] });
}, Zo = ({ sketchVM: n }) => {
  const e = () => {
    const f = n.polylineSymbol;
    if (f) {
      const g = (S) => S ? Array.isArray(S) ? `#${S[0].toString(16).padStart(2, "0")}${S[1].toString(16).padStart(2, "0")}${S[2].toString(16).padStart(2, "0")}` : `#${S.r.toString(16).padStart(2, "0")}${S.g.toString(16).padStart(2, "0")}${S.b.toString(16).padStart(2, "0")}` : "#00ff00", w = (S) => {
        if (!S)
          return 25;
        let b;
        return Array.isArray(S) ? b = S[3] / 255 : b = S.a ?? 1, 100 - b * 100;
      };
      return {
        color: g(f.color),
        opacity: w(f.color),
        width: f.width || 1,
        style: f.style || "solid"
      };
    }
    return { color: "#00ff00", opacity: 100, width: 2, style: "solid" };
  };
  D(() => {
    const f = e();
    s(f.color), d(f.opacity), p(f.width), h(f.style);
  }, [n.polylineSymbol]);
  const a = e(), [l, s] = E(a.color), [u, d] = E(a.opacity), [i, p] = E(a.width), [c, h] = E(a.style), y = (f = c, g = u, w = i, S = l) => {
    console.log("PolylineSymbolSettings.updateSymbol called");
    const x = {
      type: "simple-line",
      color: (() => {
        const A = parseInt(S.slice(1, 3), 16), _ = parseInt(S.slice(3, 5), 16), $ = parseInt(S.slice(5, 7), 16);
        return [A, _, $, (100 - g) / 100];
      })(),
      width: w,
      style: f
    };
    console.log("Setting polylineSymbol:", x), n.polylineSymbol = x, console.log("After setting polylineSymbol:", n.polylineSymbol);
  };
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Stil",
      /* @__PURE__ */ o.jsxs(
        $t,
        {
          scale: "s",
          value: c,
          onCalciteSelectChange: (f) => {
            const g = f.target.value;
            h(g), y(g, u, i, l);
          },
          children: [
            /* @__PURE__ */ o.jsx(ue, { value: "solid", children: "Heltrukket" }),
            /* @__PURE__ */ o.jsx(ue, { value: "dash", children: "Stiplet" }),
            /* @__PURE__ */ o.jsx(ue, { value: "dot", children: "Prikket" }),
            /* @__PURE__ */ o.jsx(ue, { value: "dash-dot", children: "Strek-prikk" }),
            /* @__PURE__ */ o.jsx(ue, { value: "dash-dot-dot", children: "Strek-prikk-prikk" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Farge",
      /* @__PURE__ */ o.jsx(
        vt,
        {
          color: l,
          opacity: 100 - u,
          onChange: (f) => {
            s(f), y(c, u, i, f);
          },
          buttonId: "lineColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Gjennomsiktighet",
      /* @__PURE__ */ o.jsx(
        Fe,
        {
          value: u,
          onChange: (f) => {
            d(f), y(c, f, i, l);
          },
          min: 0,
          max: 100,
          step: 1,
          suffix: "%"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Bredde",
      /* @__PURE__ */ o.jsx(
        Fe,
        {
          value: i,
          onChange: (f) => {
            p(f), y(c, u, f, l);
          },
          min: 0,
          max: 10,
          step: 0.5,
          suffix: "piksler"
        }
      )
    ] })
  ] });
}, Ro = ({ sketchVM: n }) => {
  const a = (() => {
    const b = n.polygonSymbol;
    if (b) {
      const x = (_) => _ ? Array.isArray(_) ? `#${_[0].toString(16).padStart(2, "0")}${_[1].toString(16).padStart(2, "0")}${_[2].toString(16).padStart(2, "0")}` : `#${_.r.toString(16).padStart(2, "0")}${_.g.toString(16).padStart(2, "0")}${_.b.toString(16).padStart(2, "0")}` : "#000000", A = (_) => {
        if (!_)
          return 25;
        let $;
        return Array.isArray(_) ? $ = _[3] / 255 : $ = _.a ?? 1, 100 - $ * 100;
      };
      return {
        fillColor: x(b.color),
        fillOpacity: A(b.color),
        outlineColor: b.outline ? x(b.outline.color) : "#000000",
        outlineOpacity: b.outline ? A(b.outline.color) : 0,
        // 0% transparency = fully opaque
        outlineWidth: b.outline && b.outline.width ? b.outline.width : 1,
        fillStyle: b.style || "solid"
      };
    }
    return {
      fillColor: "#000000",
      fillOpacity: 100,
      outlineColor: "#000000",
      outlineOpacity: 100,
      outlineWidth: 1,
      fillStyle: "solid"
    };
  })(), [l, s] = E(a.fillColor), [u, d] = E(a.fillOpacity), [i, p] = E(a.outlineColor), [c, h] = E(a.outlineOpacity), [y, f] = E(a.outlineWidth), [g, w] = E(a.fillStyle), S = (b = g, x = u, A = c, _ = l, $ = i, G = y) => {
    console.log("PolygonSymbolSettings.updateSymbol called");
    const R = () => {
      const T = parseInt(_.slice(1, 3), 16), H = parseInt(_.slice(3, 5), 16), M = parseInt(_.slice(5, 7), 16);
      return [T, H, M, (100 - x) / 100];
    }, X = () => {
      const T = parseInt($.slice(1, 3), 16), H = parseInt($.slice(3, 5), 16), M = parseInt($.slice(5, 7), 16);
      return [T, H, M, (100 - A) / 100];
    }, N = {
      type: "simple-fill",
      color: R(),
      style: b,
      outline: {
        color: X(),
        width: G
      }
    };
    console.log("Setting polygonSymbol:", N), n.polygonSymbol = N, console.log("After setting polygonSymbol:", n.polygonSymbol);
  };
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Fyllfarge",
      /* @__PURE__ */ o.jsx(
        vt,
        {
          color: l,
          opacity: 100 - u,
          onChange: (b) => {
            s(b), S(g, u, c, b, i, y);
          },
          buttonId: "fillColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Fyllgjennomsiktighet",
      /* @__PURE__ */ o.jsx(
        Fe,
        {
          value: u,
          onChange: (b) => {
            d(b), S(g, b, c, l, i, y);
          },
          min: 0,
          max: 100,
          step: 1,
          suffix: "%"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Omrissfarge",
      /* @__PURE__ */ o.jsx(
        vt,
        {
          color: i,
          opacity: 100 - c,
          onChange: (b) => {
            p(b), S(g, u, c, l, b, y);
          },
          buttonId: "outlineColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Omrissgjennomsiktighet",
      /* @__PURE__ */ o.jsx(
        Fe,
        {
          value: c,
          onChange: (b) => {
            h(b), S(g, u, b, l, i, y);
          },
          min: 0,
          max: 100,
          step: 1,
          suffix: "%"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Omrissbredde",
      /* @__PURE__ */ o.jsx(
        Fe,
        {
          value: y,
          onChange: (b) => {
            f(b), S(g, u, c, l, i, b);
          },
          min: 0,
          max: 10,
          step: 0.5,
          suffix: "piksler"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Mønster",
      /* @__PURE__ */ o.jsxs(
        $t,
        {
          scale: "s",
          value: g,
          onCalciteSelectChange: (b) => {
            const x = b.target.value;
            w(x), S(x, u, c, l, i, y);
          },
          children: [
            /* @__PURE__ */ o.jsx(ue, { value: "solid", children: "Heldekkende" }),
            /* @__PURE__ */ o.jsx(ue, { value: "horizontal", children: "Horisontale linjer" }),
            /* @__PURE__ */ o.jsx(ue, { value: "vertical", children: "Vertikale linjer" }),
            /* @__PURE__ */ o.jsx(ue, { value: "diagonal", children: "Skrå linjer" }),
            /* @__PURE__ */ o.jsx(ue, { value: "cross", children: "Kryss" }),
            /* @__PURE__ */ o.jsx(ue, { value: "diagonal-cross", children: "Kryss skrå" }),
            /* @__PURE__ */ o.jsx(ue, { value: "none", children: "Ingen fyll" })
          ]
        }
      )
    ] })
  ] });
}, dr = [
  {
    name: "Sirkel",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          anchorPoint: {
            x: 0,
            y: 0,
            z: 0
          },
          anchorPointUnits: "Relative",
          dominantSizeAxis3D: "Y",
          size: 10,
          billboardMode3D: "FaceNearPlane",
          frame: {
            xmin: -5,
            ymin: -5,
            xmax: 5,
            ymax: 5
          },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: {
                rings: [
                  [
                    [
                      0,
                      5
                    ],
                    [
                      0.87,
                      4.92
                    ],
                    [
                      1.71,
                      4.7
                    ],
                    [
                      2.5,
                      4.33
                    ],
                    [
                      3.21,
                      3.83
                    ],
                    [
                      3.83,
                      3.21
                    ],
                    [
                      4.33,
                      2.5
                    ],
                    [
                      4.7,
                      1.71
                    ],
                    [
                      4.92,
                      0.87
                    ],
                    [
                      5,
                      0
                    ],
                    [
                      4.92,
                      -0.87
                    ],
                    [
                      4.7,
                      -1.71
                    ],
                    [
                      4.33,
                      -2.5
                    ],
                    [
                      3.83,
                      -3.21
                    ],
                    [
                      3.21,
                      -3.83
                    ],
                    [
                      2.5,
                      -4.33
                    ],
                    [
                      1.71,
                      -4.7
                    ],
                    [
                      0.87,
                      -4.92
                    ],
                    [
                      0,
                      -5
                    ],
                    [
                      -0.87,
                      -4.92
                    ],
                    [
                      -1.71,
                      -4.7
                    ],
                    [
                      -2.5,
                      -4.33
                    ],
                    [
                      -3.21,
                      -3.83
                    ],
                    [
                      -3.83,
                      -3.21
                    ],
                    [
                      -4.33,
                      -2.5
                    ],
                    [
                      -4.7,
                      -1.71
                    ],
                    [
                      -4.92,
                      -0.87
                    ],
                    [
                      -5,
                      -0
                    ],
                    [
                      -4.92,
                      0.87
                    ],
                    [
                      -4.7,
                      1.71
                    ],
                    [
                      -4.33,
                      2.5
                    ],
                    [
                      -3.83,
                      3.21
                    ],
                    [
                      -3.21,
                      3.83
                    ],
                    [
                      -2.5,
                      4.33
                    ],
                    [
                      -1.71,
                      4.7
                    ],
                    [
                      -0.87,
                      4.92
                    ],
                    [
                      0,
                      5
                    ]
                  ]
                ]
              },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidStroke",
                    enable: !0,
                    capStyle: "Round",
                    joinStyle: "Round",
                    lineStyle3D: "Strip",
                    miterLimit: 10,
                    width: 0.2,
                    color: [
                      0,
                      0,
                      128,
                      217
                    ]
                  },
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [
                      121,
                      121,
                      186,
                      217
                    ]
                  }
                ],
                angleAlignment: "Map"
              }
            }
          ],
          respectFrame: !0
        }
      ],
      haloSize: 1,
      scaleX: 1,
      angleAlignment: "Display"
    }
  },
  {
    name: "Kvadrat",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: { rings: [[[-5, -5], [5, -5], [5, 5], [-5, 5], [-5, -5]]] },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  },
  {
    name: "Trekant",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: { rings: [[[0, -5], [5, 5], [-5, 5], [0, -5]]] },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  },
  {
    name: "Diamant",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: { rings: [[[0, -5], [5, 0], [0, 5], [-5, 0], [0, -5]]] },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  },
  {
    name: "Kryss",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: {
                paths: [
                  [[-5, -5], [5, 5]],
                  [[5, -5], [-5, 5]]
                ]
              },
              symbol: {
                type: "CIMLineSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidStroke",
                    enable: !0,
                    width: 2,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  },
  {
    name: "Pil",
    cimJSON: {
      type: "CIMPointSymbol",
      symbolLayers: [
        {
          type: "CIMVectorMarker",
          enable: !0,
          size: 12,
          colorLocked: !1,
          frame: { xmin: -5, ymin: -5, xmax: 5, ymax: 5 },
          markerGraphics: [
            {
              type: "CIMMarkerGraphic",
              geometry: { rings: [[[0, -5], [5, 5], [0, 2], [-5, 5], [0, -5]]] },
              symbol: {
                type: "CIMPolygonSymbol",
                symbolLayers: [
                  {
                    type: "CIMSolidFill",
                    enable: !0,
                    color: [255, 0, 0, 255]
                  }
                ]
              }
            }
          ]
        }
      ]
    }
  }
], To = ({ symbol: n }) => {
  const e = K(null);
  return D(() => {
    if (!e.current || !n)
      return;
    (async () => {
      try {
        e.current.innerHTML = "";
        const l = await mn(n, { size: 40 });
        l && e.current && e.current.appendChild(l);
      } catch (l) {
        console.error("Feil ved lasting av symbolforhåndsvisning:", l);
      }
    })();
  }, [n]), /* @__PURE__ */ o.jsx("div", { ref: e });
}, Io = ({
  symbolDef: n,
  isSelected: e,
  onClick: a,
  color: l,
  size: s
}) => {
  const [u, d] = E(null);
  return D(() => {
    const i = async () => {
      try {
        const c = JSON.parse(JSON.stringify(n.cimJSON));
        c.symbolLayers && c.symbolLayers.length > 0 && (c.symbolLayers[0].size = s);
        const h = Ar(l);
        if (c.symbolLayers && c.symbolLayers.length > 0 && c.symbolLayers[0].markerGraphics && c.symbolLayers[0].markerGraphics.length > 0) {
          const g = c.symbolLayers[0].markerGraphics[0];
          g.symbol.type === "CIMPolygonSymbol" ? g.symbol.symbolLayers && g.symbol.symbolLayers.length > 0 && (g.symbol.symbolLayers[0].color = h) : g.symbol.type === "CIMLineSymbol" && g.symbol.symbolLayers && g.symbol.symbolLayers.length > 0 && (g.symbol.symbolLayers[0].color = h);
        }
        const y = new dn({
          data: {
            type: "CIMSymbolReference",
            symbol: c
          }
        }), f = await mn(y, { size: 30 });
        f && d(f);
      } catch (c) {
        console.error("Feil ved lasting av symbolforhåndsvisning:", c), p();
      }
    }, p = () => {
      const c = document.createElement("div");
      c.textContent = n.name.substring(0, 2), c.style.width = "30px", c.style.height = "30px", c.style.display = "flex", c.style.justifyContent = "center", c.style.alignItems = "center", c.style.backgroundColor = "#f0f0f0", c.style.borderRadius = "4px", c.style.fontSize = "12px", d(c);
    };
    i();
  }, [n, l, s]), /* @__PURE__ */ o.jsx(
    "button",
    {
      onClick: a,
      title: n.name,
      style: {
        border: e ? "2px solid #007ac2" : "1px solid #ccc",
        padding: 4,
        borderRadius: 4,
        background: "white",
        cursor: "pointer",
        minWidth: "40px",
        minHeight: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      children: u ? /* @__PURE__ */ o.jsx("div", { ref: (i) => i && !i.hasChildNodes() && i.appendChild(u) }) : /* @__PURE__ */ o.jsx("div", { style: { fontSize: "0.8rem" }, children: n.name })
    }
  );
}, Ar = (n, e = 0) => {
  const a = parseInt(n.slice(1, 3), 16), l = parseInt(n.slice(3, 5), 16), s = parseInt(n.slice(5, 7), 16);
  return [a, l, s, Math.round((100 - e) / 100 * 255)];
}, Vo = ({ sketchVM: n }) => {
  const { t: e } = Ie(["drawing", "common"]), l = (() => {
    const _ = n.pointSymbol;
    if (_ && _.type === "cim")
      try {
        const $ = (R) => R ? Array.isArray(R) ? `#${R[0].toString(16).padStart(2, "0")}${R[1].toString(16).padStart(2, "0")}${R[2].toString(16).padStart(2, "0")}` : `#${R.r.toString(16).padStart(2, "0")}${R.g.toString(16).padStart(2, "0")}${R.b.toString(16).padStart(2, "0")}` : "#ff0000", G = _;
        if (G.data && G.data.symbol) {
          const R = G.data.symbol;
          let X = 0, N = -1;
          dr.forEach((B, ee) => {
            let U = 0;
            if (R.type === B.cimJSON.type && (U += 5), R.symbolLayers && R.symbolLayers[0] && R.symbolLayers[0].markerGraphics && R.symbolLayers[0].markerGraphics[0] && R.symbolLayers[0].markerGraphics[0].geometry) {
              const I = R.symbolLayers[0].markerGraphics[0].geometry, ne = B.cimJSON.symbolLayers[0].markerGraphics[0].geometry;
              JSON.stringify(I) === JSON.stringify(ne) && (U += 10);
            }
            U > N && (N = U, X = ee);
          });
          let T = "#ff0000", H = 12, M = 0, F = "#000000", O = 0;
          if (R.symbolLayers && R.symbolLayers.length > 0 && (H = R.symbolLayers[0].size || 12, O = R.symbolLayers[0].rotation || 0, R.symbolLayers[0].markerGraphics && R.symbolLayers[0].markerGraphics[0] && R.symbolLayers[0].markerGraphics[0].symbol && R.symbolLayers[0].markerGraphics[0].symbol.symbolLayers)) {
            const B = R.symbolLayers[0].markerGraphics[0].symbol.symbolLayers, ee = B.find((I) => I.type === "CIMSolidFill");
            ee && ee.color && (T = $(ee.color));
            const U = B.find((I) => I.type === "CIMSolidStroke");
            U && (M = U.width || 0, U.color && (F = $(U.color)));
          }
          return {
            selectedTemplate: X,
            color: T,
            size: H,
            outlineWidth: M,
            outlineColor: F,
            rotation: O
          };
        }
      } catch ($) {
        console.error("Feil ved initialisering fra symbol:", $);
      }
    return {
      selectedTemplate: 0,
      color: "#ff0000",
      size: 12,
      outlineWidth: 0,
      outlineColor: "#000000",
      rotation: 0
    };
  })(), [s, u] = E(l.selectedTemplate), [d, i] = E(l.color), [p, c] = E(l.size), [h, y] = E(l.outlineWidth), [f, g] = E(l.outlineColor), [w, S] = E(l.rotation), [b, x] = E(null), A = () => {
    try {
      const _ = JSON.parse(JSON.stringify(dr[s].cimJSON));
      _.symbolLayers && _.symbolLayers.length > 0 && (_.symbolLayers[0].size = p), _.symbolLayers && _.symbolLayers.length > 0 && (_.symbolLayers[0].rotation = w);
      const $ = Ar(d);
      if (_.symbolLayers && _.symbolLayers.length > 0 && _.symbolLayers[0].markerGraphics && _.symbolLayers[0].markerGraphics.length > 0) {
        const R = _.symbolLayers[0].markerGraphics[0];
        if (R.symbol.type === "CIMPolygonSymbol")
          if (R.symbol.symbolLayers && R.symbol.symbolLayers.length > 0 && (R.symbol.symbolLayers[0].color = $), h > 0) {
            const X = Ar(f);
            if (R.symbol.symbolLayers.some((T) => T.type === "CIMSolidStroke")) {
              const T = R.symbol.symbolLayers.find((H) => H.type === "CIMSolidStroke");
              T && (T.width = h, T.color = X);
            } else
              R.symbol.symbolLayers.push({
                type: "CIMSolidStroke",
                enable: !0,
                width: h,
                color: X
              });
          } else
            R.symbol.symbolLayers = R.symbol.symbolLayers.filter(
              (X) => X.type !== "CIMSolidStroke"
            );
        else
          R.symbol.type === "CIMLineSymbol" && R.symbol.symbolLayers && R.symbol.symbolLayers.length > 0 && (R.symbol.symbolLayers[0].color = $, R.symbol.symbolLayers[0].width = Math.max(1, h > 0 ? h : 2));
      }
      const G = new dn({
        data: {
          type: "CIMSymbolReference",
          symbol: _
        }
      });
      n.pointSymbol = G, x(G);
    } catch (_) {
      console.error("Feil ved oppdatering av CIM symbol:", _);
    }
  };
  return D(() => {
    A();
  }, [s, d, p, h, f, w]), /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs("div", { style: { marginBottom: "1rem" }, children: [
      /* @__PURE__ */ o.jsx(re, { children: e("drawing:symbolSettings.shape") }),
      /* @__PURE__ */ o.jsx("div", { style: {
        display: "flex",
        flexWrap: "wrap",
        gap: "0.5rem",
        marginBottom: "1rem",
        maxHeight: "200px",
        overflowY: "auto"
      }, children: dr.map((_, $) => /* @__PURE__ */ o.jsx(
        Io,
        {
          symbolDef: _,
          isSelected: s === $,
          onClick: () => u($),
          color: d,
          size: p
        },
        $
      )) })
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      e("drawing:symbolSettings.color"),
      /* @__PURE__ */ o.jsx(
        vt,
        {
          color: d,
          onChange: (_) => {
            i(_);
          },
          buttonId: "cimColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      e("drawing:symbolSettings.size"),
      /* @__PURE__ */ o.jsx(
        Fe,
        {
          value: p,
          onChange: (_) => {
            c(_), A();
          },
          min: 0,
          max: 48,
          suffix: e("drawing:symbolSettings.pixels")
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      e("drawing:symbolSettings.rotation"),
      /* @__PURE__ */ o.jsx(
        Fe,
        {
          min: 0,
          max: 360,
          step: 5,
          value: w,
          suffix: "°",
          onChange: (_) => S(_)
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      e("drawing:symbolSettings.outlineWidth"),
      /* @__PURE__ */ o.jsx(
        Fe,
        {
          value: h,
          onChange: (_) => y(_),
          min: 0,
          max: 10,
          step: 0.5,
          suffix: e("drawing:symbolSettings.pixels")
        }
      )
    ] }),
    h > 0 && /* @__PURE__ */ o.jsxs(re, { children: [
      e("drawing:symbolSettings.outlineColor"),
      /* @__PURE__ */ o.jsx(
        vt,
        {
          color: f,
          onChange: (_) => {
            g(_);
          },
          buttonId: "cimOutlineColorBtn"
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs("div", { style: { marginTop: "1rem" }, children: [
      /* @__PURE__ */ o.jsx(re, { children: e("drawing:symbolSettings.preview") }),
      /* @__PURE__ */ o.jsx(
        "div",
        {
          style: {
            width: "100%",
            height: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid #ccc",
            borderRadius: "4px",
            backgroundColor: "#f8f8f8"
          },
          children: /* @__PURE__ */ o.jsx(To, { symbol: b })
        }
      )
    ] })
  ] });
}, No = "TextSymbolSettings-module__controlGroup___Yk6df", Fo = "TextSymbolSettings-module__textSizeControl___21mYq", $o = "TextSymbolSettings-module__slider___KthKX", Ho = "TextSymbolSettings-module__numberInput___DyJCZ", Oo = "TextSymbolSettings-module__colorControl___RGsRV", Po = "TextSymbolSettings-module__colorInputGroup___RG6TL", Do = "TextSymbolSettings-module__colorSwatch___1N1OE", zo = "TextSymbolSettings-module__colorValue___U7-YB", ye = {
  controlGroup: No,
  textSizeControl: Fo,
  slider: $o,
  numberInput: Ho,
  colorControl: Oo,
  colorInputGroup: Po,
  colorSwatch: Do,
  colorValue: zo
}, Go = {
  small: 12,
  medium: 18,
  large: 24
}, Bo = ({ sketchVM: n }) => {
  const a = (() => {
    const b = n.textSymbol;
    if (b) {
      const x = (_) => _ ? Array.isArray(_) ? `#${_[0].toString(16).padStart(2, "0")}${_[1].toString(16).padStart(2, "0")}${_[2].toString(16).padStart(2, "0")}` : `#${_.r.toString(16).padStart(2, "0")}${_.g.toString(16).padStart(2, "0")}${_.b.toString(16).padStart(2, "0")}` : "#000000", A = (_) => _ ? Array.isArray(_) ? _[3] / 255 * 100 : (_.a ?? 1) * 100 : 100;
      return {
        fontFamily: b.font ? b.font.family : "Arial",
        fontSize: b.font ? b.font.size : 12,
        color: x(b.color),
        opacity: A(b.color),
        rotation: b.angle || 0
      };
    }
    return {
      fontFamily: "Arial",
      fontSize: 12,
      color: "#000000",
      opacity: 100,
      rotation: 0
    };
  })(), [l, s] = E(a.fontFamily), [u, d] = E(a.fontSize), [i, p] = E(() => a.fontSize <= 12 ? "small" : a.fontSize >= 24 ? "large" : "medium"), [c, h] = E(a.color), [y, f] = E(a.opacity), [g, w] = E(a.rotation);
  D(() => {
    const b = Go[i];
    d(b), S(b);
  }, [i]);
  const S = (b) => {
    const x = {
      type: "text",
      text: "",
      // This will be set by the SketchViewModel
      font: {
        family: l,
        size: b || u,
        style: "normal",
        weight: "normal"
      },
      // Convert transparency to opacity (opacity = 100 - transparency)
      color: [
        parseInt(c.slice(1, 3), 16),
        parseInt(c.slice(3, 5), 16),
        parseInt(c.slice(5, 7), 16),
        (100 - y) / 100
      ],
      haloSize: 1,
      haloColor: [255, 255, 255, 0.5],
      angle: g
    };
    n.textSymbol = x;
  };
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Font",
      /* @__PURE__ */ o.jsxs(
        $t,
        {
          scale: "s",
          value: l,
          onCalciteSelectChange: (b) => {
            s(b.target.value), S();
          },
          children: [
            /* @__PURE__ */ o.jsx(ue, { value: "Arial", children: "Arial" }),
            /* @__PURE__ */ o.jsx(ue, { value: "Arial Black", children: "Arial Black" }),
            /* @__PURE__ */ o.jsx(ue, { value: "Helvetica", children: "Helvetica" }),
            /* @__PURE__ */ o.jsx(ue, { value: "Times New Roman", children: "Times New Roman" }),
            /* @__PURE__ */ o.jsx(ue, { value: "Courier New", children: "Courier New" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Størrelse",
      /* @__PURE__ */ o.jsx("div", { className: ye.textSizeControl, children: /* @__PURE__ */ o.jsxs(
        tn,
        {
          width: "full",
          scale: "s",
          value: i,
          onCalciteSegmentedControlChange: (b) => {
            p(b.target.value);
          },
          children: [
            /* @__PURE__ */ o.jsx(Ke, { value: "small", checked: i === "small", children: "Liten" }),
            /* @__PURE__ */ o.jsx(Ke, { value: "medium", checked: i === "medium", children: "Medium" }),
            /* @__PURE__ */ o.jsx(Ke, { value: "large", checked: i === "large", children: "Stor" })
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Egendefinert størrelse",
      /* @__PURE__ */ o.jsxs("div", { className: ye.controlGroup, children: [
        /* @__PURE__ */ o.jsx(
          gt,
          {
            min: 8,
            max: 48,
            value: u,
            step: 1,
            className: ye.slider,
            onCalciteSliderChange: (b) => {
              const x = Number(b.target.value);
              d(x), x <= 12 ? p("small") : x >= 24 ? p("large") : p("medium"), S(x);
            }
          }
        ),
        /* @__PURE__ */ o.jsx(
          jt,
          {
            value: u.toString(),
            scale: "s",
            numberButtonType: "horizontal",
            className: ye.numberInput,
            suffixText: "pt",
            min: 8,
            max: 48,
            step: 1,
            onCalciteInputNumberChange: (b) => {
              const x = Math.min(48, Math.max(8, Number(b.target.value)));
              d(x), x <= 12 ? p("small") : x >= 24 ? p("large") : p("medium"), S(x);
            }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Farge",
      /* @__PURE__ */ o.jsx("div", { className: ye.colorControl, children: /* @__PURE__ */ o.jsxs("div", { className: ye.colorInputGroup, children: [
        /* @__PURE__ */ o.jsx(
          "div",
          {
            className: ye.colorSwatch,
            style: { "--swatch-color": c, "--swatch-opacity": y / 100 }
          }
        ),
        /* @__PURE__ */ o.jsx("span", { className: ye.colorValue, children: c }),
        /* @__PURE__ */ o.jsx(
          en,
          {
            value: c,
            onCalciteColorPickerChange: (b) => {
              h(b.target.value), S();
            }
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Gjennomsiktighet",
      /* @__PURE__ */ o.jsxs("div", { className: ye.controlGroup, children: [
        /* @__PURE__ */ o.jsx(
          gt,
          {
            min: 0,
            max: 100,
            value: y,
            step: 1,
            className: ye.slider,
            onCalciteSliderChange: (b) => {
              f(Number(b.target.value)), S();
            }
          }
        ),
        /* @__PURE__ */ o.jsx(
          jt,
          {
            value: y.toString(),
            scale: "s",
            numberButtonType: "horizontal",
            className: ye.numberInput,
            suffixText: "%",
            min: 0,
            max: 100,
            step: 1,
            onCalciteInputNumberChange: (b) => {
              const x = Math.min(100, Math.max(0, Number(b.target.value)));
              f(x), S();
            }
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Rotasjon",
      /* @__PURE__ */ o.jsxs("div", { className: ye.controlGroup, children: [
        /* @__PURE__ */ o.jsx(
          gt,
          {
            min: 0,
            max: 360,
            value: g,
            step: 5,
            className: ye.slider,
            onCalciteSliderChange: (b) => {
              w(Number(b.target.value)), S();
            }
          }
        ),
        /* @__PURE__ */ o.jsx(
          jt,
          {
            value: g.toString(),
            scale: "s",
            numberButtonType: "horizontal",
            className: ye.numberInput,
            suffixText: "°",
            min: 0,
            max: 360,
            step: 5,
            onCalciteInputNumberChange: (b) => {
              const x = Number(b.target.value) % 360;
              w(x), S();
            }
          }
        )
      ] })
    ] })
  ] });
}, Uo = ({
  options: n,
  onChange: e,
  geometryType: a,
  selectedGraphic: l
}) => {
  const [s, u] = E(n?.precision ?? 2), [d, i] = E(n?.labelStyle ?? "simple"), [p, c] = E(n?.showSegmentLengths ?? !0), [h, y] = E(n?.textSize ?? "medium");
  D(() => {
    if (l && l.attributes) {
      if ("measurementPrecision" in l.attributes) {
        const g = l.getAttribute("measurementPrecision");
        g !== void 0 && u(g);
      }
      if ("measurementLabelStyle" in l.attributes) {
        const g = l.getAttribute("measurementLabelStyle");
        g !== void 0 && g !== d && i(g);
      }
      if ("measurementShowSegmentLengths" in l.attributes) {
        const g = l.getAttribute("measurementShowSegmentLengths");
        g !== void 0 && g !== p && c(g);
      }
      if ("measurementTextSize" in l.attributes) {
        const g = l.getAttribute("measurementTextSize");
        g !== void 0 && g !== h && y(g);
      }
    }
  }, [l, d, p, h]);
  const f = (g) => {
    e && e(g, l);
  };
  return /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    a !== "point" && /* @__PURE__ */ o.jsxs(re, { layout: "inline", children: [
      "Vis delsegmenter / radius",
      /* @__PURE__ */ o.jsx(
        rn,
        {
          checked: p,
          onCalciteSwitchChange: (g) => {
            const w = g.target.checked;
            c(w), f({ showSegmentLengths: w });
          }
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Etikettstil",
      /* @__PURE__ */ o.jsxs(
        $t,
        {
          value: d,
          onCalciteSelectChange: (g) => {
            const w = g.target.value;
            i(w), f({ labelStyle: w });
          },
          children: [
            /* @__PURE__ */ o.jsx(ue, { value: "simple", children: "Enkel" }),
            /* @__PURE__ */ o.jsx(ue, { value: "boxed", children: "Med bakgrunn" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ o.jsxs(re, { children: [
      "Tekststørrelse",
      /* @__PURE__ */ o.jsxs(
        tn,
        {
          width: "full",
          scale: "s",
          value: h,
          onCalciteSegmentedControlChange: (g) => {
            const w = g.target.value;
            y(w), f({ textSize: w });
          },
          children: [
            /* @__PURE__ */ o.jsx(Ke, { value: "small", children: "Liten" }),
            /* @__PURE__ */ o.jsx(Ke, { value: "medium", children: "Medium" }),
            /* @__PURE__ */ o.jsx(Ke, { value: "large", children: "Stor" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ o.jsx(re, { children: "Presisjon (desimaler)" }),
    /* @__PURE__ */ o.jsx(
      gt,
      {
        min: 0,
        max: 6,
        step: 1,
        value: s,
        labelHandles: !0,
        labelTicks: !0,
        onCalciteSliderChange: (g) => {
          const w = g.target.value;
          u(w), f({ precision: w });
        }
      }
    )
  ] });
}, Wo = ({
  sketchVM: n,
  measurementOptions: e,
  onMeasurementOptionsChange: a,
  measurementManager: l
}) => {
  const { t: s } = Ie(["drawing", "common"]), [u, d] = E(null), i = K([]), p = (c) => {
    if (c.length === 0)
      return null;
    const h = c[0]?.geometry?.type;
    return h ? c.every(
      (f) => f.geometry?.type === h
    ) ? h : "multiple" : null;
  };
  return D(() => {
    if (!n)
      return;
    if (n.activeTool) {
      const x = n.activeTool;
      x.includes("point") ? d("point") : x.includes("polyline") ? d("polyline") : x.includes("polygon") || x.includes("rectangle") || x.includes("circle") ? d("polygon") : x.includes("text") && d("text");
    }
    const c = n.watch("polygonSymbol", (x) => {
      i.current.length > 0 && i.current.forEach((A) => {
        A.geometry?.type === "polygon" && (A.symbol = x);
      });
    }), h = n.watch("pointSymbol", (x) => {
      i.current.length > 0 && i.current.forEach((A) => {
        A.geometry?.type === "point" && (A.symbol = x);
      });
    }), y = n.watch("polylineSymbol", (x) => {
      console.log("polylineSymbol changed:", x), i.current.length > 0 && (console.log("Updating polyline graphics:", i.current.length), i.current.forEach((A) => {
        A.geometry?.type === "polyline" && (console.log("Updating polyline graphic with new symbol"), A.symbol = x);
      }));
    }), f = n.watch("textSymbol", (x) => {
      i.current.length > 0 && i.current.forEach((A) => {
        A.geometry?.type === "point" && A.symbol?.type === "text" && (A.symbol = x);
      });
    }), g = n.watch("activeTool", (x) => {
      x && (x.includes("point") ? d("point") : x.includes("polyline") ? d("polyline") : x.includes("polygon") || x.includes("rectangle") || x.includes("circle") ? d("polygon") : x.includes("text") && d("text"));
    }), w = n.on("create", (x) => {
      if (x.graphic && (i.current = [x.graphic], l && l.updateMeasurement(x.graphic)), x.state === "start") {
        const A = n.activeTool;
        A && (A.includes("point") ? d("point") : A.includes("polyline") ? d("polyline") : A.includes("polygon") || A.includes("rectangle") || A.includes("circle") ? d("polygon") : A.includes("text") && d("text"));
      }
      x.state === "cancel" && (l?.removeMeasurement(x.graphic), i.current = [], d(null));
    }), S = n.on("delete", (x) => {
      l && x.graphics.length > 0 && x.graphics.forEach((A) => {
        l.removeMeasurement(A);
      }), d(null);
    }), b = n.on("update", (x) => {
      if (x.state === "complete") {
        i.current = [], d(null);
        return;
      }
      i.current = x.graphics || [];
      const A = p(i.current);
      if (d(A), A && i.current.length > 0) {
        const _ = i.current[0];
        if (_.symbol)
          switch (A) {
            case "point":
              n.pointSymbol = _.symbol;
              break;
            case "polyline":
              n.polylineSymbol = _.symbol;
              break;
            case "polygon":
              n.polygonSymbol = _.symbol;
              break;
            case "text":
              n.textSymbol = _.symbol;
              break;
          }
      }
      l && x.graphics.length > 0 && x.graphics.forEach((_) => {
        l.updateMeasurement(_);
      });
    });
    return () => {
      w.remove(), g.remove(), S.remove(), b.remove(), c.remove(), h.remove(), y.remove(), f.remove();
    };
  }, [n, l]), n ? /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    u === null && /* @__PURE__ */ o.jsx(St, { open: !0, children: /* @__PURE__ */ o.jsxs(Tr, { open: !0, kind: "info", icon: !0, children: [
      /* @__PURE__ */ o.jsx("div", { slot: "title", children: "Velg tegne- eller utvalgsverktøy" }),
      /* @__PURE__ */ o.jsx("div", { slot: "message", children: "Velg et tegneverktøy i verktøylinjen for å tegne i kartet og definere tilhørende symbol eller bruk utvalgsverktøy for å endre på eksisterende tegneobjekter" })
    ] }) }),
    u === "multiple" && /* @__PURE__ */ o.jsx(St, { open: !0, children: /* @__PURE__ */ o.jsxs(Tr, { open: !0, kind: "info", icon: !0, children: [
      /* @__PURE__ */ o.jsx("div", { slot: "title", children: "Ulike geometrityper" }),
      /* @__PURE__ */ o.jsx("div", { slot: "message", children: "Kan ikke endre symboler når de valgte objektene har ulike geometrityper. Velg objekter av samme type for å endre symboler" })
    ] }) }),
    /* @__PURE__ */ o.jsx(St, { open: !0, children: /* @__PURE__ */ o.jsxs("div", { className: "symbol-settings", children: [
      u === "point" && /* @__PURE__ */ o.jsx(
        Vo,
        {
          sketchVM: n
        }
      ),
      u === "polyline" && /* @__PURE__ */ o.jsx(
        Zo,
        {
          sketchVM: n
        }
      ),
      u === "polygon" && /* @__PURE__ */ o.jsx(
        Ro,
        {
          sketchVM: n
        }
      ),
      u === "text" && /* @__PURE__ */ o.jsx(
        Bo,
        {
          sketchVM: n
        }
      )
    ] }) }),
    u != null && /* @__PURE__ */ o.jsxs(St, { title: s("drawing:measurement.title"), open: !0, children: [
      /* @__PURE__ */ o.jsxs(re, { layout: "inline", children: [
        s("drawing:measurement.showMeasurement"),
        /* @__PURE__ */ o.jsx(
          rn,
          {
            checked: i.current.length > 0 ? i.current[0].getAttribute("measurementShowOnMap") ?? e?.showOnMap : e?.showOnMap,
            onCalciteSwitchChange: (c) => {
              i.current.length > 0 ? i.current.forEach((h) => {
                a?.({ showOnMap: c.target.checked }, h);
              }) : a?.({ showOnMap: c.target.checked }, null);
            }
          }
        )
      ] }),
      /* @__PURE__ */ o.jsx(qn, { children: /* @__PURE__ */ o.jsx(Jn, { heading: "Innstillinger for mål", children: /* @__PURE__ */ o.jsx(
        Uo,
        {
          options: i.current.length > 0 ? {
            showOnMap: i.current[0].getAttribute("measurementShowOnMap") ?? e?.showOnMap,
            showLabels: i.current[0].getAttribute("measurementShowLabels") ?? e?.showLabels,
            unit: i.current[0].getAttribute("measurementUnit") ?? e?.unit,
            precision: i.current[0].getAttribute("measurementPrecision") ?? e?.precision,
            labelStyle: i.current[0].getAttribute("measurementLabelStyle") ?? e?.labelStyle,
            showSegmentLengths: i.current[0].getAttribute("measurementShowSegmentLengths") ?? e?.showSegmentLengths,
            textSize: i.current[0].getAttribute("measurementTextSize") ?? e?.textSize
          } : e,
          onChange: (c, h) => {
            i.current.length > 0 ? i.current.forEach((y) => {
              a?.(c, y);
            }) : a?.(c, null);
          },
          geometryType: u || "polygon",
          selectedGraphic: i.current[0]
        }
      ) }) })
    ] })
  ] }) : null;
}, Zr = class Ye {
  // Private constructor to prevent direct construction calls with the `new` operator
  constructor() {
    this.measurementLayer = null, this.graphicToLabelMap = /* @__PURE__ */ new Map(), this.graphicIdCounter = 0;
  }
  /**
   * Get the singleton instance
   */
  static getInstance() {
    return Ye.instance || (Ye.instance = new Ye()), Ye.instance;
  }
  /**
   * Initialize the MeasurementManager with a view
   */
  init(e) {
    const a = "measurements-graphics-layer", l = e.map;
    if (!l) {
      console.warn("MeasurementManager.init: view.map is not available");
      return;
    }
    const s = l.findLayerById(a);
    s ? this.measurementLayer = s : (this.measurementLayer = new bt({
      id: a,
      title: "Measurements",
      listMode: "hide"
    }), l.add(this.measurementLayer));
  }
  // Generer en unik ID for grafikk
  getGraphicId(e) {
    const a = e.getAttribute("id") || e.getAttribute("objectid");
    if (a)
      return a.toString();
    const l = `graphic-${this.graphicIdCounter++}`;
    return e.setAttribute("id", l), l;
  }
  // Hent målsettingsinnstillinger for en spesifikk grafikk
  getGraphicMeasurementOptions(e) {
    const a = { ...Ye.DEFAULT_OPTIONS };
    return e.attributes && "measurementShowLabels" in e.attributes && (a.showLabels = e.getAttribute("measurementShowLabels")), e.attributes && "measurementShowOnMap" in e.attributes && (a.showOnMap = e.getAttribute("measurementShowOnMap")), e.attributes && "measurementUnit" in e.attributes && (a.unit = e.getAttribute("measurementUnit")), e.attributes && "measurementPrecision" in e.attributes && (a.precision = e.getAttribute("measurementPrecision")), e.attributes && "measurementLabelStyle" in e.attributes && (a.labelStyle = e.getAttribute("measurementLabelStyle")), e.attributes && "measurementShowSegmentLengths" in e.attributes && (a.showSegmentLengths = e.getAttribute("measurementShowSegmentLengths")), e.attributes && "measurementTextSize" in e.attributes && (a.textSize = e.getAttribute("measurementTextSize")), a.unit = "metric", a;
  }
  // Lagre målsettingsinnstillinger på en grafikk
  setGraphicMeasurementOptions(e, a) {
    a.showLabels !== void 0 && e.setAttribute("measurementShowLabels", a.showLabels), a.showOnMap !== void 0 && e.setAttribute("measurementShowOnMap", a.showOnMap), a.unit !== void 0 && e.setAttribute("measurementUnit", a.unit), a.precision !== void 0 && e.setAttribute("measurementPrecision", a.precision), a.labelStyle !== void 0 && e.setAttribute("measurementLabelStyle", a.labelStyle), a.showSegmentLengths !== void 0 && e.setAttribute("measurementShowSegmentLengths", a.showSegmentLengths), a.textSize !== void 0 && e.setAttribute("measurementTextSize", a.textSize), this.updateMeasurement(e);
  }
  // Hovedmetode for å legge til/oppdatere målsetting
  updateMeasurement(e) {
    if (this.removeMeasurement(e), !e.geometry)
      return;
    const a = this.getGraphicMeasurementOptions(e), l = this.calculateMeasurement(e.geometry, a);
    l && (e.setAttribute("measurement", l.formatted), e.setAttribute("measurementValue", l.value), a.showOnMap && a.showLabels && (this.addLabelMeasurement(e, l, a), (e.geometry.type === "polyline" || e.geometry.type === "polygon") && a.showSegmentLengths && this.addSegmentMeasurements(e, a)));
  }
  // Fjern målsetting for en grafikk
  removeMeasurement(e) {
    if (!this.measurementLayer)
      return;
    const a = this.getGraphicId(e);
    this.graphicToLabelMap.has(a) && (this.graphicToLabelMap.get(a).forEach((d) => {
      this.measurementLayer && this.measurementLayer.remove(d);
    }), this.graphicToLabelMap.delete(a));
    const s = this.measurementLayer.graphics.toArray().filter(
      (u) => u.attributes && u.attributes.parentGraphicId === a && u.attributes.isMeasurementLabel
    );
    for (const u of s)
      this.measurementLayer.remove(u);
  }
  // Beregn målsetting basert på geometri
  calculateMeasurement(e, a) {
    if (!e)
      return null;
    let l = null;
    try {
      switch (e.type) {
        case "point": {
          const s = e;
          l = {
            value: s.z || 0,
            formatted: s.z ? `Z: ${this.formatValue(s.z, "m", a.precision)}` : `(${this.formatValue(s.x, "", a.precision)}, ${this.formatValue(s.y, "", a.precision)})`
          };
          break;
        }
        case "polyline": {
          try {
            let s;
            s = Fr.execute(e, { unit: "meters" }), l = {
              value: s,
              formatted: this.formatLength(s, a.precision)
            };
          } catch (s) {
            console.error("Failed to calculate polyline length", s);
            const u = e;
            let d = 0;
            if (u.paths && u.paths.length > 0)
              for (const i of u.paths)
                for (let p = 1; p < i.length; p++) {
                  const c = i[p][0] - i[p - 1][0], h = i[p][1] - i[p - 1][1];
                  d += Math.sqrt(c * c + h * h);
                }
            l = {
              value: d,
              formatted: this.formatLength(d, a.precision)
            };
          }
          break;
        }
        case "polygon": {
          try {
            let s;
            s = Ma.execute(e, { unit: "square-meters" }), l = {
              value: s,
              formatted: this.formatArea(s, a.precision)
            };
          } catch (s) {
            console.error("Failed to calculate polygon area", s), l = {
              value: 0,
              formatted: this.formatArea(0, a.precision)
            };
          }
          break;
        }
        default:
          l = null;
      }
    } catch (s) {
      console.error("Error in calculateMeasurement", s), l = {
        value: 0,
        formatted: "Beregning feilet"
      };
    }
    return l;
  }
  // Formater lengde med riktig enhet (alltid metrisk)
  formatLength(e, a) {
    return e < 1e3 ? `${this.formatValue(e, "m", a)}` : `${this.formatValue(e / 1e3, "km", a)}`;
  }
  // Formater areal med riktig enhet (alltid metrisk)
  formatArea(e, a) {
    return e < 1e4 ? `${this.formatValue(e, "m²", a)}` : `${this.formatValue(e / 1e4, "ha", a)}`;
  }
  // Formater tall med angitt presisjon
  formatValue(e, a, l) {
    return `${e.toFixed(l)} ${a}`;
  }
  // Finn posisjon for label basert på geometri (alltid senter/midtpunkt)
  getLabelPosition(e) {
    if (!e)
      return null;
    let a = null;
    switch (e.type) {
      case "point": {
        a = e;
        break;
      }
      case "polyline": {
        const l = e;
        l.extent && (a = l.extent.center);
        break;
      }
      case "polygon": {
        const l = e;
        l.centroid ? a = l.centroid : l.extent && (a = l.extent.center);
        break;
      }
      default:
        e.extent && e.extent.center && (a = e.extent.center);
    }
    return a;
  }
  // Get font size based on text size option
  getFontSize(e, a = !1) {
    const l = {
      small: 10,
      medium: 12,
      large: 16
    };
    return a ? l[e] - 2 : l[e];
  }
  // Legg til tekstlabel for målsetting
  addLabelMeasurement(e, a, l) {
    if (!e.geometry)
      return;
    const s = this.getLabelPosition(e.geometry);
    if (!s)
      return;
    const u = this.getFontSize(l.textSize);
    let d;
    switch (l.labelStyle) {
      case "boxed": {
        d = {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: a.formatted,
          font: {
            size: u,
            family: "sans-serif",
            weight: "bold"
          },
          backgroundColor: [255, 255, 255, 0.7],
          borderLineColor: [0, 0, 0, 0.5],
          borderLineSize: 1,
          yoffset: 3
        };
        break;
      }
      default: {
        d = {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: a.formatted,
          font: {
            size: u,
            family: "sans-serif",
            weight: "bold"
          }
        };
        break;
      }
    }
    const i = this.getGraphicId(e), p = new ur({
      geometry: s,
      symbol: d,
      attributes: {
        parentGraphicId: i,
        isMeasurementLabel: !0,
        type: "main-measurement"
      }
    });
    this.measurementLayer && this.measurementLayer.add(p);
    const c = this.getGraphicId(e);
    this.graphicToLabelMap.has(c) || this.graphicToLabelMap.set(c, []), this.graphicToLabelMap.get(c).push(p);
  }
  // Create a text symbol for segment measurements
  createSegmentTextSymbol(e, a, l, s = !0) {
    const u = this.getFontSize(l.textSize, s);
    switch (l.labelStyle) {
      case "boxed":
        return {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: e,
          font: {
            size: u,
            family: "sans-serif",
            weight: "bold"
          },
          backgroundColor: [255, 255, 255, 0.7],
          borderLineColor: [0, 0, 0, 0.5],
          borderLineSize: 1,
          yoffset: 3,
          angle: a
        };
      default:
        return {
          type: "text",
          color: "black",
          haloColor: "white",
          haloSize: "2px",
          text: e,
          font: {
            size: u,
            family: "sans-serif",
            weight: "bold"
          },
          angle: a
        };
    }
  }
  // Calculate segment length and create label
  createSegmentLabel(e, a, l, s) {
    const u = new ja({
      paths: [[[e[0], e[1]], [a[0], a[1]]]],
      spatialReference: l
    }), d = Fr.execute(u, { unit: "meters" }), i = this.formatLength(d, s.precision), p = (e[0] + a[0]) / 2, c = (e[1] + a[1]) / 2, h = new Zt({
      x: p,
      y: c,
      spatialReference: l
    }), y = a[0] - e[0], f = a[1] - e[1];
    let g = -Math.atan2(f, y) * 180 / Math.PI;
    g < -90 ? g += 180 : g > 90 && (g -= 180);
    const w = this.createSegmentTextSymbol(i, g, s);
    return new ur({
      geometry: h,
      symbol: w,
      attributes: {
        // parentGraphicId will be set when added to the layer
        parentGraphicId: null,
        isMeasurementLabel: !0,
        type: "segment-measurement"
      }
    });
  }
  // Check if a polygon is approximately a circle
  isCircle(e) {
    if (!e)
      return { isCircle: !1 };
    if (!e.rings || e.rings.length !== 1)
      return { isCircle: !1 };
    const a = e.rings[0];
    if (a.length < 8)
      return { isCircle: !1 };
    let l = 0, s = 0;
    for (let f = 0; f < a.length - 1; f++)
      l += a[f][0], s += a[f][1];
    const u = l / (a.length - 1), d = s / (a.length - 1);
    let i = 0, p = [];
    for (let f = 0; f < a.length - 1; f++) {
      const g = a[f][0] - u, w = a[f][1] - d, S = Math.sqrt(g * g + w * w);
      p.push(S), i += S;
    }
    const c = i / (a.length - 1), h = 0.05;
    for (const f of p)
      if (Math.abs(f - c) / c > h)
        return { isCircle: !1 };
    return {
      isCircle: !0,
      center: new Zt({
        x: u,
        y: d,
        spatialReference: e.spatialReference
      }),
      radius: c
    };
  }
  // Add measurements for individual segments of polylines or polygon perimeters
  addSegmentMeasurements(e, a) {
    if (!e.geometry)
      return;
    const l = e.geometry, s = [];
    if (l.type === "polyline") {
      const u = l;
      if (u.paths && u.paths.length > 0)
        for (const d of u.paths)
          for (let i = 1; i < d.length; i++) {
            const p = this.createSegmentLabel(
              d[i - 1],
              d[i],
              u.spatialReference,
              a
            );
            if (p && this.measurementLayer) {
              const c = this.getGraphicId(e);
              p.attributes ? p.attributes.parentGraphicId = c : p.attributes = {
                parentGraphicId: c,
                isMeasurementLabel: !0,
                type: "segment-measurement"
              }, this.measurementLayer.add(p), s.push(p);
            }
          }
    } else if (l.type === "polygon") {
      const u = l, d = this.isCircle(u);
      if (d.isCircle && d.center && d.radius) {
        const p = `R: ${this.formatLength(d.radius, a.precision)}`, c = d.radius * 0.3, h = new Zt({
          x: d.center.x,
          y: d.center.y - c,
          // Move down (south) by subtracting from Y
          spatialReference: u.spatialReference
        }), y = this.createSegmentTextSymbol(p, 0, a), f = this.getGraphicId(e), g = new ur({
          geometry: h,
          symbol: y,
          attributes: {
            parentGraphicId: f,
            isMeasurementLabel: !0,
            type: "radius-measurement"
          }
        });
        this.measurementLayer && (this.measurementLayer.add(g), s.push(g));
      } else if (u.rings && u.rings.length > 0)
        for (const i of u.rings) {
          for (let p = 1; p < i.length - 1; p++) {
            const c = this.createSegmentLabel(
              i[p - 1],
              i[p],
              u.spatialReference,
              a
            );
            if (c && this.measurementLayer) {
              const h = this.getGraphicId(e);
              c.attributes ? c.attributes.parentGraphicId = h : c.attributes = {
                parentGraphicId: h,
                isMeasurementLabel: !0,
                type: "polygon-segment-measurement"
              }, this.measurementLayer.add(c), s.push(c);
            }
          }
          if (i.length >= 3) {
            const p = i.length - 2, c = this.createSegmentLabel(
              i[p],
              i[0],
              u.spatialReference,
              a
            );
            if (c && this.measurementLayer) {
              const h = this.getGraphicId(e);
              c.attributes ? c.attributes.parentGraphicId = h : c.attributes = {
                parentGraphicId: h,
                isMeasurementLabel: !0,
                type: "polygon-closing-segment-measurement"
              }, this.measurementLayer.add(c), s.push(c);
            }
          }
        }
    }
    if (s.length > 0) {
      const u = this.getGraphicId(e);
      this.graphicToLabelMap.has(u) || this.graphicToLabelMap.set(u, []), this.graphicToLabelMap.get(u).push(...s);
    }
  }
  // Clear all measurements without destroying the layer
  clearAllMeasurements() {
    if (!this.measurementLayer)
      return;
    const a = this.measurementLayer.graphics.toArray().filter(
      (l) => l.attributes && l.attributes.isMeasurementLabel
    );
    for (const l of a)
      this.measurementLayer.remove(l);
    this.graphicToLabelMap.clear();
  }
  // No need to destroy the singleton, but provide a method to reset if needed
  reset() {
    this.graphicToLabelMap.clear();
  }
};
Zr.instance = null;
Zr.DEFAULT_OPTIONS = {
  showLabels: !0,
  showOnMap: !0,
  unit: "metric",
  precision: 2,
  labelStyle: "simple",
  showSegmentLengths: !0,
  textSize: "medium"
};
let Fn = Zr;
const pr = "drawing-graphics-layer", k1 = () => {
  const { mapView: n } = Ee(), [, e] = E(), a = K(null), l = K(null), s = K(null);
  console.log("Rendering Drawing component");
  const [u, d] = E({
    showLabels: !0,
    showOnMap: !0,
    unit: "metric",
    precision: 2,
    textSize: "medium",
    labelStyle: "simple",
    showSegmentLengths: !0
  }), i = K(null);
  D(() => {
    const c = n?.map;
    if (!n || !c || !n.container || !s.current)
      return;
    let h = !1, y = c.findLayerById(pr);
    return y || (y = new bt({
      id: pr,
      listMode: "hide"
    }), c.add(y)), a.current = y, n.when(() => {
      if (h)
        return;
      const f = [];
      a.current && f.push({ layer: a.current, enabled: !0 }), c.allLayers.forEach((w) => {
        (w instanceof La || w instanceof bt) && w.id !== pr && f.push({ layer: w, enabled: !0 });
      });
      const g = new Ea({
        layer: a.current || void 0,
        view: n,
        creationMode: "update",
        container: s.current,
        snappingOptions: {
          enabled: !0,
          selfEnabled: !1,
          distance: 10,
          featureSources: f
        },
        tooltipOptions: { enabled: !0 },
        visibleElements: { duplicateButton: !1 }
      });
      l.current = g, e(g), i.current = Fn.getInstance(), i.current.init(n);
    }), () => {
      h = !0, l.current && (l.current.destroy(), l.current = null);
    };
  }, [n]);
  const p = (c, h) => {
    h && i.current && i.current.setGraphicMeasurementOptions(h, c);
  };
  return /* @__PURE__ */ o.jsxs("div", { id: "tegning-details", children: [
    /* @__PURE__ */ o.jsx("div", { ref: s, id: "tegning-description", className: "sketch-toolbar-container" }),
    /* @__PURE__ */ o.jsx(
      Wo,
      {
        sketchVM: l.current?.viewModel ?? null,
        measurementOptions: u,
        onMeasurementOptionsChange: p,
        measurementManager: i.current
      }
    )
  ] });
}, Yo = "DrawingBlock-module__block___R5QZD", Ko = "DrawingBlock-module__open___pPJL9", qo = "DrawingBlock-module__header___2OncX", Jo = "DrawingBlock-module__trigger___ykZgk", Xo = "DrawingBlock-module__headerActions___DF-R0", Qo = "DrawingBlock-module__heading___hTUwI", el = "DrawingBlock-module__indicator___PMMPf", tl = "DrawingBlock-module__contentWrapper___AVgV7", rl = "DrawingBlock-module__content___DSuRC", Te = {
  block: Yo,
  open: Ko,
  header: qo,
  trigger: Jo,
  headerActions: Xo,
  heading: Qo,
  indicator: el,
  contentWrapper: tl,
  content: rl
};
function nl({ heading: n, open: e, onOpenChange: a, headerActions: l, children: s }) {
  const u = Gn(), d = `${u}-content`, i = `${u}-heading`;
  return /* @__PURE__ */ o.jsxs("section", { className: `${Te.block} ${e ? Te.open : ""}`, children: [
    /* @__PURE__ */ o.jsxs("div", { className: Te.header, children: [
      /* @__PURE__ */ o.jsxs(
        "button",
        {
          type: "button",
          "aria-expanded": e,
          "aria-controls": d,
          onClick: () => a(!e),
          className: Te.trigger,
          children: [
            /* @__PURE__ */ o.jsx(Mr, { size: 16, weight: "bold", className: Te.indicator, "aria-hidden": "true" }),
            /* @__PURE__ */ o.jsx("span", { id: i, className: Te.heading, children: n })
          ]
        }
      ),
      l && /* @__PURE__ */ o.jsx("div", { className: Te.headerActions, children: l })
    ] }),
    /* @__PURE__ */ o.jsx("section", { id: d, "aria-labelledby": i, className: Te.contentWrapper, children: /* @__PURE__ */ o.jsx("div", { className: Te.content, children: s }) })
  ] });
}
const al = "DrawingCustomToolbar-module__root___LPkOc", ol = "DrawingCustomToolbar-module__group___SrZ-n", ll = "DrawingCustomToolbar-module__label___6lIrf", sl = "DrawingCustomToolbar-module__toolRow___1D-C6", il = "DrawingCustomToolbar-module__toolbarItem___7-ufb", cl = "DrawingCustomToolbar-module__divider___MZewe", Ce = {
  root: al,
  group: ol,
  label: ll,
  toolRow: sl,
  toolbarItem: il,
  divider: cl
}, Pr = { weight: "duotone", size: 24 }, ul = [
  { key: "point", icon: /* @__PURE__ */ o.jsx(jn, {}), label: "Punkt", tooltip: "Tegn punkt" },
  { key: "polyline", icon: /* @__PURE__ */ o.jsx(En, {}), label: "Linje", tooltip: "Tegn linje" },
  { key: "polygon", icon: /* @__PURE__ */ o.jsx(kn, {}), label: "Polygon", tooltip: "Tegn polygon" },
  { key: "rectangle", icon: /* @__PURE__ */ o.jsx(Zn, {}), label: "Rektangel", tooltip: "Tegn rektangel" },
  { key: "circle", icon: /* @__PURE__ */ o.jsx(_n, {}), label: "Sirkel", tooltip: "Tegn sirkel" }
], ml = [
  { key: "click", icon: /* @__PURE__ */ o.jsx(wn, {}), label: "Velg", tooltip: "Velg objekt" },
  { key: "rectangle", icon: /* @__PURE__ */ o.jsx(Rn, {}), label: "Velg med rektangel", tooltip: "Velg med rektangel" },
  { key: "lasso", icon: /* @__PURE__ */ o.jsx(Cn, {}), label: "Velg med lasso", tooltip: "Velg med lasso" }
], dl = ({
  activeTool: n,
  selectMode: e,
  snappingEnabled: a,
  hasDrawings: l,
  selectionCount: s,
  onCreate: u,
  onSelect: d,
  onDelete: i,
  onToggleSnapping: p
}) => /* @__PURE__ */ o.jsxs("div", { className: Ce.root, children: [
  /* @__PURE__ */ o.jsx("div", { className: Ce.group, children: /* @__PURE__ */ o.jsx(wr.Provider, { value: Pr, children: /* @__PURE__ */ o.jsxs("div", { className: Ce.toolRow, role: "toolbar", "aria-label": "Tegneverktøy", children: [
    ul.map(({ key: c, icon: h, label: y, tooltip: f }) => /* @__PURE__ */ o.jsx(xt, { content: f, position: "bottom", children: /* @__PURE__ */ o.jsx(yt, { icon: h, label: y, active: n === c, onClick: () => u(c), className: Ce.toolbarItem }) }, c)),
    /* @__PURE__ */ o.jsx("span", { className: Ce.divider, "aria-hidden": "true" }),
    /* @__PURE__ */ o.jsx(xt, { content: a ? "Slå av snapping" : "Slå på snapping", position: "bottom", children: /* @__PURE__ */ o.jsx(yt, { icon: /* @__PURE__ */ o.jsx(Ln, {}), label: "Snapping", active: a, onClick: p, className: Ce.toolbarItem }) })
  ] }) }) }),
  l && /* @__PURE__ */ o.jsx("div", { className: Ce.group, children: /* @__PURE__ */ o.jsx(wr.Provider, { value: Pr, children: /* @__PURE__ */ o.jsxs("div", { className: Ce.toolRow, role: "toolbar", "aria-label": "Velgverktøy", children: [
    ml.map(({ key: c, icon: h, label: y, tooltip: f }) => /* @__PURE__ */ o.jsx(xt, { content: f, position: "bottom", children: /* @__PURE__ */ o.jsx(yt, { icon: h, label: y, active: e === c, onClick: () => d(c), className: Ce.toolbarItem }) }, c)),
    s > 0 && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx("span", { className: Ce.divider, "aria-hidden": "true" }),
      /* @__PURE__ */ o.jsx(xt, { content: "Slett valgt objekt", position: "bottom", children: /* @__PURE__ */ o.jsxs(an, { rightIcon: /* @__PURE__ */ o.jsx(kr, { size: 16 }), onClick: i, variant: "secondary", size: "sm", children: [
        s,
        " valgt"
      ] }) })
    ] })
  ] }) }) })
] }), $n = [
  { value: "solid", label: "Heltrukket" },
  { value: "dash", label: "Stiplet" },
  { value: "dot", label: "Prikker" },
  { value: "dash-dot", label: "Strek-prikk" },
  { value: "dash-dot-dot", label: "Strek-prikk-prikk" }
];
function Vt(n) {
  if (!n)
    return "#0000ff";
  const [e, a, l] = Array.isArray(n) ? [n[0], n[1], n[2]] : [n.r ?? 0, n.g ?? 0, n.b ?? 0];
  return `#${e.toString(16).padStart(2, "0")}${a.toString(16).padStart(2, "0")}${l.toString(16).padStart(2, "0")}`;
}
function Nt(n) {
  if (!n)
    return 0;
  let e = Array.isArray(n) ? n[3] : n.a ?? 1;
  return e > 1 && (e = e / 255), Math.round((1 - e) * 100);
}
function Ft(n, e) {
  const a = parseInt(n.slice(1, 3), 16), l = parseInt(n.slice(3, 5), 16), s = parseInt(n.slice(5, 7), 16), u = (100 - e) / 100;
  return [a, l, s, u];
}
const pl = "SymbolSettings-module__settings___L-Y6E", fl = "SymbolSettings-module__sliderRow___aPbIY", hl = "SymbolSettings-module__slider___KIPMw", gl = "SymbolSettings-module__numberInput___xZj9F", qe = {
  settings: pl,
  sliderRow: fl,
  slider: hl,
  numberInput: gl
}, Ue = ({ label: n, value: e, min: a, max: l, step: s, unit: u, onChange: d }) => /* @__PURE__ */ o.jsxs("div", { className: qe.sliderRow, children: [
  /* @__PURE__ */ o.jsx(
    on,
    {
      label: n,
      min: a,
      max: l,
      step: s,
      value: e,
      showValue: !1,
      onChange: (i) => d(Number(i.target.value)),
      className: qe.slider
    }
  ),
  /* @__PURE__ */ o.jsx(
    ln,
    {
      label: "",
      min: a,
      max: l,
      step: s,
      value: e,
      unit: u,
      onChange: (i) => d(Number(i.target.value)),
      className: qe.numberInput
    }
  )
] }), yl = ({ sketchVM: n, initialSymbol: e, onSymbolChange: a }) => {
  const l = n, [s, u] = E(() => {
    const i = e ?? l.polylineSymbol;
    return {
      color: Vt(i?.color),
      transparency: Nt(i?.color),
      width: i?.width ?? 2,
      style: i?.style ?? "solid"
    };
  });
  function d(i) {
    const p = { ...s, ...i };
    u(p);
    const c = {
      type: "simple-line",
      color: Ft(p.color, p.transparency),
      width: p.width,
      style: p.style
    };
    a ? a(c) : l.polylineSymbol = c;
  }
  return /* @__PURE__ */ o.jsxs("div", { className: qe.settings, children: [
    /* @__PURE__ */ o.jsx(
      Lr,
      {
        label: "Stil",
        value: s.style,
        options: $n,
        onChange: (i) => d({ style: i.target.value })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Tt,
      {
        label: "Farge",
        value: s.color,
        onChange: (i) => d({ color: i })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Ue,
      {
        label: "Gjennomsiktighet",
        value: s.transparency,
        min: 0,
        max: 100,
        step: 1,
        unit: "%",
        onChange: (i) => d({ transparency: i })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Ue,
      {
        label: "Bredde",
        value: s.width,
        min: 0.5,
        max: 20,
        step: 0.5,
        unit: "px",
        onChange: (i) => d({ width: i })
      }
    )
  ] });
}, bl = ({ sketchVM: n, initialSymbol: e, onSymbolChange: a }) => {
  const l = n, [s, u] = E(() => {
    const i = e ?? l.polygonSymbol;
    return {
      fillColor: Vt(i?.color),
      fillTransparency: Nt(i?.color),
      outlineColor: Vt(i?.outline?.color),
      outlineTransparency: Nt(i?.outline?.color),
      outlineWidth: i?.outline?.width ?? 1,
      outlineStyle: i?.outline?.style ?? "solid"
    };
  });
  function d(i) {
    const p = { ...s, ...i };
    u(p);
    const c = {
      type: "simple-fill",
      color: Ft(p.fillColor, p.fillTransparency),
      outline: {
        color: Ft(p.outlineColor, p.outlineTransparency),
        width: p.outlineWidth,
        style: p.outlineStyle
      }
    };
    a ? a(c) : l.polygonSymbol = c;
  }
  return /* @__PURE__ */ o.jsxs("div", { className: qe.settings, children: [
    /* @__PURE__ */ o.jsx(
      Tt,
      {
        label: "Fyllfarge",
        value: s.fillColor,
        onChange: (i) => d({ fillColor: i })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Ue,
      {
        label: "Fyllgjennomsiktighet",
        value: s.fillTransparency,
        min: 0,
        max: 100,
        step: 1,
        unit: "%",
        onChange: (i) => d({ fillTransparency: i })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Tt,
      {
        label: "Farge på linje",
        value: s.outlineColor,
        onChange: (i) => d({ outlineColor: i })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Ue,
      {
        label: "Omrissgjennomsiktighet",
        value: s.outlineTransparency,
        min: 0,
        max: 100,
        step: 1,
        unit: "%",
        onChange: (i) => d({ outlineTransparency: i })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Lr,
      {
        label: "Omrissstil",
        value: s.outlineStyle,
        options: $n,
        onChange: (i) => d({ outlineStyle: i.target.value })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Ue,
      {
        label: "Omrissbredde",
        value: s.outlineWidth,
        min: 0.5,
        max: 20,
        step: 0.5,
        unit: "px",
        onChange: (i) => d({ outlineWidth: i })
      }
    )
  ] });
}, vl = ({ sketchVM: n, initialSymbol: e, onSymbolChange: a }) => {
  const l = n, [s, u] = E(() => {
    const i = e ?? l.pointSymbol;
    return {
      color: Vt(i?.color),
      transparency: Nt(i?.color),
      size: i?.size ?? 8
    };
  });
  function d(i) {
    const p = { ...s, ...i };
    u(p);
    const c = {
      type: "simple-marker",
      color: Ft(p.color, p.transparency),
      size: p.size,
      outline: { color: [255, 255, 255, 0.8], width: 1 }
    };
    a ? a(c) : l.pointSymbol = c;
  }
  return /* @__PURE__ */ o.jsxs("div", { className: qe.settings, children: [
    /* @__PURE__ */ o.jsx(
      Tt,
      {
        label: "Farge",
        value: s.color,
        onChange: (i) => d({ color: i })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Ue,
      {
        label: "Gjennomsiktighet",
        value: s.transparency,
        min: 0,
        max: 100,
        step: 1,
        unit: "%",
        onChange: (i) => d({ transparency: i })
      }
    ),
    /* @__PURE__ */ o.jsx(
      Ue,
      {
        label: "Størrelse",
        value: s.size,
        min: 2,
        max: 40,
        step: 1,
        unit: "px",
        onChange: (i) => d({ size: i })
      }
    )
  ] });
}, Sl = ({ sketchVM: n, geometryType: e, selectedGraphic: a, initialSymbol: l, onSymbolChange: s }) => {
  const u = String(a?.uid ?? "");
  return e === "polyline" ? /* @__PURE__ */ o.jsx(yl, { sketchVM: n, initialSymbol: l, onSymbolChange: s }, u) : e === "polygon" ? /* @__PURE__ */ o.jsx(bl, { sketchVM: n, initialSymbol: l, onSymbolChange: s }, u) : e === "point" ? /* @__PURE__ */ o.jsx(vl, { sketchVM: n, initialSymbol: l, onSymbolChange: s }, u) : null;
}, xl = "MeasurementSettings-module__settings___WAfq8", _l = "MeasurementSettings-module__sectionHeading___GK0XC", wl = "MeasurementSettings-module__blockContent___wUToR", Al = "MeasurementSettings-module__sliderRow___-Ga-T", Cl = "MeasurementSettings-module__slider___fbUpN", El = "MeasurementSettings-module__numberInput___VkXbM", We = {
  settings: xl,
  sectionHeading: _l,
  blockContent: wl,
  sliderRow: Al,
  slider: Cl,
  numberInput: El
}, Ll = ({ options: n, onChange: e, geometryType: a, selectedGraphic: l }) => {
  const [s, u] = E(n?.showOnMap ?? !0), [d, i] = E(n?.showSegmentLengths ?? !0), [p, c] = E(n?.labelStyle ?? "simple"), [h, y] = E(n?.textSize ?? "medium"), [f, g] = E(n?.precision ?? 2);
  D(() => {
    if (!l)
      return;
    const S = l.getAttribute("measurementShowOnMap"), b = l.getAttribute("measurementShowSegmentLengths"), x = l.getAttribute("measurementLabelStyle"), A = l.getAttribute("measurementTextSize"), _ = l.getAttribute("measurementPrecision");
    S != null && u(S), b != null && i(b), x != null && c(x), A != null && y(A), _ != null && g(_);
  }, [l]);
  const w = (S) => e(S, l ?? null);
  return /* @__PURE__ */ o.jsxs("div", { className: We.settings, children: [
    /* @__PURE__ */ o.jsx(
      Nr,
      {
        label: "Vis mål",
        checked: s,
        onChange: (S) => {
          u(S), w({ showOnMap: S });
        }
      }
    ),
    s && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
      /* @__PURE__ */ o.jsx("p", { className: We.sectionHeading, children: "Innstillinger for mål" }),
      /* @__PURE__ */ o.jsxs("div", { className: We.blockContent, children: [
        (a === "polyline" || a === "polygon") && /* @__PURE__ */ o.jsx(
          Nr,
          {
            label: "Vis delsegmenter / radius",
            checked: d,
            onChange: (S) => {
              i(S), w({ showSegmentLengths: S });
            }
          }
        ),
        /* @__PURE__ */ o.jsx(
          Lr,
          {
            label: "Etikettstil",
            value: p,
            options: [
              { value: "simple", label: "Enkel" },
              { value: "boxed", label: "Med bakgrunn" }
            ],
            onChange: (S) => {
              const b = S.target.value;
              c(b), w({ labelStyle: b });
            }
          }
        ),
        /* @__PURE__ */ o.jsx(
          ga,
          {
            label: "Tekststørrelse",
            value: h,
            options: [
              { value: "small", label: "Liten" },
              { value: "medium", label: "Medium" },
              { value: "large", label: "Stor" }
            ],
            onChange: (S) => {
              y(S), w({ textSize: S });
            }
          }
        ),
        /* @__PURE__ */ o.jsxs("div", { className: We.sliderRow, children: [
          /* @__PURE__ */ o.jsx(
            on,
            {
              label: "Desimaler",
              min: 0,
              max: 6,
              step: 1,
              value: f,
              showValue: !1,
              onChange: (S) => {
                const b = parseInt(S.target.value);
                g(b), w({ precision: b });
              },
              className: We.slider
            }
          ),
          /* @__PURE__ */ o.jsx(
            ln,
            {
              label: "Desimaler",
              min: 0,
              max: 6,
              step: 1,
              value: f,
              onChange: (S) => {
                const b = parseInt(S.target.value);
                g(b), w({ precision: b });
              },
              className: We.numberInput
            }
          )
        ] })
      ] })
    ] })
  ] });
}, Ml = "DrawingCustomSettings-module__container___RFOhU", jl = "DrawingCustomSettings-module__section___N7kaX", kl = {
  container: Ml,
  section: jl
}, Zl = ({
  sketchVM: n,
  measurementOptions: e,
  onMeasurementOptionsChange: a,
  onGeometryTypeChange: l,
  onSymbolChange: s,
  measurementManager: u,
  graphic: d
}) => {
  const [i, p] = E(null), c = (_) => {
    p(_), l?.(_);
  }, [h, y] = E(void 0), f = K([]), g = (_) => {
    if (_.length === 0)
      return null;
    const $ = _[0]?.geometry?.type;
    return $ ? _.every((G) => G.geometry?.type === $) ? $ : "multiple" : null;
  }, w = (_) => _.includes("point") ? "point" : _.includes("polyline") ? "polyline" : _.includes("polygon") || _.includes("rectangle") || _.includes("circle") ? "polygon" : _.includes("text") ? "text" : null;
  if (D(() => {
    if (!n || d)
      return;
    if (n.activeTool) {
      const M = w(n.activeTool);
      M && c(M);
    }
    const _ = n.watch("polygonSymbol", (M) => {
      f.current.forEach((F) => {
        F.geometry?.type === "polygon" && (F.symbol = M);
      });
    }), $ = n.watch("pointSymbol", (M) => {
      f.current.forEach((F) => {
        F.geometry?.type === "point" && F.symbol?.type !== "text" && (F.symbol = M);
      });
    }), G = n.watch("polylineSymbol", (M) => {
      f.current.forEach((F) => {
        F.geometry?.type === "polyline" && (F.symbol = M);
      });
    }), R = n.watch("textSymbol", (M) => {
      f.current.forEach((F) => {
        F.geometry?.type === "point" && F.symbol?.type === "text" && (F.symbol = M);
      });
    }), X = n.watch("activeTool", (M) => {
      if (M) {
        const F = w(M);
        F && c(F);
      }
    }), N = n.on("create", (M) => {
      M.graphic && (f.current = [M.graphic], y(M.graphic), u?.updateMeasurement(M.graphic)), M.state === "start" && c(w(n.activeTool ?? "")), M.state === "complete" && M.graphic && n.update([M.graphic]), M.state === "cancel" && (u?.removeMeasurement(M.graphic), f.current = [], y(void 0), c(null));
    }), T = n.on("delete", (M) => {
      M.graphics?.forEach((F) => u?.removeMeasurement(F)), f.current = [], y(void 0), c(null);
    }), H = n.on("update", (M) => {
      f.current = M.graphics || [];
      const F = f.current[0], O = g(f.current);
      if (c(O), y(F), O && F?.symbol)
        switch (O) {
          case "point":
            n.pointSymbol = F.symbol;
            break;
          case "polyline":
            n.polylineSymbol = F.symbol;
            break;
          case "polygon":
            n.polygonSymbol = F.symbol;
            break;
          case "text":
            n.textSymbol = F.symbol;
            break;
        }
      M.graphics?.forEach((B) => u?.updateMeasurement(B)), M.state === "complete" && (f.current = [], y(void 0), c(null));
    });
    return () => {
      _.remove(), $.remove(), G.remove(), R.remove(), X.remove(), N.remove(), T.remove(), H.remove();
    };
  }, [n, u]), !n)
    return null;
  const S = d ? d.geometry?.type ?? null : i, b = d ?? h, x = b ? {
    showOnMap: b.getAttribute("measurementShowOnMap") ?? e?.showOnMap,
    showLabels: b.getAttribute("measurementShowLabels") ?? e?.showLabels,
    unit: b.getAttribute("measurementUnit") ?? e?.unit,
    precision: b.getAttribute("measurementPrecision") ?? e?.precision,
    labelStyle: b.getAttribute("measurementLabelStyle") ?? e?.labelStyle,
    showSegmentLengths: b.getAttribute("measurementShowSegmentLengths") ?? e?.showSegmentLengths,
    textSize: b.getAttribute("measurementTextSize") ?? e?.textSize
  } : e, A = (_, $) => {
    d ? a?.(_, d) : f.current.length > 0 ? f.current.forEach(
      (G) => a?.(_, G)
    ) : a?.(_, $ ?? null);
  };
  return /* @__PURE__ */ o.jsx("div", { className: kl.container, children: S !== null && S !== "multiple" && S !== "text" && /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
    /* @__PURE__ */ o.jsx(
      Sl,
      {
        sketchVM: n,
        geometryType: S,
        selectedGraphic: b,
        initialSymbol: d ? d.symbol : void 0,
        onSymbolChange: d ? s ?? ((_) => {
          d.symbol = _;
        }) : void 0
      }
    ),
    /* @__PURE__ */ o.jsx(
      Ll,
      {
        options: x,
        onChange: A,
        geometryType: S,
        selectedGraphic: b
      }
    )
  ] }) });
}, Rl = {
  point: "Punkt",
  polyline: "Linje",
  polygon: "Polygon",
  rectangle: "Rektangel",
  circle: "Sirkel",
  text: "Tekst"
}, Dr = "drawing-custom-graphics-layer", zr = "drawing-custom-selection-layer";
function Tl(n, e) {
  return n.graphics.filter((a) => !!a.geometry && ka.execute(e, a.geometry)).toArray();
}
function Il(n) {
  const e = K(null), a = K(null), l = K(null), s = K(null), u = K(null), d = K("point"), i = K(null), p = K(/* @__PURE__ */ new Map()), c = K(/* @__PURE__ */ new Map()), h = K(/* @__PURE__ */ new Map()), y = K(/* @__PURE__ */ new Map()), [f, g] = E(null), [w, S] = E(null), [b, x] = E(null), [A, _] = E(!0), [$, G] = E(0), [R, X] = E(0), [N, T] = E([]), [H, M] = E(!1), [F, O] = E(!1), [B, ee] = E(0), [U, I] = E(0), [ne, ge] = E(null), ae = le(() => {
    const k = i.current ? i.current.uid : null, W = k ? (p.current.get(k)?.length ?? 0) > 0 || h.current.has(k) : !1, q = k ? (c.current.get(k)?.length ?? 0) > 0 : !1;
    M((l.current?.canUndo() ?? !1) || W), O((l.current?.canRedo() ?? !1) || q);
  }, []);
  D(() => {
    const k = n?.map;
    if (!n || !k || !n.container)
      return;
    let W = !1;
    const q = [];
    let ce = k.findLayerById(Dr);
    ce || (ce = new bt({ id: Dr, listMode: "hide" }), k.add(ce)), e.current = ce;
    let me = k.findLayerById(zr);
    me || (me = new bt({ id: zr, listMode: "hide" }), k.add(me)), a.current = me;
    const fe = (Y) => {
      Y.state === "complete" && (u.current?.updateMeasurement(Y.graphic), X((ie) => ie + 1), T((ie) => [...ie, { graphic: Y.graphic, toolType: d.current }]));
    }, de = (Y) => {
      Y.graphics?.forEach((te) => u.current?.updateMeasurement(te)), I((te) => te + 1);
      const ie = Y.state === "complete" ? 0 : Y.graphics?.length ?? 0;
      if (G(ie), ae(), Y.state === "start") {
        const te = Y.graphics?.length === 1 ? Y.graphics[0] : null;
        i.current = te, ge(te ? te.uid : null);
      } else
        Y.state === "complete" && ge(null);
    }, Re = (Y) => {
      Y.graphics?.forEach((te) => u.current?.removeMeasurement(te)), G(0), X((te) => Math.max(0, te - (Y.graphics?.length ?? 0)));
      const ie = new Set(Y.graphics ?? []);
      T((te) => te.filter((Ve) => !ie.has(Ve.graphic)));
    };
    return n.when(() => {
      if (W)
        return;
      const Y = new $r({
        layer: ce,
        view: n,
        defaultCreateOptions: { mode: "click" },
        snappingOptions: {
          enabled: !0,
          selfEnabled: !0,
          featureEnabled: !0,
          distance: 10,
          featureSources: k.allLayers.filter((te) => te.type === "feature" || te.type === "graphics").map((te) => new Ra({ layer: te, enabled: !0 })).toArray()
        },
        tooltipOptions: { enabled: !0 }
      }), ie = new $r({ layer: me, view: n });
      l.current = Y, s.current = ie, g(Y), q.push(
        Y.watch("activeTool", (te) => {
          S(te), te && x(null);
        }),
        Y.on("create", fe),
        Y.on("update", de),
        Y.on("undo", ae),
        Y.on("redo", ae),
        Y.on("delete", Re),
        ie.on("create", (te) => {
          const Ve = te.graphic?.geometry;
          if (te.state !== "complete" || !Ve)
            return;
          const Ae = Tl(ce, Ve);
          me.removeAll(), Ae.length > 0 && Y.update(Ae);
        })
      ), u.current = Fn.getInstance(), u.current.init(n);
    }), () => {
      W = !0, q.forEach((Y) => Y.remove()), l.current?.destroy(), l.current = null, s.current?.destroy(), s.current = null;
    };
  }, [n, ae]);
  const Le = le((k) => {
    if (s.current?.cancel(), x(null), w === k) {
      l.current?.cancel();
      return;
    }
    d.current = k, l.current?.create(k);
  }, [w]), Me = le((k) => {
    if (l.current?.cancel(), s.current?.cancel(), a.current?.removeAll(), b === k) {
      x(null);
      return;
    }
    x(k), k === "rectangle" ? s.current?.create("rectangle") : k === "lasso" && s.current?.create("polygon", { mode: "freehand" });
  }, [b]), $e = le(() => {
    const k = l.current;
    if (!k)
      return;
    const W = !k.snappingOptions.enabled;
    k.snappingOptions = new Za({
      enabled: W,
      selfEnabled: !0,
      featureEnabled: !0,
      distance: 10,
      featureSources: k.snappingOptions.featureSources
    }), _(W);
  }, []), Xe = le(() => l.current?.delete(), []), Qe = le(() => {
    if (l.current?.canUndo()) {
      l.current.undo();
      return;
    }
    const k = i.current;
    if (!k)
      return;
    const W = k.uid, q = h.current.get(W);
    if (q !== void 0) {
      clearTimeout(y.current.get(W)), y.current.delete(W), h.current.delete(W);
      const de = c.current.get(W) ?? [];
      k.symbol && de.push(k.symbol.clone()), c.current.set(W, de), k.symbol = q, ee((Re) => Re + 1), ae();
      return;
    }
    const ce = p.current.get(W);
    if (!ce?.length)
      return;
    const me = ce.pop(), fe = c.current.get(W) ?? [];
    k.symbol && fe.push(k.symbol.clone()), c.current.set(W, fe), k.symbol = me, ee((de) => de + 1), ae();
  }, [ae]), je = le(() => {
    if (l.current?.canRedo()) {
      l.current.redo();
      return;
    }
    const k = i.current;
    if (!k)
      return;
    const W = k.uid, q = c.current.get(W);
    if (!q?.length)
      return;
    const ce = q.pop(), me = p.current.get(W) ?? [];
    k.symbol && me.push(k.symbol.clone()), p.current.set(W, me), k.symbol = ce, ee((fe) => fe + 1), ae();
  }, [ae]), ke = le((k, W) => {
    const q = k.uid;
    !h.current.has(q) && k.symbol && h.current.set(q, k.symbol.clone()), clearTimeout(y.current.get(q));
    const ce = setTimeout(() => {
      const me = h.current.get(q);
      me && (p.current.has(q) || p.current.set(q, []), p.current.get(q).push(me), h.current.delete(q), y.current.delete(q), ae());
    }, 500);
    y.current.set(q, ce), c.current.set(q, []), k.symbol = W, ae();
  }, [ae]), _e = le((k) => {
    const W = k.uid;
    clearTimeout(y.current.get(W)), h.current.delete(W), y.current.delete(W), p.current.delete(W), c.current.delete(W), i.current === k && (i.current = null), l.current?.cancel(), s.current?.cancel(), a.current?.removeAll(), u.current?.removeMeasurement(k), e.current?.remove(k), G(0), X((q) => Math.max(0, q - 1)), T((q) => q.filter((ce) => ce.graphic !== k)), ae();
  }, [ae]), Ze = le((k) => {
    i.current = k, s.current?.cancel(), a.current?.removeAll(), k ? l.current?.update([k]) : l.current?.cancel(), ae();
  }, [ae]);
  return {
    sketchVM: f,
    measurementManager: u.current,
    activeTool: w,
    selectMode: b,
    snappingEnabled: A,
    selectionCount: $,
    graphicCount: R,
    drawings: N,
    canUndo: H,
    canRedo: F,
    symbolRevision: B,
    geometryRevision: U,
    selectedGraphicUid: ne,
    handleCreate: Le,
    handleSelect: Me,
    handleToggleSnapping: $e,
    handleUndo: Qe,
    handleRedo: je,
    handleSymbolChange: ke,
    handleDelete: Xe,
    handleDeleteGraphic: _e,
    handleActivateDrawing: Ze
  };
}
const Vl = "DrawingCustom-module__root___C3yS5", Nl = "DrawingCustom-module__drawingNotice___o1Ho6", Fl = "DrawingCustom-module__drawingHistoryActions___nXng9", $l = "DrawingCustom-module__measurementLabel___HwBOC", Rt = {
  root: Vl,
  drawingNotice: Nl,
  drawingHistoryActions: Fl,
  measurementLabel: $l
}, Hl = {
  showLabels: !0,
  showOnMap: !0,
  unit: "metric",
  precision: 2,
  textSize: "medium",
  labelStyle: "simple",
  showSegmentLengths: !0
};
function Ol(n) {
  return n ? n.includes("point") ? "point" : n.includes("polyline") ? "polyline" : n.includes("polygon") || n.includes("rectangle") || n.includes("circle") ? "polygon" : n.includes("text") ? "text" : null : null;
}
function Pl(n, e) {
  const a = e.filter((l) => l.toolType === n.toolType).indexOf(n) + 1;
  return `${Rl[n.toolType] ?? n.toolType} ${a}`;
}
function Dl({ geometryType: n, graphicCount: e }) {
  let a;
  return n !== null ? a = "Velg objekter av samme type for å endre symboler" : a = "Velg et verktøy ovenfor. Du kan tegne opp flere objekter.", /* @__PURE__ */ o.jsx(cn, { variant: "info", icon: /* @__PURE__ */ o.jsx(Ot, { size: 20, weight: "regular" }), className: Rt.drawingNotice, children: /* @__PURE__ */ o.jsx("p", { children: a }) });
}
const Z1 = () => {
  const { mapView: n } = Ee(), { setDisableMapClick: e } = pa();
  D(() => (e(!0), () => {
    e(!1);
  }), []);
  const {
    sketchVM: a,
    measurementManager: l,
    activeTool: s,
    selectMode: u,
    snappingEnabled: d,
    selectionCount: i,
    graphicCount: p,
    drawings: c,
    handleCreate: h,
    handleSelect: y,
    handleToggleSnapping: f,
    canUndo: g,
    canRedo: w,
    symbolRevision: S,
    geometryRevision: b,
    selectedGraphicUid: x,
    handleUndo: A,
    handleRedo: _,
    handleSymbolChange: $,
    handleDelete: G,
    handleDeleteGraphic: R,
    handleActivateDrawing: X
  } = Il(n), N = Ol(s), [T, H] = E(null), [M, F] = E(0), O = K(0);
  D(() => {
    x !== null && x !== T && H(x);
  }, [x]), Xr(() => {
    const U = c.length > O.current;
    if (O.current = c.length, c.length === 0) {
      H(null);
      return;
    }
    const I = c[c.length - 1];
    H(I.graphic.uid), U && X(I.graphic);
  }, [c.length]);
  const B = (U, I) => {
    I && l && (l.setGraphicMeasurementOptions(I, U), F((ne) => ne + 1));
  }, ee = Bn(() => {
    const U = /* @__PURE__ */ new Map();
    for (const I of c) {
      const ne = I.graphic.uid, ge = I.toolType !== "point" && I.toolType !== "text";
      U.set(ne, ge ? I.graphic.getAttribute("measurement") : null);
    }
    return U;
  }, [c, M, b]);
  return /* @__PURE__ */ o.jsxs("div", { id: "drawing-custom-details", className: Rt.root, children: [
    /* @__PURE__ */ o.jsx(
      dl,
      {
        activeTool: s,
        selectMode: u,
        snappingEnabled: d,
        hasDrawings: p > 0,
        selectionCount: i,
        onCreate: h,
        onSelect: y,
        onDelete: G,
        onToggleSnapping: f
      }
    ),
    c.length === 0 && /* @__PURE__ */ o.jsx(Dl, { geometryType: N, graphicCount: p }),
    c.map((U) => {
      const I = U.graphic.uid;
      return /* @__PURE__ */ o.jsxs(
        nl,
        {
          heading: Pl(U, c),
          open: T === I,
          onOpenChange: (ne) => {
            H(ne ? I : null), X(ne ? U.graphic : null);
          },
          headerActions: /* @__PURE__ */ o.jsxs(o.Fragment, { children: [
            ee.get(I) && /* @__PURE__ */ o.jsx("span", { className: Rt.measurementLabel, children: ee.get(I) }),
            /* @__PURE__ */ o.jsx(
              sn,
              {
                icon: /* @__PURE__ */ o.jsx(kr, { size: 16 }),
                label: "Slett tegning",
                size: "sm",
                onClick: () => R(U.graphic)
              }
            )
          ] }),
          children: [
            /* @__PURE__ */ o.jsxs(ya, { "aria-label": "Angre/gjør om", className: Rt.drawingHistoryActions, children: [
              /* @__PURE__ */ o.jsx(
                yt,
                {
                  icon: /* @__PURE__ */ o.jsx(vn, { size: 20 }),
                  label: "Angre",
                  disabled: !g,
                  onClick: A
                }
              ),
              /* @__PURE__ */ o.jsx(
                yt,
                {
                  icon: /* @__PURE__ */ o.jsx(Sn, { size: 20 }),
                  label: "Gjør om",
                  disabled: !w,
                  onClick: _
                }
              )
            ] }),
            /* @__PURE__ */ o.jsx(
              Zl,
              {
                graphic: U.graphic,
                sketchVM: a,
                measurementOptions: Hl,
                onMeasurementOptionsChange: B,
                onSymbolChange: (ne) => $(U.graphic, ne),
                measurementManager: l
              },
              I === T ? `${I}-${S}` : I
            )
          ]
        },
        I
      );
    })
  ] });
}, zl = "LayerSelector-module__cardGroup___dog-Z", Gl = "LayerSelector-module__centerContainer___aSILL", Bl = "LayerSelector-module__messageContainer___pyCOj", Ul = "LayerSelector-module__thumbnail___DRTN9", Wl = "LayerSelector-module__cardFooter___KmyW-", Yl = "LayerSelector-module__layerVisible___bsAVM", At = {
  cardGroup: zl,
  centerContainer: Gl,
  messageContainer: Bl,
  thumbnail: Ul,
  cardFooter: Wl,
  layerVisible: Yl
}, R1 = ({
  layersGroupId: n,
  onError: e,
  fallbackThumbnail: a = "public/images/basis terreng.png"
}) => {
  const { t: l } = Ie(["kartinnhold"]), { mapView: s } = Ee(), [u, d] = E([]), [i, p] = E(!0);
  D(() => {
    if (!s || !n)
      return;
    (async () => {
      try {
        p(!0);
        const y = new pn();
        await y.load();
        const g = await new fn({
          portal: y,
          id: n
        }).queryItems(), w = await Promise.all(
          g.results.map(async (S) => {
            if (!S.id || !S.title)
              throw new Error("Invalid portal item: missing id or title");
            const b = s.map?.allLayers.find(
              (x) => x.title === S.title
            );
            return {
              id: S.id,
              title: S.title,
              portalItem: S,
              layer: b,
              thumbnailUrl: S.thumbnailUrl || a
            };
          })
        );
        d(w);
      } catch (y) {
        console.error("Error loading group layers:", y), e?.(l("kartinnhold:errorLoadingLayers"));
      } finally {
        p(!1);
      }
    })();
  }, [s, n, e, a, l]);
  const c = async (h) => {
    if (s)
      try {
        d((y) => {
          const f = [...y], g = f.findIndex((w) => w.id === h);
          if (g >= 0) {
            const w = f[g];
            w.layer ? (s.map && s.map.remove(w.layer), f[g] = {
              ...w,
              layer: void 0
            }) : (d((S) => {
              const b = [...S];
              return b[g] = {
                ...b[g],
                isLoading: !0
              }, b;
            }), Ta.fromPortalItem({
              portalItem: new hn({
                id: w.id
              })
            }).then((S) => {
              if (S.blendMode = "multiply", s.map)
                s.map.add(S);
              else
                throw new Error("Map is not available");
              const b = s.watch("updating", () => {
                const x = s.allLayerViews.find((A) => A.layer === S);
                x && !x.updating && (b.remove(), d((A) => {
                  const _ = [...A];
                  return _[g] = {
                    ..._[g],
                    layer: S,
                    isLoading: !1
                  }, _;
                }));
              });
            }).catch((S) => {
              console.error("Error adding layer:", S), e?.(l("kartinnhold:errorAddingLayer", { title: w.title }));
            }));
          }
          return f;
        });
      } catch (y) {
        console.error("Error managing layer:", y), e?.(l("kartinnhold:errorManagingLayer"));
      }
  };
  return i ? /* @__PURE__ */ o.jsx("div", { className: At.centerContainer, children: /* @__PURE__ */ o.jsx(Xn, { scale: "s", type: "indeterminate" }) }) : u.length === 0 ? /* @__PURE__ */ o.jsx("div", { className: At.messageContainer, children: l("kartinnhold:noLayers") }) : /* @__PURE__ */ o.jsx(Qn, { selectionMode: "none", children: u.map((h) => /* @__PURE__ */ o.jsxs(
    ea,
    {
      "thumbnail-position": "block-start",
      children: [
        /* @__PURE__ */ o.jsx(
          "img",
          {
            slot: "thumbnail",
            className: At.thumbnail,
            src: h.thumbnailUrl,
            alt: h.title
          }
        ),
        /* @__PURE__ */ o.jsx("span", { className: At.cardTitle, slot: "footer-start", children: h.title }),
        /* @__PURE__ */ o.jsx(
          Qr,
          {
            scale: "s",
            slot: "footer-end",
            loading: h.isLoading,
            disabled: h.isLoading,
            icon: h.layer ? "minus-circle" : "add-layer",
            onClick: () => c(h.id)
          }
        )
      ]
    },
    h.id
  )) });
}, Kl = "MapItem-module__item___VfsvS", ql = "MapItem-module__active___wncKR", Jl = "MapItem-module__thumbnail___IweqH", Xl = "MapItem-module__image___IkGzb", Ql = "MapItem-module__text___sh1cd", e0 = "MapItem-module__title___MLNdF", t0 = "MapItem-module__description___XGEsY", Ge = {
  item: Kl,
  active: ql,
  thumbnail: Jl,
  image: Xl,
  text: Ql,
  title: e0,
  description: t0
};
function r0({ title: n, description: e, thumbnailUrl: a, isActive: l, onClick: s }) {
  return /* @__PURE__ */ o.jsxs(
    "button",
    {
      className: `${Ge.item} ${l ? Ge.active : ""}`,
      onClick: s,
      type: "button",
      children: [
        /* @__PURE__ */ o.jsx("div", { className: Ge.thumbnail, children: /* @__PURE__ */ o.jsx("img", { src: a, alt: n, className: Ge.image }) }),
        /* @__PURE__ */ o.jsxs("div", { className: Ge.text, children: [
          /* @__PURE__ */ o.jsx("span", { className: Ge.title, children: n }),
          e && /* @__PURE__ */ o.jsx("span", { className: Ge.description, children: e })
        ] })
      ]
    }
  );
}
const n0 = "ThematicMapSelector-module__centerContainer___MgqzU", a0 = "ThematicMapSelector-module__messageContainer___s34HH", o0 = "ThematicMapSelector-module__gallery___dNrUU", fr = {
  centerContainer: n0,
  messageContainer: a0,
  gallery: o0
}, T1 = ({
  thematicMapsGroupId: n,
  onError: e,
  fallbackThumbnail: a = "public/images/basis terreng.png"
}) => {
  const { t: l } = Ie(["kartinnhold"]), { mapView: s } = Ee(), [u, d] = E([]), [i, p] = E(!0), c = K(null);
  D(() => {
    if (!s || !n)
      return;
    c.current || (c.current = s.map), (async () => {
      try {
        p(!0);
        const w = new pn();
        await w.load();
        const S = new fn({
          portal: w,
          id: n
        }), b = {
          query: "type:'Web Map'",
          sortField: "title",
          sortOrder: "asc",
          num: 100
        }, A = (await S.queryItems(b)).results.map((_) => {
          if (!_.id || !_.title)
            throw new Error("Invalid portal item: missing id or title");
          const $ = _.thumbnailUrl || a;
          return {
            id: _.id,
            title: _.title,
            active: s.map.portalItem?.id === _.id,
            thumbnailUrl: $
          };
        });
        d(A);
      } catch (w) {
        console.error("Error loading thematic maps:", w), e?.("Kunne ikke laste tematiske kart");
      } finally {
        p(!1);
      }
    })();
  }, [s, n, e, a]);
  const h = () => {
    !s || !c.current || (s.map = c.current, d((g) => g.map((w) => ({ ...w, active: !1 }))));
  }, y = async (g) => {
    if (s)
      try {
        const w = new Ia({
          portalItem: new hn({
            id: g
          })
        });
        await w.load(), s.map = w, d(
          (S) => S.map((b) => ({
            ...b,
            active: b.id === g
          }))
        );
      } catch (w) {
        console.error("Error changing web map:", w), e?.("Kunne ikke bytte til valgt temakart");
      }
  };
  if (i)
    return /* @__PURE__ */ o.jsx("div", { className: fr.centerContainer, children: /* @__PURE__ */ o.jsx(ba, {}) });
  if (u.length === 0)
    return /* @__PURE__ */ o.jsx("div", { className: fr.messageContainer, children: l("kartinnhold:noThematicMaps") });
  const f = u.some((g) => g.active);
  return /* @__PURE__ */ o.jsxs("div", { id: "kartinnhold-gallery", className: fr.gallery, children: [
    u.map((g) => /* @__PURE__ */ o.jsx(
      r0,
      {
        title: g.title,
        thumbnailUrl: g.thumbnailUrl,
        isActive: g.active,
        onClick: () => g.active ? h() : y(g.id)
      },
      g.id
    )),
    f && /* @__PURE__ */ o.jsx(an, { variant: "secondary", size: "sm", onClick: h, children: l("kartinnhold:resetThematicMap") })
  ] });
}, l0 = "AddressSearch-module__wrapper___Lt7Og", s0 = "AddressSearch-module__searchInput___SL0JK", i0 = "AddressSearch-module__listbox___SBRWu", c0 = "AddressSearch-module__noResults___3zjaP", u0 = "AddressSearch-module__optionItem___CaFU6", m0 = "AddressSearch-module__active___7g0Sv", d0 = "AddressSearch-module__resultsHeader___yXnWw", p0 = "AddressSearch-module__indexBadge___-gCz0", Ne = {
  wrapper: l0,
  searchInput: s0,
  listbox: i0,
  noResults: c0,
  optionItem: u0,
  active: m0,
  resultsHeader: d0,
  indexBadge: p0
};
function I1({ input: n, suggestions: e, isFetchingDetails: a, onInputChange: l, onSuggestionClick: s, onHoverChange: u, className: d }) {
  const { t: i } = Ie("common"), [p, c] = E(!1), [h, y] = E(-1), f = K(null), g = "address-search-listbox", w = p && n.length > 0 && !a, S = (b) => {
    switch (b.key) {
      case "ArrowDown":
        b.preventDefault(), y((x) => Math.min(x + 1, e.length - 1));
        break;
      case "ArrowUp":
        b.preventDefault(), y((x) => Math.max(x - 1, 0));
        break;
      case "Enter": {
        const x = h >= 0 ? e[h] : e[0];
        x && (s(x), c(!1), y(-1));
        break;
      }
      case "Escape":
        l(""), c(!1), y(-1), f.current?.blur();
        break;
    }
  };
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      className: `${Ne.wrapper}${d ? ` ${d}` : ""}`,
      onBlur: (b) => {
        b.currentTarget.contains(b.relatedTarget) || (c(!1), y(-1));
      },
      children: [
        /* @__PURE__ */ o.jsx(
          va,
          {
            ref: f,
            label: i("addressSearch.label"),
            hideLabel: !0,
            size: "md",
            className: Ne.searchInput,
            prefix: /* @__PURE__ */ o.jsx(Mn, { size: 16 }),
            suffix: n ? /* @__PURE__ */ o.jsx(
              sn,
              {
                icon: /* @__PURE__ */ o.jsx(Vn, { size: 14 }),
                label: i("addressSearch.clearLabel"),
                variant: "ghost",
                size: "sm",
                onMouseDown: (b) => b.preventDefault(),
                onClick: () => {
                  l(""), c(!1), y(-1), f.current?.focus();
                }
              }
            ) : void 0,
            role: "combobox",
            "aria-expanded": w,
            "aria-controls": g,
            "aria-activedescendant": h >= 0 ? `address-search-option-${h}` : void 0,
            "aria-autocomplete": "list",
            value: n,
            placeholder: i("addressSearch.placeholder"),
            disabled: a,
            onChange: (b) => {
              l(b.target.value), c(!0), y(-1);
            },
            onFocus: () => c(!0),
            onKeyDown: S,
            autoComplete: "off"
          }
        ),
        w && /* @__PURE__ */ o.jsxs(
          "ul",
          {
            id: g,
            role: "listbox",
            "aria-label": i("addressSearch.suggestionsLabel"),
            className: Ne.listbox,
            children: [
              e.length === 0 && /* @__PURE__ */ o.jsx("li", { role: "option", "aria-selected": !1, className: Ne.noResults, children: i("addressSearch.noResults") }),
              e.length > 0 && /* @__PURE__ */ o.jsx("li", { className: Ne.resultsHeader, children: i("addressSearch.resultsHeader") }),
              e.map((b, x) => /* @__PURE__ */ o.jsx(
                "li",
                {
                  id: `address-search-option-${x}`,
                  role: "option",
                  "aria-selected": x === h,
                  className: Ne.optionItem,
                  onMouseDown: (A) => A.preventDefault(),
                  children: /* @__PURE__ */ o.jsx(
                    Sa,
                    {
                      title: b.address,
                      prefix: /* @__PURE__ */ o.jsx("span", { className: Ne.indexBadge, children: x + 1 }),
                      action: /* @__PURE__ */ o.jsx(jr, { size: 16, color: "var(--text-primary)" }),
                      className: x === h ? Ne.active : void 0,
                      onClick: () => {
                        s(b), c(!1), y(-1);
                      },
                      onMouseEnter: () => {
                        y(x), u(x);
                      },
                      onMouseLeave: () => u(null)
                    }
                  )
                },
                `${b.text}-${b.x}-${b.y}`
              ))
            ]
          }
        )
      ]
    }
  );
}
const Cr = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  silent: 4
};
function f0(n) {
  return !!n && n in Cr;
}
function h0() {
  if (typeof window < "u")
    try {
      const n = new URLSearchParams(window.location.search).get("debug");
      if (n === "verbose" || n === "debug")
        return "debug";
      if (n === "off" || n === "silent")
        return "silent";
      const e = window.localStorage?.getItem("origoLogLevel");
      if (f0(e))
        return e;
    } catch {
    }
  return "info";
}
let g0 = h0();
function Pt(n) {
  const e = `[${n}]`, a = (l) => Cr[l] >= Cr[g0];
  return {
    debug: (...l) => {
      a("debug") && console.debug(e, ...l);
    },
    info: (...l) => {
      a("info") && console.info(e, ...l);
    },
    warn: (...l) => {
      a("warn") && console.warn(e, ...l);
    },
    error: (...l) => {
      a("error") && console.error(e, ...l);
    }
  };
}
const Ct = Pt("Auth");
let pt = null;
function y0() {
  if (pt !== null)
    return pt;
  const n = window.location.hostname;
  if (n === "localhost" || n === "127.0.0.1") {
    const a = typeof import.meta < "u" && { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 }.VITE_DEV_CUSTOMER, l = a || "mars";
    return a ? Ct.debug(`Development mode: using VITE_DEV_CUSTOMER='${l}'`) : Ct.debug(`Development mode: using default customer '${l}'. Set VITE_DEV_CUSTOMER to override.`), pt = l, l;
  }
  const e = n.split(".");
  if (e.length >= 2) {
    const a = e[1];
    return Ct.debug(`Extracted customer domain from hostname: '${a}'`), pt = a, a;
  }
  return Ct.warn(`Unexpected hostname format: '${n}'. Using hostname as customer domain.`), pt = n, n;
}
const b0 = {
  isSignedIn: !1,
  user: void 0,
  status: "idle",
  error: void 0,
  isAuthRequired: !1
}, hr = Je(
  "auth/checkSignInStatus",
  async ({ authService: n, requireAuth: e }, { rejectWithValue: a }) => {
    try {
      return await n.checkSignInStatus(e);
    } catch (l) {
      return a(l.message);
    }
  }
), gr = Je(
  "auth/requireSignIn",
  async ({ authService: n }, { rejectWithValue: e }) => {
    try {
      return await n.requireSignIn();
    } catch (a) {
      return e(a.message);
    }
  }
), yr = Je(
  "auth/signOut",
  async ({ authService: n }, { rejectWithValue: e }) => {
    try {
      await n.signOut();
    } catch (a) {
      return e(a.message);
    }
  }
), Hn = Ht({
  name: "auth",
  initialState: b0,
  reducers: {
    setIsAuthRequired: (n, e) => {
      n.isAuthRequired = e.payload;
    },
    clearAuth: (n) => {
      n.isSignedIn = !1, n.user = void 0, n.status = "idle", n.error = void 0;
    }
  },
  extraReducers: (n) => {
    n.addCase(hr.pending, (e) => {
      e.status = "loading", e.error = void 0;
    }).addCase(hr.fulfilled, (e, a) => {
      e.status = "succeeded", e.isSignedIn = a.payload.isSignedIn, e.user = a.payload.user;
    }).addCase(hr.rejected, (e, a) => {
      e.status = "failed", e.error = a.payload;
    }).addCase(gr.pending, (e) => {
      e.status = "loading", e.error = void 0;
    }).addCase(gr.fulfilled, (e, a) => {
      e.status = "succeeded", e.isSignedIn = !0, e.user = a.payload;
    }).addCase(gr.rejected, (e, a) => {
      e.status = "failed", e.error = a.payload;
    }).addCase(yr.pending, (e) => {
      e.status = "loading";
    }).addCase(yr.fulfilled, (e) => {
      e.status = "idle", e.isSignedIn = !1, e.user = void 0, e.error = void 0;
    }).addCase(yr.rejected, (e, a) => {
      e.status = "failed", e.error = a.payload;
    });
  }
});
Hn.actions;
const v0 = Hn.reducer, On = Pt("tokenSlice"), S0 = {
  token: void 0,
  expiresAt: void 0,
  isRefreshing: !1,
  lastRefreshError: void 0,
  appName: void 0,
  username: void 0,
  customerName: void 0,
  applicationRoles: []
}, br = Je("token/getToken", async ({ tokenProvider: n }) => {
  try {
    return await n.getTokenMetadata?.();
  } catch (e) {
    On.warn("Failed to get token:", e);
    return;
  }
}), vr = Je(
  "token/refreshToken",
  async ({ tokenProvider: n }) => {
    try {
      return await n.refreshToken(), await n.getTokenMetadata?.();
    } catch (e) {
      On.warn("Failed to refresh token:", e);
      return;
    }
  }
), Pn = Ht({
  name: "token",
  initialState: S0,
  reducers: {
    setToken: (n, e) => {
      n.token = e.payload;
    },
    setTokenMetadata: (n, e) => {
      e.payload.token && (n.token = e.payload.token), e.payload.expiresAt && (n.expiresAt = e.payload.expiresAt), e.payload.username && (n.username = e.payload.username), e.payload.customerName && (n.customerName = e.payload.customerName), e.payload.applicationRoles && (n.applicationRoles = e.payload.applicationRoles);
    },
    setAppName: (n, e) => {
      n.appName = e.payload;
    },
    clearToken: (n) => {
      n.token = void 0, n.expiresAt = void 0, n.lastRefreshError = void 0, n.username = void 0, n.customerName = void 0, n.applicationRoles = [];
    }
  },
  extraReducers: (n) => {
    n.addCase(br.pending, (e) => {
      e.isRefreshing = !0, e.lastRefreshError = void 0;
    }).addCase(br.fulfilled, (e, a) => {
      e.isRefreshing = !1, a.payload && (e.token = a.payload.token, e.expiresAt = a.payload.expiresAt, e.username = a.payload.username, e.customerName = a.payload.customerName, e.applicationRoles = a.payload.applicationRoles || []);
    }).addCase(br.rejected, (e, a) => {
      e.isRefreshing = !1, e.lastRefreshError = a.error?.message;
    }).addCase(vr.pending, (e) => {
      e.isRefreshing = !0, e.lastRefreshError = void 0;
    }).addCase(vr.fulfilled, (e, a) => {
      e.isRefreshing = !1, a.payload && (e.token = a.payload.token, e.expiresAt = a.payload.expiresAt, e.username = a.payload.username, e.customerName = a.payload.customerName, e.applicationRoles = a.payload.applicationRoles || []);
    }).addCase(vr.rejected, (e, a) => {
      e.isRefreshing = !1, e.lastRefreshError = a.error?.message;
    });
  }
});
Pn.actions;
const x0 = Pn.reducer, _0 = (n) => n.auth.token.token, w0 = Pt("settingsSlice"), A0 = {
  settings: void 0,
  isLoading: !1
}, Gr = Je(
  "settings/loadSettings",
  async ({ settingsService: n, config: e, requireAuth: a }) => {
    try {
      return await n.loadSettings(e, a);
    } catch (l) {
      return w0.warn("Failed to load settings, using defaults:", l), e.defaultSettings;
    }
  }
), Dn = Ht({
  name: "settings",
  initialState: A0,
  reducers: {
    setSettings: (n, e) => {
      n.settings = e.payload;
    }
  },
  extraReducers: (n) => {
    n.addCase(Gr.pending, (e) => {
      e.isLoading = !0;
    }).addCase(Gr.fulfilled, (e, a) => {
      e.isLoading = !1, e.settings = a.payload;
    });
  }
});
Dn.actions;
const C0 = Dn.reducer;
var ft = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Br;
function E0() {
  if (Br)
    return ft;
  Br = 1;
  var n = xe, e = Symbol.for("react.element"), a = Symbol.for("react.fragment"), l = Object.prototype.hasOwnProperty, s = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(i, p, c) {
    var h, y = {}, f = null, g = null;
    c !== void 0 && (f = "" + c), p.key !== void 0 && (f = "" + p.key), p.ref !== void 0 && (g = p.ref);
    for (h in p)
      l.call(p, h) && !u.hasOwnProperty(h) && (y[h] = p[h]);
    if (i && i.defaultProps)
      for (h in p = i.defaultProps, p)
        y[h] === void 0 && (y[h] = p[h]);
    return { $$typeof: e, type: i, key: f, ref: g, props: y, _owner: s.current };
  }
  return ft.Fragment = a, ft.jsx = d, ft.jsxs = d, ft;
}
var Et = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ur;
function L0() {
  return Ur || (Ur = 1, process.env.NODE_ENV !== "production" && function() {
    var n = xe, e = Symbol.for("react.element"), a = Symbol.for("react.portal"), l = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), u = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), i = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), w = Symbol.iterator, S = "@@iterator";
    function b(r) {
      if (r === null || typeof r != "object")
        return null;
      var m = w && r[w] || r[S];
      return typeof m == "function" ? m : null;
    }
    var x = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function A(r) {
      {
        for (var m = arguments.length, v = new Array(m > 1 ? m - 1 : 0), C = 1; C < m; C++)
          v[C - 1] = arguments[C];
        _("error", r, v);
      }
    }
    function _(r, m, v) {
      {
        var C = x.ReactDebugCurrentFrame, Z = C.getStackAddendum();
        Z !== "" && (m += "%s", v = v.concat([Z]));
        var V = v.map(function(j) {
          return String(j);
        });
        V.unshift("Warning: " + m), Function.prototype.apply.call(console[r], console, V);
      }
    }
    var $ = !1, G = !1, R = !1, X = !1, N = !1, T;
    T = Symbol.for("react.module.reference");
    function H(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === l || r === u || N || r === s || r === c || r === h || X || r === g || $ || G || R || typeof r == "object" && r !== null && (r.$$typeof === f || r.$$typeof === y || r.$$typeof === d || r.$$typeof === i || r.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === T || r.getModuleId !== void 0));
    }
    function M(r, m, v) {
      var C = r.displayName;
      if (C)
        return C;
      var Z = m.displayName || m.name || "";
      return Z !== "" ? v + "(" + Z + ")" : v;
    }
    function F(r) {
      return r.displayName || "Context";
    }
    function O(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && A("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case l:
          return "Fragment";
        case a:
          return "Portal";
        case u:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case i:
            var m = r;
            return F(m) + ".Consumer";
          case d:
            var v = r;
            return F(v._context) + ".Provider";
          case p:
            return M(r, r.render, "ForwardRef");
          case y:
            var C = r.displayName || null;
            return C !== null ? C : O(r.type) || "Memo";
          case f: {
            var Z = r, V = Z._payload, j = Z._init;
            try {
              return O(j(V));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ee = 0, U, I, ne, ge, ae, Le, Me;
    function $e() {
    }
    $e.__reactDisabledLog = !0;
    function Xe() {
      {
        if (ee === 0) {
          U = console.log, I = console.info, ne = console.warn, ge = console.error, ae = console.group, Le = console.groupCollapsed, Me = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: $e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ee++;
      }
    }
    function Qe() {
      {
        if (ee--, ee === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, r, {
              value: U
            }),
            info: B({}, r, {
              value: I
            }),
            warn: B({}, r, {
              value: ne
            }),
            error: B({}, r, {
              value: ge
            }),
            group: B({}, r, {
              value: ae
            }),
            groupCollapsed: B({}, r, {
              value: Le
            }),
            groupEnd: B({}, r, {
              value: Me
            })
          });
        }
        ee < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var je = x.ReactCurrentDispatcher, ke;
    function _e(r, m, v) {
      {
        if (ke === void 0)
          try {
            throw Error();
          } catch (Z) {
            var C = Z.stack.trim().match(/\n( *(at )?)/);
            ke = C && C[1] || "";
          }
        return `
` + ke + r;
      }
    }
    var Ze = !1, k;
    {
      var W = typeof WeakMap == "function" ? WeakMap : Map;
      k = new W();
    }
    function q(r, m) {
      if (!r || Ze)
        return "";
      {
        var v = k.get(r);
        if (v !== void 0)
          return v;
      }
      var C;
      Ze = !0;
      var Z = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var V;
      V = je.current, je.current = null, Xe();
      try {
        if (m) {
          var j = function() {
            throw Error();
          };
          if (Object.defineProperty(j.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(j, []);
            } catch (Q) {
              C = Q;
            }
            Reflect.construct(r, [], j);
          } else {
            try {
              j.call();
            } catch (Q) {
              C = Q;
            }
            r.call(j.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Q) {
            C = Q;
          }
          r();
        }
      } catch (Q) {
        if (Q && C && typeof Q.stack == "string") {
          for (var L = Q.stack.split(`
`), J = C.stack.split(`
`), P = L.length - 1, z = J.length - 1; P >= 1 && z >= 0 && L[P] !== J[z]; )
            z--;
          for (; P >= 1 && z >= 0; P--, z--)
            if (L[P] !== J[z]) {
              if (P !== 1 || z !== 1)
                do
                  if (P--, z--, z < 0 || L[P] !== J[z]) {
                    var oe = `
` + L[P].replace(" at new ", " at ");
                    return r.displayName && oe.includes("<anonymous>") && (oe = oe.replace("<anonymous>", r.displayName)), typeof r == "function" && k.set(r, oe), oe;
                  }
                while (P >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ze = !1, je.current = V, Qe(), Error.prepareStackTrace = Z;
      }
      var ve = r ? r.displayName || r.name : "", he = ve ? _e(ve) : "";
      return typeof r == "function" && k.set(r, he), he;
    }
    function ce(r, m, v) {
      return q(r, !1);
    }
    function me(r) {
      var m = r.prototype;
      return !!(m && m.isReactComponent);
    }
    function fe(r, m, v) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return q(r, me(r));
      if (typeof r == "string")
        return _e(r);
      switch (r) {
        case c:
          return _e("Suspense");
        case h:
          return _e("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case p:
            return ce(r.render);
          case y:
            return fe(r.type, m, v);
          case f: {
            var C = r, Z = C._payload, V = C._init;
            try {
              return fe(V(Z), m, v);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Re = {}, Y = x.ReactDebugCurrentFrame;
    function ie(r) {
      if (r) {
        var m = r._owner, v = fe(r.type, r._source, m ? m.type : null);
        Y.setExtraStackFrame(v);
      } else
        Y.setExtraStackFrame(null);
    }
    function te(r, m, v, C, Z) {
      {
        var V = Function.call.bind(de);
        for (var j in r)
          if (V(r, j)) {
            var L = void 0;
            try {
              if (typeof r[j] != "function") {
                var J = Error((C || "React class") + ": " + v + " type `" + j + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[j] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw J.name = "Invariant Violation", J;
              }
              L = r[j](m, j, C, v, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (P) {
              L = P;
            }
            L && !(L instanceof Error) && (ie(Z), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", C || "React class", v, j, typeof L), ie(null)), L instanceof Error && !(L.message in Re) && (Re[L.message] = !0, ie(Z), A("Failed %s type: %s", v, L.message), ie(null));
          }
      }
    }
    var Ve = Array.isArray;
    function Ae(r) {
      return Ve(r);
    }
    function Dt(r) {
      {
        var m = typeof Symbol == "function" && Symbol.toStringTag, v = m && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return v;
      }
    }
    function zt(r) {
      try {
        return et(r), !1;
      } catch {
        return !0;
      }
    }
    function et(r) {
      return "" + r;
    }
    function tt(r) {
      if (zt(r))
        return A("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Dt(r)), et(r);
    }
    var we = x.ReactCurrentOwner, Gt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, rt, nt, He;
    He = {};
    function Bt(r) {
      if (de.call(r, "ref")) {
        var m = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function Ut(r) {
      if (de.call(r, "key")) {
        var m = Object.getOwnPropertyDescriptor(r, "key").get;
        if (m && m.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function Wt(r, m) {
      if (typeof r.ref == "string" && we.current && m && we.current.stateNode !== m) {
        var v = O(we.current.type);
        He[v] || (A('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(we.current.type), r.ref), He[v] = !0);
      }
    }
    function Yt(r, m) {
      {
        var v = function() {
          rt || (rt = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        v.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: v,
          configurable: !0
        });
      }
    }
    function Kt(r, m) {
      {
        var v = function() {
          nt || (nt = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", m));
        };
        v.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: v,
          configurable: !0
        });
      }
    }
    var qt = function(r, m, v, C, Z, V, j) {
      var L = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: r,
        key: m,
        ref: v,
        props: j,
        // Record the component responsible for creating this element.
        _owner: V
      };
      return L._store = {}, Object.defineProperty(L._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(L, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.defineProperty(L, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Z
      }), Object.freeze && (Object.freeze(L.props), Object.freeze(L)), L;
    };
    function Jt(r, m, v, C, Z) {
      {
        var V, j = {}, L = null, J = null;
        v !== void 0 && (tt(v), L = "" + v), Ut(m) && (tt(m.key), L = "" + m.key), Bt(m) && (J = m.ref, Wt(m, Z));
        for (V in m)
          de.call(m, V) && !Gt.hasOwnProperty(V) && (j[V] = m[V]);
        if (r && r.defaultProps) {
          var P = r.defaultProps;
          for (V in P)
            j[V] === void 0 && (j[V] = P[V]);
        }
        if (L || J) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          L && Yt(j, z), J && Kt(j, z);
        }
        return qt(r, L, J, Z, C, we.current, j);
      }
    }
    var Oe = x.ReactCurrentOwner, at = x.ReactDebugCurrentFrame;
    function be(r) {
      if (r) {
        var m = r._owner, v = fe(r.type, r._source, m ? m.type : null);
        at.setExtraStackFrame(v);
      } else
        at.setExtraStackFrame(null);
    }
    var Pe;
    Pe = !1;
    function De(r) {
      return typeof r == "object" && r !== null && r.$$typeof === e;
    }
    function ot() {
      {
        if (Oe.current) {
          var r = O(Oe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Xt(r) {
      {
        if (r !== void 0) {
          var m = r.fileName.replace(/^.*[\\\/]/, ""), v = r.lineNumber;
          return `

Check your code at ` + m + ":" + v + ".";
        }
        return "";
      }
    }
    var lt = {};
    function Qt(r) {
      {
        var m = ot();
        if (!m) {
          var v = typeof r == "string" ? r : r.displayName || r.name;
          v && (m = `

Check the top-level render call using <` + v + ">.");
        }
        return m;
      }
    }
    function st(r, m) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var v = Qt(m);
        if (lt[v])
          return;
        lt[v] = !0;
        var C = "";
        r && r._owner && r._owner !== Oe.current && (C = " It was passed a child from " + O(r._owner.type) + "."), be(r), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', v, C), be(null);
      }
    }
    function it(r, m) {
      {
        if (typeof r != "object")
          return;
        if (Ae(r))
          for (var v = 0; v < r.length; v++) {
            var C = r[v];
            De(C) && st(C, m);
          }
        else if (De(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var Z = b(r);
          if (typeof Z == "function" && Z !== r.entries)
            for (var V = Z.call(r), j; !(j = V.next()).done; )
              De(j.value) && st(j.value, m);
        }
      }
    }
    function er(r) {
      {
        var m = r.type;
        if (m == null || typeof m == "string")
          return;
        var v;
        if (typeof m == "function")
          v = m.propTypes;
        else if (typeof m == "object" && (m.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        m.$$typeof === y))
          v = m.propTypes;
        else
          return;
        if (v) {
          var C = O(m);
          te(v, r.props, "prop", C, r);
        } else if (m.PropTypes !== void 0 && !Pe) {
          Pe = !0;
          var Z = O(m);
          A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Z || "Unknown");
        }
        typeof m.getDefaultProps == "function" && !m.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function tr(r) {
      {
        for (var m = Object.keys(r.props), v = 0; v < m.length; v++) {
          var C = m[v];
          if (C !== "children" && C !== "key") {
            be(r), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", C), be(null);
            break;
          }
        }
        r.ref !== null && (be(r), A("Invalid attribute `ref` supplied to `React.Fragment`."), be(null));
      }
    }
    var ct = {};
    function ut(r, m, v, C, Z, V) {
      {
        var j = H(r);
        if (!j) {
          var L = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (L += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var J = Xt(Z);
          J ? L += J : L += ot();
          var P;
          r === null ? P = "null" : Ae(r) ? P = "array" : r !== void 0 && r.$$typeof === e ? (P = "<" + (O(r.type) || "Unknown") + " />", L = " Did you accidentally export a JSX literal instead of a component?") : P = typeof r, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", P, L);
        }
        var z = Jt(r, m, v, Z, V);
        if (z == null)
          return z;
        if (j) {
          var oe = m.children;
          if (oe !== void 0)
            if (C)
              if (Ae(oe)) {
                for (var ve = 0; ve < oe.length; ve++)
                  it(oe[ve], r);
                Object.freeze && Object.freeze(oe);
              } else
                A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              it(oe, r);
        }
        if (de.call(m, "key")) {
          var he = O(r), Q = Object.keys(m).filter(function(sr) {
            return sr !== "key";
          }), ze = Q.length > 0 ? "{key: someKey, " + Q.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ct[he + ze]) {
            var lr = Q.length > 0 ? "{" + Q.join(": ..., ") + ": ...}" : "{}";
            A(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ze, he, lr, he), ct[he + ze] = !0;
          }
        }
        return r === l ? tr(z) : er(z), z;
      }
    }
    function rr(r, m, v) {
      return ut(r, m, v, !0);
    }
    function nr(r, m, v) {
      return ut(r, m, v, !1);
    }
    var ar = nr, or = rr;
    Et.Fragment = l, Et.jsx = ar, Et.jsxs = or;
  }()), Et;
}
process.env.NODE_ENV === "production" ? E0() : L0();
ra({
  auth: v0,
  token: x0,
  settings: C0
});
const Wr = 25833, M0 = /^\d+\s*\/\s*\d+/, j0 = (n) => M0.test(n.trim()), k0 = (n) => [n.gardsnr, n.bruksnr, n.festenr || void 0, n.seksjonsnr || void 0].filter((a) => a !== void 0).join("/"), Z0 = (n) => {
  const e = new URLSearchParams();
  return Object.entries(n).forEach(([a, l]) => {
    l != null && l !== "" && e.set(a, String(l));
  }), e;
}, R0 = {
  async fetchSuggestions(n, e, a, l, s, u) {
    const d = j0(n) ? "eiendom" : "adresse", i = Z0({ query: n, token: e, maxsize: String(l), filter_kilde: d, ...s }), p = `${a}?${i.toString()}`, c = await fetch(p, { signal: u });
    if (!c.ok)
      throw new Error("Failed to fetch suggestions");
    const h = await c.json();
    if (d === "eiendom") {
      const y = s?.filter_kommunenavn?.toLowerCase();
      return (h.hits ?? []).filter((f) => !y || f.kommunenavn?.toLowerCase().includes(y)).map((f) => {
        if (typeof f.x != "number" || typeof f.y != "number" || f.gardsnr === void 0 || f.bruksnr === void 0)
          return null;
        const g = k0(f), w = f.kommunenavn ?? "";
        return {
          text: [g, w].filter(Boolean).join(", "),
          address: g,
          postalCode: "",
          postalArea: w,
          x: f.x,
          y: f.y,
          wkid: Wr,
          gnr: f.gardsnr,
          bnr: f.bruksnr,
          fnr: f.festenr,
          snr: f.seksjonsnr
        };
      }).filter((f) => !!f);
    }
    return (h.hits ?? []).map((y) => {
      if (typeof y.x != "number" || typeof y.y != "number")
        return null;
      const f = y.postnr ?? "", g = y.poststed ?? "", w = y.adresse ?? `${y.gatenavn ?? ""} ${y.husnrbokstav ?? `${y.husnr ?? ""}${y.husbokstav ?? ""}`.trim()}`.trim(), S = [w, `${f} ${g}`.trim()].filter(Boolean).join(", ");
      return S ? { text: S, address: w, postalCode: f, postalArea: g, x: y.x, y: y.y, wkid: Wr, adresseId: y.adresseid } : null;
    }).filter((y) => !!y);
  }
}, Yr = (n) => n.toLowerCase().normalize("NFKD").replace(/[^\p{L}\p{N}]+/gu, " ").trim(), Sr = Pt("useAddressSearch"), T0 = {
  mars: "Fredrikstad",
  venus: "Nesodden"
}, I0 = (n) => {
  if (n)
    return n;
  const e = y0();
  return T0[e] ?? e;
}, V0 = "https://services.geodataonline.no/arcgis/rest/services/ProxyServices/search/adresse", V1 = ({ searchApiUrl: n = V0, minChars: e = 2, maxResults: a = 4, kommunenavn: l, onValidateLocation: s, matrikkelClient: u }) => {
  const [d, i] = E(""), [p, c] = E([]), [h, y] = E(!1), [f, g] = E(null), [w, S] = E(!1), [b, x] = E(!1), A = K(null), _ = Er(_0), $ = le(
    async (N) => {
      try {
        const T = new Zt({ x: N.x, y: N.y, spatialReference: { wkid: N.wkid } });
        let H;
        if (u) {
          const M = u;
          if (M.getMatrikkelEnhetFromGeometry) {
            const F = await M.getMatrikkelEnhetFromGeometry(T);
            H = (Array.isArray(F) ? F : [])[0];
          }
        }
        return {
          ...N,
          matrikkelEnhet: H ? { ...H, kommunenr: String(H.kommunenr) } : void 0
        };
      } catch (T) {
        return Sr.error("Matrikkel lookup failed", T), null;
      }
    },
    [u]
  ), G = le(
    (N) => {
      const T = N.trim(), H = !!_ && T.length >= e;
      i(N), g(null), c([]), y(!1), S(H), A.current && clearTimeout(A.current), A.current = setTimeout(async () => {
        if (!H || !_) {
          c([]), y(!1), S(!1);
          return;
        }
        try {
          const M = await R0.fetchSuggestions(N, _, n, a, { filter_kommunenavn: I0(l) }), F = Yr(N).split(/\s+/).filter(Boolean), O = M.filter((B) => {
            const ee = Yr(B.text ?? "");
            return F.every((U) => ee.includes(U));
          });
          c(O);
        } catch (M) {
          M.name !== "AbortError" && (Sr.error("Suggestions error", M), c([]));
        } finally {
          S(!1), y(!0);
        }
      }, 500);
    },
    [_, n, e, a, l]
  ), R = le(
    async (N) => {
      try {
        const T = {
          selected: !0,
          id: N.adresseId != null ? String(N.adresseId) : void 0,
          name: N.text,
          address: N.address,
          postalCode: N.postalCode,
          postalArea: N.postalArea,
          x: N.x,
          y: N.y,
          wkid: N.wkid
        }, H = await $(T);
        return !H || s && !await s(H) ? null : H;
      } catch (T) {
        return T.name !== "AbortError" && Sr.error("Error fetching address details:", T), null;
      }
    },
    [$, s]
  ), X = le((N) => {
    i(N.address ?? ""), g(N), c([]), y(!1);
  }, []);
  return {
    input: d,
    setInput: i,
    suggestions: p,
    hasFetchedSuggestions: h,
    selectedSuggestion: f,
    isLoading: w,
    isFetchingDetails: b,
    setIsFetchingDetails: x,
    handleInputChange: G,
    handleSuggestionClick: X,
    fetchAddressDetailsFromSuggestion: R
  };
}, N0 = "VersionInfo-module__headerButton___9pT0V", F0 = "VersionInfo-module__footerLink___2Y7St", $0 = "VersionInfo-module__notice___je-0O", H0 = "VersionInfo-module__noticeButton___ZGSac", O0 = "VersionInfo-module__dialogMeta___akGsY", P0 = "VersionInfo-module__versionLine___BG1s6", D0 = "VersionInfo-module__commit___t0UtV", z0 = "VersionInfo-module__buildDate___MKUGB", G0 = "VersionInfo-module__changelogTitle___bnj-w", B0 = "VersionInfo-module__entries___6gHwp", U0 = "VersionInfo-module__entry___VEyTs", W0 = "VersionInfo-module__entryHeader___HTZHe", Y0 = "VersionInfo-module__entryVersion___7YAYZ", K0 = "VersionInfo-module__entryDate___NSX41", q0 = "VersionInfo-module__section___-zx9O", J0 = "VersionInfo-module__sectionHeading___NcjpI", X0 = "VersionInfo-module__itemList___W9JnR", pe = {
  headerButton: N0,
  footerLink: F0,
  notice: $0,
  noticeButton: H0,
  dialogMeta: O0,
  versionLine: P0,
  commit: D0,
  buildDate: z0,
  changelogTitle: G0,
  entries: B0,
  entry: U0,
  entryHeader: W0,
  entryVersion: Y0,
  entryDate: K0,
  section: q0,
  sectionHeading: J0,
  itemList: X0
};
function N1({ placement: n = "footer", appName: e, onClick: a }) {
  return n === "header" ? /* @__PURE__ */ o.jsxs(
    "button",
    {
      type: "button",
      className: pe.headerButton,
      onClick: a,
      "aria-label": "Vis versjonsinformasjon og endringslogg",
      children: [
        /* @__PURE__ */ o.jsx(Ot, { size: 14, weight: "regular", "aria-hidden": "true" }),
        /* @__PURE__ */ o.jsxs("span", { children: [
          "v",
          __APP_VERSION__
        ] })
      ]
    }
  ) : /* @__PURE__ */ o.jsx(
    "button",
    {
      type: "button",
      className: pe.footerLink,
      onClick: a,
      "aria-label": `Vis versjonsinformasjon og endringslogg${e ? ` for ${e}` : ""}`,
      children: e ? `${e} v${__APP_VERSION__}` : `v${__APP_VERSION__}`
    }
  );
}
const Q0 = /^##\s*\[?([^\]\s]+)\]?\s*[–-]\s*(.+?)\s*$/, es = /^###\s+(.+?)\s*$/, ts = /^[-*]\s+(.+?)\s*$/;
function rs(n) {
  const e = [];
  let a = null, l = null;
  for (const s of n.split(/\r?\n/)) {
    const u = s.trim(), d = u.match(Q0);
    if (d) {
      a = { version: d[1], date: d[2], sections: [] }, e.push(a), l = null;
      continue;
    }
    if (!a)
      continue;
    const i = u.match(es);
    if (i) {
      l = { heading: i[1], items: [] }, a.sections.push(l);
      continue;
    }
    const p = u.match(ts);
    p && l && l.items.push(p[1]);
  }
  return e;
}
function ns(n) {
  return n.split(/\*\*(.+?)\*\*/).map((a, l) => l % 2 === 1 ? /* @__PURE__ */ o.jsx("strong", { children: a }, l) : a);
}
function as(n) {
  const e = new Date(n);
  return Number.isNaN(e.getTime()) ? n : e.toLocaleDateString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric" });
}
function F1({ open: n, onClose: e, appName: a, changelogMarkdown: l }) {
  const s = rs(l);
  return /* @__PURE__ */ o.jsxs(xa, { open: n, onClose: e, title: `Om ${a}`, children: [
    /* @__PURE__ */ o.jsxs("div", { className: pe.dialogMeta, children: [
      /* @__PURE__ */ o.jsxs("div", { className: pe.versionLine, children: [
        /* @__PURE__ */ o.jsxs("strong", { children: [
          "Versjon ",
          __APP_VERSION__
        ] }),
        /* @__PURE__ */ o.jsxs("span", { className: pe.commit, children: [
          "(",
          __APP_COMMIT__,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ o.jsxs("div", { className: pe.buildDate, children: [
        "Bygget ",
        as(__APP_BUILD_DATE__)
      ] })
    ] }),
    /* @__PURE__ */ o.jsx("h3", { className: pe.changelogTitle, children: "Endringslogg" }),
    s.length === 0 ? /* @__PURE__ */ o.jsx("p", { children: "Ingen endringer registrert ennå." }) : /* @__PURE__ */ o.jsx("ol", { className: pe.entries, children: s.map((u) => /* @__PURE__ */ o.jsxs("li", { className: pe.entry, children: [
      /* @__PURE__ */ o.jsxs("header", { className: pe.entryHeader, children: [
        /* @__PURE__ */ o.jsx("span", { className: pe.entryVersion, children: u.version }),
        /* @__PURE__ */ o.jsx("span", { className: pe.entryDate, children: u.date })
      ] }),
      u.sections.map((d) => /* @__PURE__ */ o.jsxs("div", { className: pe.section, children: [
        /* @__PURE__ */ o.jsx("h4", { className: pe.sectionHeading, children: d.heading }),
        /* @__PURE__ */ o.jsx("ul", { className: pe.itemList, children: d.items.map((i, p) => /* @__PURE__ */ o.jsx("li", { children: ns(i) }, p)) })
      ] }, d.heading))
    ] }, u.version)) })
  ] });
}
function $1({ onOpenChangelog: n, onDismiss: e }) {
  return /* @__PURE__ */ o.jsxs(cn, { variant: "info", className: pe.notice, onDismiss: e, children: [
    "Ny versjon (",
    __APP_VERSION__,
    ") er rullet ut.",
    " ",
    /* @__PURE__ */ o.jsx("button", { type: "button", className: pe.noticeButton, onClick: n, children: "Se hva som er nytt" })
  ] });
}
function H1(n) {
  const [e, a] = E(!1);
  return D(() => {
    try {
      const s = window.localStorage.getItem(n);
      s && s !== __APP_VERSION__ ? a(!0) : s || window.localStorage.setItem(n, __APP_VERSION__);
    } catch {
    }
  }, [n]), { hasNewVersion: e, dismiss: () => {
    try {
      window.localStorage.setItem(n, __APP_VERSION__);
    } catch {
    }
    a(!1);
  } };
}
const os = "SearchSuggestionLayer-module__popup___ltkFS", ls = "SearchSuggestionLayer-module__popupArrow___LHemA", ss = "SearchSuggestionLayer-module__popupArrowFlipped___RvYFW", Lt = {
  popup: os,
  popupArrow: ls,
  popupArrowFlipped: ss
}, ht = 8, Kr = 10, xr = 28, is = ({ anchorX: n, anchorY: e, container: a, children: l }) => {
  const s = K(null), [u, d] = E(null);
  return Xr(() => {
    if (!s.current)
      return;
    const i = s.current.offsetWidth, p = s.current.offsetHeight, c = a.offsetWidth, h = a.offsetHeight, y = n - i / 2, f = Math.max(ht, Math.min(y, c - i - ht)), g = e - p - xr < ht, w = g ? Math.min(e + xr, h - p - ht) : Math.max(ht, e - p - xr), S = Math.max(Kr, Math.min(n - f, i - Kr));
    d({ left: f, top: w, arrowLeft: S, flipped: g });
  }, [n, e, a]), /* @__PURE__ */ o.jsxs(
    "div",
    {
      ref: s,
      className: Lt.popup,
      style: u ? { left: u.left, top: u.top } : { visibility: "hidden", left: n, top: e },
      children: [
        l,
        /* @__PURE__ */ o.jsx(
          "span",
          {
            className: u?.flipped ? `${Lt.popupArrow} ${Lt.popupArrowFlipped}` : Lt.popupArrow,
            style: { left: u ? u.arrowLeft : void 0 }
          }
        )
      ]
    }
  );
}, Mt = 200;
function cs(n, e) {
  const a = n.map((s) => s.x), l = n.map((s) => s.y);
  return new Va({
    xmin: Math.min(...a) - Mt,
    ymin: Math.min(...l) - Mt,
    xmax: Math.max(...a) + Mt,
    ymax: Math.max(...l) + Mt,
    spatialReference: { wkid: e }
  });
}
function us(n) {
  const e = String(n + 1), a = 24, l = 3, s = a * l, u = `<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}" viewBox="0 0 ${s} ${s}">
        <circle cx="${s / 2}" cy="${s / 2}" r="${s / 2 - l}" fill="#0037F8" stroke="white" stroke-width="${2 * l}"/>
        <text x="${s / 2}" y="${s / 2}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${12 * l}" font-family="sans-serif" font-weight="bold">${e}</text>
    </svg>`;
  return {
    type: "picture-marker",
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(u)}`,
    width: a,
    height: a
  };
}
function qr(n) {
  const e = String(n + 1), a = 32, l = 3, s = a * l, u = s / 2, d = s / 2 - l, i = d - 4 * l, p = `<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}" viewBox="0 0 ${s} ${s}">
        <defs>
            <filter id="shadow" x="-30%" y="-30%" width="160%" height="160%">
                <feDropShadow dx="0" dy="${l}" stdDeviation="${2 * l}" flood-color="rgba(0,0,0,0.35)"/>
            </filter>
        </defs>
        <circle cx="${u}" cy="${u}" r="${d}" fill="white" filter="url(#shadow)"/>
        <circle cx="${u}" cy="${u}" r="${i}" fill="#0037F8"/>
        <text x="${u}" y="${u}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${12 * l}" font-family="sans-serif" font-weight="bold">${e}</text>
    </svg>`;
  return {
    type: "picture-marker",
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(p)}`,
    width: a,
    height: a
  };
}
function ms(n) {
  const e = String(n + 1), a = 24, l = 3, s = a * l, u = `<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}" viewBox="0 0 ${s} ${s}">
        <circle cx="${s / 2}" cy="${s / 2}" r="${s / 2 - l}" fill="#B0B7C3" stroke="white" stroke-width="${2 * l}"/>
        <text x="${s / 2}" y="${s / 2}" text-anchor="middle" dominant-baseline="central" fill="white" font-size="${12 * l}" font-family="sans-serif" font-weight="bold">${e}</text>
    </svg>`;
  return {
    type: "picture-marker",
    url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(u)}`,
    width: a,
    height: a
  };
}
function O1({
  suggestions: n,
  hoveredIndex: e,
  paddingLeft: a = 0,
  onPinHit: l,
  onPinClick: s,
  onPopupDismiss: u,
  onMapClick: d,
  renderPopupContent: i
}) {
  const { graphicsLayer: p, mapView: c } = Ee(), [h, y] = E(null), f = xe.useRef(h);
  D(() => {
    f.current = h;
  }, [h]);
  const [g, w] = E(null), S = xe.useRef([]), b = xe.useCallback(() => {
    !p || S.current.length === 0 || (S.current.forEach((N) => p.remove(N)), S.current = []);
  }, [p]);
  D(() => {
    y(null), w(null);
  }, [n]), D(() => {
    if (c)
      return c.padding = { left: a }, () => {
        c.padding = { left: 0 };
      };
  }, [c, a]), D(() => {
    if (p && (b(), n.length !== 0))
      return n.forEach((N, T) => {
        let H;
        h !== null ? H = T === h ? qr(T) : ms(T) : T === e ? H = qr(T) : H = us(T);
        const M = new Na({
          geometry: new _t({ x: N.x, y: N.y, spatialReference: { wkid: N.wkid } }),
          symbol: H,
          attributes: { pinIndex: T }
        });
        p.add(M), S.current.push(M);
      }), () => {
        b();
      };
  }, [n, e, h, p, b]), D(() => {
    if (n.length === 0 || !c)
      return;
    const N = n.map(
      (T) => new _t({ x: T.x, y: T.y, spatialReference: { wkid: T.wkid } })
    );
    c.goTo(cs(N, n[0].wkid));
  }, [n, c]);
  const x = xe.useRef(l), A = xe.useRef(s), _ = xe.useRef(u), $ = xe.useRef(d), G = xe.useRef(i);
  D(() => {
    x.current = l;
  }, [l]), D(() => {
    A.current = s;
  }, [s]), D(() => {
    _.current = u;
  }, [u]), D(() => {
    $.current = d;
  }, [d]), D(() => {
    G.current = i;
  }, [i]), D(() => {
    if (!c || !p)
      return;
    const N = c.on("click", async (T) => {
      const M = (await c.hitTest(T, { include: [p] })).results.find((F) => F.type === "graphic");
      if (M && S.current.includes(M.graphic)) {
        const F = M.graphic.attributes?.pinIndex, O = n[F];
        if (O != null)
          if (x.current?.(), G.current) {
            y(F);
            const B = c.toScreen(
              new _t({ x: O.x, y: O.y, spatialReference: { wkid: O.wkid } })
            );
            B && w({ x: B.x, y: B.y });
          } else
            A.current?.(O);
      } else if (f.current !== null && n[f.current]) {
        const F = n[f.current];
        y(null), w(null), _.current?.(F);
      } else
        y(null), w(null), $.current?.();
    });
    return () => N.remove();
  }, [c, p, n]), D(() => {
    if (!c || h === null)
      return;
    const N = c.watch("extent", () => {
      const T = n[h];
      if (!T)
        return;
      const H = c.toScreen(
        new _t({ x: T.x, y: T.y, spatialReference: { wkid: T.wkid } })
      );
      H && w({ x: H.x, y: H.y });
    });
    return () => N.remove();
  }, [c, h, n]);
  const R = c?.container instanceof HTMLElement ? c.container : null, X = h !== null ? n[h] : null;
  return !i || !R || !X || !g ? null : gn(
    /* @__PURE__ */ o.jsx(is, { anchorX: g.x, anchorY: g.y, container: R, children: i(X) }),
    R
  );
}
const ds = "Toaster-module__container___azaFy", ps = "Toaster-module__slide-in___zkFuc", fs = {
  container: ds,
  slideIn: ps
};
function P1({
  message: n,
  open: e,
  onClose: a,
  variant: l = "info",
  icon: s,
  autoCloseDuration: u = 4e3
}) {
  return e ? gn(
    /* @__PURE__ */ o.jsx("div", { className: fs.container, children: /* @__PURE__ */ o.jsx(
      un,
      {
        variant: l,
        icon: s,
        open: e,
        onClose: a,
        autoCloseDuration: u,
        children: n
      }
    ) }),
    document.body
  ) : null;
}
const zn = Jr(null), hs = "ToastProvider-module__container___89FP-", gs = {
  container: hs
}, ys = {
  success: /* @__PURE__ */ o.jsx(xn, { size: 20 }),
  danger: /* @__PURE__ */ o.jsx(In, { size: 20 }),
  warning: /* @__PURE__ */ o.jsx(Tn, { size: 20 }),
  info: /* @__PURE__ */ o.jsx(Ot, { size: 20 })
};
function D1({ children: n }) {
  const [e, a] = E([]), l = le((u) => {
    a((d) => d.filter((i) => i.id !== u));
  }, []), s = le((u) => {
    const d = crypto.randomUUID();
    a((i) => [...i, { ...u, id: d }]);
  }, []);
  return /* @__PURE__ */ o.jsxs(zn.Provider, { value: { add: s, remove: l }, children: [
    n,
    /* @__PURE__ */ o.jsx("div", { className: gs.container, "aria-live": "polite", children: e.map((u) => /* @__PURE__ */ o.jsx(
      un,
      {
        open: !0,
        variant: u.variant,
        icon: ys[u.variant],
        onClose: () => l(u.id),
        autoCloseDuration: u.duration,
        children: u.message
      },
      u.id
    )) })
  ] });
}
const bs = 5e3;
function z1() {
  const n = Un(zn);
  if (!n)
    throw new Error("useToast must be used inside <ToastProvider>");
  const e = (l, s, u = bs) => {
    n.add({ message: l, variant: s, duration: u });
  };
  return {
    success: (l, s) => e(l, "success", s),
    error: (l, s) => e(l, "danger", s),
    warning: (l, s) => e(l, "warning", s),
    info: (l, s) => e(l, "info", s),
    execute: async (l, s) => {
      try {
        const u = await l();
        return e(s.success, "success"), u;
      } catch (u) {
        const d = s.error ?? (u instanceof Error ? u.message : "Noe gikk galt");
        e(d, "danger");
      }
    }
  };
}
const vs = {
  title: "Applikasjon",
  description: "Kart og datavisning",
  showInfoLabel: "Vis informasjon",
  showInfoTooltip: "Klikk for å vise hjelpeinformasjon",
  themeToggleLabel: "Bytt tema",
  languageToggleLabel: "Bytt språk",
  arcgisOnlineLabel: "ArcGIS Online",
  signoutLabel: "Logg ut",
  userDropdownTooltip: "Brukerinnstillinger",
  toggleMenuLabel: "Åpne/lukk meny"
}, Ss = {
  close: "Lukk",
  expand: "Utvid",
  collapse: "Slå sammen"
}, xs = {
  header: vs,
  panel: Ss
}, _s = {
  title: "Application",
  description: "Map and data visualization",
  showInfoLabel: "Show information",
  showInfoTooltip: "Click to show help information",
  themeToggleLabel: "Toggle theme",
  languageToggleLabel: "Change language",
  arcgisOnlineLabel: "ArcGIS Online",
  signoutLabel: "Sign out",
  userDropdownTooltip: "User settings",
  toggleMenuLabel: "Toggle menu"
}, ws = {
  close: "Close",
  expand: "Expand",
  collapse: "Collapse"
}, As = {
  header: _s,
  panel: ws
}, Cs = "Legg til kartlag", Es = "Legg til kartlag", Ls = "Temakart", Ms = "Bakgrunnskart", js = "Ingen kartlag tilgjengelig", ks = "Ingen temakart tilgjengelig", Zs = "Tilbakestill temakart", Rs = "Feil", Ts = "Kunne ikke laste kartlag fra ArcGIS Online", Is = "Kunne ikke legge til kartlag: {{title}}", Vs = "Kunne ikke håndtere kartlaget", Ns = {
  loadingLayer: "Kunne ikke laste kartlag",
  loadingThematicMap: "Kunne ikke laste temakart"
}, Fs = {
  layers: "Vis kartlag",
  mapType: "Velg karttype",
  basemap: "Velg bakgrunnskart"
}, $s = {
  title: Cs,
  layers: Es,
  thematicMaps: Ls,
  basemaps: Ms,
  noLayers: js,
  noThematicMaps: ks,
  resetThematicMap: Zs,
  error: Rs,
  errorLoadingLayers: Ts,
  errorAddingLayer: Is,
  errorManagingLayer: Vs,
  errors: Ns,
  tabs: Fs
}, Hs = "Ja", Os = "Nei", Ps = "Skjul", Ds = "Vis", zs = "Fra", Gs = "Til", Bs = {
  ok: "OK",
  cancel: "Avbryt",
  previous: "Forrige",
  next: "Neste"
}, Us = {
  placeholder: "Søk etter sted eller klikk i kartet..."
}, Ws = {
  placeholder: "Søk etter butikk..."
}, Ys = {
  placeholder: "Velg analyseområde...",
  placeholderPlural: "Velg analyseområder...",
  mapExtent: "Kartutsnitt",
  contextDelete: "Slett analyseområdet",
  contextNew: "Lag nytt analyseområde",
  contextEdit: "Rediger analyseområdet"
}, Ks = {
  placeholder: "Søk..."
}, qs = {
  label: "Søk etter adresse eller gårds-/bruksnummer",
  placeholder: "Søk etter adresse eller gnr/bnr…",
  clearLabel: "Tøm søk",
  suggestionsLabel: "Adresseforslag",
  noResults: "Ingen treff",
  resultsHeader: "Resultater"
}, Js = {
  yes: Hs,
  no: Os,
  hide: Ps,
  show: Ds,
  from: zs,
  to: Gs,
  buttons: Bs,
  locationhistoryselect: Us,
  storelocationselect: Ws,
  analysisareaselect: Ys,
  search: Ks,
  addressSearch: qs
}, Xs = {
  shape: "Form",
  color: "Farge",
  size: "Størrelse",
  rotation: "Rotasjon",
  outlineWidth: "Omriss bredde",
  outlineColor: "Omriss farge",
  preview: "Forhåndsvisning",
  pixels: "piksler"
}, Qs = {
  clickToSelectColor: "Klikk for å velge farge",
  openColorPicker: "Åpne fargevelger"
}, ei = {
  title: "Mål på tegningen",
  showMeasurement: "Vis mål"
}, ti = {
  title: "Tegneverktøy",
  select: "Velg",
  point: "Punkt",
  polyline: "Linje",
  polygon: "Polygon",
  rectangle: "Rektangel",
  circle: "Sirkel",
  clear: "Slett alt"
}, ri = {
  symbolSettings: Xs,
  colorControl: Qs,
  measurement: ei,
  sketchToolbar: ti
}, ni = "Layers", ai = "Layers", oi = "Thematic Maps", li = "Basemaps", si = "No layers available", ii = "No thematic maps available", ci = "Reset thematic map", ui = "Error", mi = "Could not load layers from ArcGIS Online", di = "Could not add layer: {{title}}", pi = "Could not manage layer", fi = {
  loadingLayer: "Could not load layer",
  loadingThematicMap: "Could not load thematic map"
}, hi = {
  layers: "Show layers",
  mapType: "Select map type",
  basemap: "Select basemap"
}, gi = {
  title: ni,
  layers: ai,
  thematicMaps: oi,
  basemaps: li,
  noLayers: si,
  noThematicMaps: ii,
  resetThematicMap: ci,
  error: ui,
  errorLoadingLayers: mi,
  errorAddingLayer: di,
  errorManagingLayer: pi,
  errors: fi,
  tabs: hi
}, yi = "Yes", bi = "No", vi = "Hide", Si = "Show", xi = "From", _i = "To", wi = {
  ok: "OK",
  cancel: "Cancel",
  previous: "Previous",
  next: "Next"
}, Ai = {
  placeholder: "Search or click in the map..."
}, Ci = {
  placeholder: "Select analysis area...",
  placeholderPlural: "Select analysis areas...",
  mapExtent: "Map extent",
  contextDelete: "Delete analysis area",
  contextNew: "Create new analysis area",
  contextEdit: "Edit analysis area"
}, Ei = {
  placeholder: "Search..."
}, Li = {
  label: "Search for address or cadastral number",
  placeholder: "Search for address or gnr/bnr…",
  clearLabel: "Clear search",
  suggestionsLabel: "Address suggestions",
  noResults: "No results",
  resultsHeader: "Results"
}, Mi = {
  yes: yi,
  no: bi,
  hide: vi,
  show: Si,
  from: xi,
  to: _i,
  buttons: wi,
  locationhistoryselect: Ai,
  analysisareaselect: Ci,
  search: Ei,
  addressSearch: Li
}, ji = {
  shape: "Shape",
  color: "Color",
  size: "Size",
  rotation: "Rotation",
  outlineWidth: "Outline width",
  outlineColor: "Outline color",
  preview: "Preview",
  pixels: "pixels"
}, ki = {
  clickToSelectColor: "Click to select color",
  openColorPicker: "Open color picker"
}, Zi = {
  title: "Measurement",
  showMeasurement: "Show measurement"
}, Ri = {
  title: "Sketch Tools",
  select: "Select",
  point: "Point",
  polyline: "Polyline",
  polygon: "Polygon",
  rectangle: "Rectangle",
  circle: "Circle",
  clear: "Clear"
}, Ti = {
  symbolSettings: ji,
  colorControl: ki,
  measurement: Zi,
  sketchToolbar: Ri
}, G1 = {
  nb: {
    uiComponents: xs,
    common: Js,
    drawing: ri,
    kartinnhold: $s
  },
  en: {
    uiComponents: As,
    common: Mi,
    drawing: Ti,
    kartinnhold: gi
  }
};
export {
  I1 as AddressSearch,
  F1 as ChangelogDialog,
  k1 as Drawing,
  Z1 as DrawingCustom,
  E1 as EsriBasemapGallery,
  A1 as EsriLayerList,
  M1 as EsriLegend,
  L1 as EsriPrint,
  j1 as FlowWrapper,
  v1 as Header,
  C1 as LayerListCustom,
  R1 as LayerSelector,
  S1 as LeftPanel,
  r0 as MapItem,
  $1 as NewVersionNotice,
  _1 as OrigoLeftPanel,
  bn as OrigoPanel,
  w1 as OrigoRightPanel,
  Ha as PanelToolbar,
  x1 as RightPanel,
  O1 as SearchSuggestionLayer,
  T1 as ThematicMapSelector,
  D1 as ToastProvider,
  P1 as Toaster,
  N1 as VersionTrigger,
  R0 as addressService,
  h1 as panelReducer,
  rs as parseChangelog,
  p1 as setActiveLeftPanel,
  f1 as setActiveRightPanel,
  G1 as uiTranslations,
  g1 as useActiveLeftPanel,
  y1 as useActiveRightPanel,
  V1 as useAddressSearch,
  H1 as useNewVersionNotice,
  b1 as usePanelDispatch,
  z1 as useToast
};
//# sourceMappingURL=index.mjs.map
